import {
  Component,
  OnInit,
  ViewChild,
  QueryList,
  ViewChildren,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { formatNumber } from '@angular/common';
import { DateService } from '../services/date.service';
import { GeneralService } from '../services/general.service';
import { ActionsService } from '../services/actions.service';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { NgForm } from '@angular/forms';
import { CalmoisComponent } from '../calmois/calmois.component';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { Subscription } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AvtDialogDeleteComponent } from '../avt-dialog-delete/avt-dialog-delete.component';
import { AvtListeDocumentComponent } from '../avt-liste-document/avt-liste-document.component';
import { AvtListeMachineComponent } from '../avt-liste-machine/avt-liste-machine.component';
import { CalendarComponent } from '../calendar/calendar.component';
import { RechercheComponent } from '../recherche/recherche.component';
import * as globalUrls from '../services/globalVariables';
declare var $: any;
@Component({
  selector: 'app-avt-action',
  templateUrl: './avt-action.component.html',
  styleUrls: ['./avt-action.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' })
      ),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class AvtActionComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public overlayCalmois: Overlay,
    public viewContainerRefCalmoi: ViewContainerRef,
    public overlayAction: Overlay,
    public viewContainerRefAction: ViewContainerRef,
    public actionsService: ActionsService,
    public generalService: GeneralService,
    public dateService: DateService,
    public route: ActivatedRoute,
    public router: Router
  ) {}
  ecrant: string;
  titre = '';
  colorDay = this.generalService.colorDay;
  cssJourFerier = {
    'background-color': this.colorDay.backgroundJourFerier,
    height: '90%',
    width: '90%',
  };
  cssBackgroundWeek = {};
  cssTextColorWeek = {
    color: this.colorDay.textColorWeek,
    height: '90%',
    width: '90%',
  };
  cssBackgroundDefault = {
    'background-color': this.colorDay.backgroundDefault,
    height: '90%',
    width: '90%',
  };
  cssTextdDefault = { color: this.colorDay.textColorDefault };
  cssBackgroundOcupe = {
    'background-color': this.colorDay.backgroundOcupe,
    height: '90%',
    width: '90%',
  };
  cssBackgroundOcupeAM = {
    background:
      'linear-gradient(to top left, #fff 0%, #fff 50%, ' +
      this.colorDay.backgroundOcupe +
      ' 50%, ' +
      this.colorDay.backgroundOcupe +
      ' 100%)',
    height: '90%',
    width: '90%',
  };
  cssBackgroundOcupePM = {
    background:
      'linear-gradient(to bottom right, #fff 0%, #fff 50%, ' +
      this.colorDay.backgroundOcupe +
      ' 50%,' +
      this.colorDay.backgroundOcupe +
      ' 100%)',
    height: '90%',
    width: '90%',
  };
  cssBackgroundOcupeForNotSelectedTypePresenceD = {
    'background-color': this.colorDay.backgroundOcupeForNotSelectedTypePresentD,
    height: '90%',
    width: '90%',
  };
  cssBackgroundOcupeAMForNotSelectedTypePresenceD = {
    background:
      'linear-gradient(to top left, #fff 0%, #fff 50%, ' +
      this.colorDay.backgroundOcupeForNotSelectedTypePresentD +
      ' 50%, ' +
      this.colorDay.backgroundOcupeForNotSelectedTypePresentD +
      ' 100%)',
    height: '90%',
    width: '90%',
  };
  cssBackgroundOcupePMForNotSelectedTypePresenceD = {
    background:
      'linear-gradient(to bottom right, #fff 0%, #fff 50%, ' +
      this.colorDay.backgroundOcupeForNotSelectedTypePresentD +
      ' 50%,' +
      this.colorDay.backgroundOcupeForNotSelectedTypePresentD +
      ' 100%)',
    height: '90%',
    width: '90%',
  };

  cssTextColorOcupe = { color: this.colorDay.textColorOcupe };
  cssbackgroundHorsDateAction = {
    'background-color': this.colorDay.backgroundHorsDateAction,
    height: '90%',
    width: '90%',
  };
  cssbackgroundDateAction = {
    'background-color': this.colorDay.backgroundDateAction,
    height: '90%',
    width: '90%',
  };
  cssTextColorDateAction = { color: this.colorDay.textColorDateAction };
  exist: boolean = true;
  index: number = 0;
  disabled: boolean = false;
  oldIndex: number = 0;
  param_code: string;
  typeTrs: string;
  listeTypeAction = [];
  listeCursus = [];
  paramHeure;
  paramHeureCalendar;
  listeMatiereCursus = [];
  listeAllMatiere;
  listeAllMatiereIsLoadet: boolean = false;
  showCalendarAction: boolean = false;
  showCalendarActionModification: boolean = false;
  showPanelTitleAction: boolean = false;
  showPanelTitleSalleAtelierRessourceHumaine: boolean = false;
  ressourcesHumainesChecked: boolean = true;
  salleAtelierChecked: boolean = true;
  @ViewChild('menuContectuelleCalmois', { static: true })
  menuContectuelleCalmois: TemplateRef<any>;
  @ViewChild('menuContectuelleAction', { static: true })
  menuContectuelleAction: TemplateRef<any>;
  overlayRefAction: OverlayRef | null;
  subAction: Subscription;
  compteur: number = 0;
  overlayRefCalmois: OverlayRef | null;
  subCalmois: Subscription;
  @ViewChild('informationAction', { static: false }) informationAction: NgForm;
  @ViewChild('intervaleHeureTypePresence', { static: false })
  intervaleHeureTypePresence: NgForm;
  @ViewChild('informationActionD', { static: false })
  informationActionD: NgForm;
  @ViewChild('formDevis', { static: false }) formDevis: NgForm;
  @ViewChild('fconfirmDuplicationEnConflie', { static: false })
  fconfirmDuplicationEnConflie;
  listeRessourcesHumaines = [];
  selectedRessourceHumainesFilter;
  selectedRessourceHumaines;
  listeCal = [];
  listeAllSalle = [];
  listeApprenant = [];
  listeAllSalleIsLoadet: boolean = false;
  selectedSalle;
  selectedSalleFilter;
  listWeek = [];
  listMonth = [];
  dataSourceMatiere = [];
  listeModaliter = [];
  dataSourceContrat = [
    {
      Apprenant: 'Apprenant',
      Tiers_RS: 'Ste 1',
      modifierContrat: '',
      SupprimerContrat: '',
    },
  ];
  @ViewChild('listeMatiereComponen', { static: false })
  listeMatiereComponen: AvtListesComponent;
  @ViewChild('listeContrat', { static: false })
  listeContrat: AvtListesComponent;
  @ViewChild('listeApprenantsComponen', { static: false })
  listeApprenantsComponen: AvtListesComponent;
  @ViewChild('listeApprenantGroupeComponen', { static: false })
  listeApprenantGroupeComponen: AvtListesComponent;
  @ViewChild('listeTypePresenceComponen', { static: false })
  listeTypePresenceComponen: AvtListesComponent;
  @ViewChild('listeCollaborateurComponen', { static: false })
  listeCollaborateurComponen: AvtListesComponent;
  @ViewChild('listeBCComponen', { static: false })
  listeBCComponen: AvtListesComponent;
  @ViewChild('listeHeurSemaineComponent', { static: false })
  listeHeurSemaineComponent: AvtListesComponent;
  @ViewChild('calmoisComponens', { static: false })
  private calmoisComponens: CalmoisComponent;
  @ViewChild('calendarActionComponent', { static: false })
  calendarActionComponent: CalendarComponent;
  @ViewChild('calendarModificationActionComponent', { static: false })
  calendarModificationActionComponent: CalendarComponent;
  listBtnBC: Array<any> = [
    {
      name: 'ajouterBC',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: this.disabled,
      icon: 'add',
    },
    {
      name: 'SupprimerBC',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: this.disabled,
      icon: 'delete',
    },
  ];
  semaineMois: string = '';
  clientFacture;
  showDoc = false;
  eventsSalleRessourcesHumaines = [
    {
      id: 'id',
      title: 'title',
      start: new Date(),
      end: new Date(),
      backgroundColor: '#ffffff',
      textColor: '#000000',
      url: '',
    },
  ];
  eventsCalandar = [];
  eventsCalandarAction = [];
  eventsCalandarModification = [];
  eventsCalandarRessourceHymaine = [];
  eventsCalandarSalle = [];
  columnsTypePresence = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'DiverSys_Titre',
        Lg_Code: '',
        TableRD_Des: 'Type présence',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: 'Total',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'avtActionType_NbHeure',
        Lg_Code: '',
        TableRD_Des: 'Total',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '1.3-3',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsApprenants = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Perso_Nom',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };

  columnsCollaborateur = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Perso_Nom',
        Lg_Code: '',
        TableRD_Des: 'Collabotateurs',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'total',
        Lg_Code: '',
        TableRD_Des: 'Total',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsMatiere = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'matiereName',
        Lg_Code: '',
        TableRD_Des: 'Matière',
        TableRD_Largeur: 180,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'nbrHeur',
        Lg_Code: '',
        TableRD_Des: "Nombre d'heures",
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 1,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'CursusD_Duree',
        Lg_Code: '',
        TableRD_Des: 'Objectif horaires',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 1,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: ' ',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsBonCommande = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'N° BDC',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Obs',
        Lg_Code: '',
        TableRD_Des: 'Libéllé',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_THT',
        Lg_Code: '',
        TableRD_Des: 'Toatal HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 2,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'DateDebut',
        Lg_Code: '',
        TableRD_Des: 'Date début',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'DateFin',
        Lg_Code: '',
        TableRD_Des: 'Date fin',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Date_Create',
        Lg_Code: '',
        TableRD_Des: 'Date ajout',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      // {"TableRE_Code":"","TableRD_Champs":"DateDebutFinDC","Lg_Code":"","TableRD_Des":"Date début/fin","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"dd-MM-yyyy","TableRD_Alligement":0,"TableRD_Ordre":0,"TableRD_Type":4,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null}
    ],
  };
  columnsContrat = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Apprenant',
        Lg_Code: '',
        TableRD_Des: 'Nom et prénom apprenant',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Tiers_RS',
        Lg_Code: '',
        TableRD_Des: 'Nom Entreprise',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },

      {
        TableRE_Code: '',
        TableRD_Champs: 'modifierContrat',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 103,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: 'border_color',
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'SupprimerContrat',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 103,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        TableRD_Icon: 'delete',
        TableRD_Class: 'colorRed',
      },
    ],
  };
  selectedMatiereCursus;
  selectedTypePresence: number = null;
  groupeTypePresenceDiversice = [];
  typePresenceDiversice = [];
  typePresenceAction = [];
  typePresenceHeureDebAM: string;
  typePresenceHeureFinAM: string;
  typePresenceHeureDebPM: string;
  typePresenceHeureFinPM: string;
  typePresenceHeureDebAM2: string;
  typePresenceHeureFinAM2: string;
  typePresenceHeureDebPM2: string;
  typePresenceHeureFinPM2: string;
  action;
  listeActionD = [];
  initAction;
  avtActionDateDeb;
  avtActionDateFin;
  eventAfterResize;
  dateDebutDupliquation: Date;
  dateFinDupliquation: Date;
  Perso_MatriculeSelectedRessourceHumaines: string;
  Machine_SelectedSalle: string;
  avtActionTypeD = [];
  msgErrorDateConflie: string = '';
  actionD;
  MatinChecked: boolean = true;
  ApMidiChecked: boolean = true;
  MatinTypePresenceChecked: boolean = true;
  ApMidiTypePresenceChecked: boolean = true;
  MatinTypePresenceChecked2: boolean = true;
  ApMidiTypePresenceChecked2: boolean = true;
  listeFinanceurByApprenant;
  columnsListeFinanceurByApprenant = [
    'colExp',
    'Perso_Nom',
    'Perso_Prenom',
    'Tiers_NomPublic',
  ];

  columnsListeDetailFinanceurByApprenant = [
    'Tiers_NomPublic',
    'avtCursusFinance_NbrHeure',
    'ModeFacturation',
    'ModePaiement',
    'Tva',
    'DelaiReglement',
  ];
  oldId = { currentTarget: { style: '' } };
  selectedRowListeFinanceurByApprenant;
  listeTva = [];
  listeTvaIsLoadet = false;
  listeModePaiement;
  listeModePaiementIsLoadet = false;
  listeModeFacturation;
  listeModeFacturationIsLoadet = false;
  listeDelaiReglement;
  listeDelaiReglementIsLoadet = false;
  // '0' action ordinaire
  // '1' action administrative
  typeAction: string;
  listeFinanceurAction;
  oldSelectedClamois = [];
  //liste de tous les apprenants
  listeAllApprenant = [];
  timeAm = [];
  timePm = [];
  filterdTimeAm = [];
  filterdTimePm = [];
  selectedAvtActionTypeD;
  listeAvtActionTypeD = [];
  actionPlanification = '';
  dialogModifierPlanificationCalmois;
  //ne pas supprimer
  randomList = [''];
  listeSalles = [];
  listeSallesForMatSelect = [];
  selectedMatiereCursusForUpdate;
  Perso_MatriculeSelectedRessourceHumainesForUpdate;
  Machine_SelectedSalleForUpdate;
  selectedEventForRightClickEvent;
  canSetSelectedEventForRightClickToNull: boolean = true;
  aplyChangeToAllPlanification: boolean = false;
  avtAction_ModFormation: number;
  dateDebutModification;
  dateFinModification;
  titrefrmModifierPlanificationFullCall: string;
  disabledFrmModifierPlanificationFullCall: boolean = false;
  heureDebForUpdate: string;
  heureFinForUpdate: string;
  selectedTypePresenceForUpdate: string;
  selctedEventForUpdate;
  columnHeureSemaine = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'active',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 30,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 1,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'jour',
        Lg_Code: '',
        TableRD_Des: 'Jour',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'amActive',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 30,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 1,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'amDebut',
        Lg_Code: '',
        TableRD_Des: 'Debut',
        TableRD_Largeur: 55,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 105,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        data: [],
        dataToShow: [],
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'amFin',
        Lg_Code: '',
        TableRD_Des: 'Fin',
        TableRD_Largeur: 55,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 105,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        data: [],
        dataToShow: [],
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'pmActive',
        Lg_Code: '',
        TableRD_Des: '',
        TableRD_Largeur: 30,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 1,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'pmDebut',
        Lg_Code: '',
        TableRD_Des: 'Debut',
        TableRD_Largeur: 55,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 105,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        data: [],
        dataToShow: [],
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'pmFin',
        Lg_Code: '',
        TableRD_Des: 'Fin',
        TableRD_Largeur: 55,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 105,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        data: [],
        dataToShow: [],
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'durer',
        Lg_Code: '',
        TableRD_Des: 'Durée',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  columnsListeDocument = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Num',
        Lg_Code: '',
        TableRD_Des: 'Réference',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Date_Create',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd-MM-yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_Obs',
        Lg_Code: '',
        TableRD_Des: 'Intitulé',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'Doc_THT',
        Lg_Code: '',
        TableRD_Des: 'Toatal HT',
        TableRD_Largeur: 70,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };

  heureSemaine = [
    {
      id: 1,
      active: true,
      jour: 'Lundi',
      amDebut: '',
      amFin: '',
      amActive: true,
      pmDebut: '',
      pmFin: '',
      pmActive: true,
      durer: 0,
    },
    {
      id: 2,
      active: true,
      jour: 'Mardi',
      amDebut: '',
      amFin: '',
      amActive: true,
      pmDebut: '',
      pmFin: '',
      pmActive: true,
      durer: 0,
    },
    {
      id: 3,
      active: true,
      jour: 'Mercredi',
      amDebut: '',
      amFin: '',
      amActive: true,
      pmDebut: '',
      pmFin: '',
      pmActive: true,
      durer: 0,
    },
    {
      id: 4,
      active: true,
      jour: 'Jeudi',
      amDebut: '',
      amFin: '',
      amActive: true,
      pmDebut: '',
      pmFin: '',
      pmActive: true,
      durer: 0,
    },
    {
      id: 5,
      active: true,
      jour: 'Vendredi',
      amDebut: '',
      amFin: '',
      amActive: true,
      pmDebut: '',
      pmFin: '',
      pmActive: true,
      durer: 0,
    },
    {
      id: 6,
      active: false,
      jour: 'Samedi',
      amDebut: '',
      amFin: '',
      amActive: false,
      pmDebut: '',
      pmFin: '',
      pmActive: false,
      durer: 0,
    },
    {
      id: 0,
      active: false,
      jour: 'Dimanche',
      amDebut: '',
      amFin: '',
      amActive: false,
      pmDebut: '',
      pmFin: '',
      pmActive: false,
      durer: 0,
    },
  ];
  @ViewChild('collaborateurComponent', { static: false })
  collaborateurComponent: RechercheComponent;
  @ViewChild('collaborateurCalendrierActionComponent', { static: false })
  collaborateurCalendrierActionComponent: RechercheComponent;
  @ViewChild('clientComponent', { static: false })
  clientComponent: RechercheComponent;
  @ViewChild('collaborateurCalendrierActionForUpdateComponent', {
    static: false,
  })
  collaborateurCalendrierActionForUpdateComponent: RechercheComponent;
  entiterFacturation: string = '';
  modePaiement: number = 1;
  tva: number = 1;
  tarif: number;
  modeFacturation: number = 1;
  // @ViewChild("newDocumentComponen",{static : false}) newDocumentComponen : AvtListesComponent;

  newRowDevis = {
    DocD_Q: '',
    DocD_Unite: '',
    Doc_Obs: '',
    Art_TVA: this.tva,
    DocD_PUHTB: '',
    DocD_THT: 0,
  };
  listBtnListeDevis: Array<any> = [
    {
      name: 'ajouterDocument',
      class: '',
      text: 'Ajouter',
      disabled: this.disabled,
      icon: 'add',
    },
    {
      name: 'attacherDocument',
      class: 'colorGreen',
      text: 'Attacher',
      disabled: this.disabled,
      icon: 'link',
    },
    {
      name: 'devisToFacture',
      class: 'colorBlue',
      text: 'D => F',
      disabled: this.disabled,
      icon: 'redo',
    },
    {
      name: 'imrimerDocument',
      class: 'colorBlue',
      text: 'Imprimer',
      disabled: this.disabled,
      icon: 'print',
    },
    {
      name: 'detacherDocument',
      class: 'colorRed',
      text: 'Détacher',
      disabled: this.disabled,
      icon: 'link_off',
    },
  ];
  listBtnListeFacture: Array<any> = [
    {
      name: 'ajouterDocument',
      class: '',
      text: 'Ajouter',
      disabled: this.disabled,
      icon: 'add',
    },
    {
      name: 'attacherDocument',
      class: 'colorGreen',
      text: 'Attacher',
      disabled: this.disabled,
      icon: 'link',
    },
    {
      name: 'imrimerDocument',
      class: 'colorBlue',
      text: 'Imprimer',
      disabled: this.disabled,
      icon: 'print',
    },
    {
      name: 'detacherDocument',
      class: 'colorRed',
      text: 'Détacher',
      disabled: this.disabled,
      icon: 'link_off',
    },
  ];
  bonComamnde;
  initBonComamnde;
  @ViewChild('frmBonCommande', { static: false }) frmBonCommande: any;
  documentName: string = '';
  documentType: string = '';
  documentSrc: string = '';
  typeActionD: string;
  actionDIntitule: string;
  listeDocuments = [];
  @ViewChild('listeDevisComponen', { static: false })
  listeDevisComponen: AvtListesComponent;
  @ViewChild('listeFactureComponen', { static: false })
  listeFactureComponen: AvtListesComponent;
  tabProperty = [
    'avtActionReferent',
    'avtActionType',
    'avtActionTypeD',
    'avtactionDoc',
    'avtAPH',
  ];
  avtactionDCol = [];
  avtActionTypeDCalmoi = [];
  initActionStr;
  listeCollaborateur;
  ngOnInit() {
    //this.columnsApprenants={"TableRD":[""]};
    this.action = {};
    this.bonComamnde = {};
    this.readParamUrl();
    this.selectedSalle = {};
    this.selectedSalleFilter = {};
    this.selectedRessourceHumainesFilter = {};
    this.selectedRessourceHumaines = {};
    this.selectedMatiereCursus = {};
    this.clientFacture = {};
    this.selectedMatiereCursusForUpdate = {};
    this.getListeSalle();
    this.getModaliterFormation();
    this.getListeTva();
    this.getListeModePaiement();
    this.getListeModeFacturation();
    this.getListeDelaiReglement();
  }
  //ne pas supprimer
  doNotThink() {
    console.log('doNotThink');
  }
  getListeDocument(setExistToTrue: boolean) {
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtAdoc&param=' + this.param_code
      )
      .subscribe((data) => {
        this.listeDocuments = data;
        setTimeout(() => {
          //devis
          this.listeDevisComponen.setDataSource(
            data.filter((doc) => {
              return doc.Doc_Type == 'FACP';
            })
          );
          //facture
          this.listeFactureComponen.setDataSource(
            data.filter((doc) => {
              return doc.Doc_Type == 'FACT';
            })
          );
          // bon de commande
          this.listeBCComponen.setDataSource(
            data.filter((doc) => {
              return doc.Doc_Type == 'CMD';
            })
          );
          if (setExistToTrue) this.exist = setExistToTrue;
          $('#hiddenBtnForActualiserListe').trigger('click');
        }, 1000);
      });

    if (setExistToTrue) {
      this.generalService
        .rechercheTable(
          globalUrls.urlAction + '&val=' + this.action.avtAction_Code
        )
        .subscribe((action) => {
          this.initAction = action;
        });
    }
  }
  // getNewRowDevis()
  // {
  //   var row = JSON.parse(JSON.stringify(this.newRowDevis))
  //   var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == this.tva})
  //   selectedTva = selectedTva? selectedTva.DiverSys_Titre : "";
  //   row.Art_TVA = selectedTva;
  //   return row
  // }
  onTvaChange() {
    // var data = this.newDocumentComponen.dataSource.data;
    // var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == this.tva})
    // data.forEach(row =>
    // {
    //     row.Art_TVA = selectedTva.DiverSys_Titre;
    // });
    // this.calculerDevis()
  }
  // outputActionNewDocument(event)
  // {
  //   if(event.event.keyCode == 9)
  //     if(event.index == this.newDocumentComponen.dataSource.data.length-1)
  //     {
  //       var c = this.columnsNewDocument.TableRD[this.columnsNewDocument.TableRD.length - 2].TableRD_Champs
  //       if(event.column.TableRD_Champs == c)
  //         this.addNewRowInDocument()
  //     }
  //   this.calculerDevis()
  // }
  // calculerDevis()
  // {
  //   var data = this.newDocumentComponen.dataSource.data;
  //   this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text = 0;
  //   data.forEach(row =>
  //   {
  //     if(this.generalService.isNotEmpty(row.DocD_Q) && this.generalService.isNotEmpty(row.DocD_PUHTB))
  //       row.DocD_THT = row.DocD_Q * row.DocD_PUHTB;
  //     if(this.generalService.isNotEmpty(row.Art_TVA))
  //     {
  //       var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == row.Art_TVA})
  //       var tva = parseInt(selectedTva.DiverSys_Titre.replace("%",""))/100;
  //       var THT = row.DocD_THT * tva
  //       var somme = parseInt(this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text.toString())
  //       this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text = somme + THT
  //     }
  //   });
  //   this.columnsNewDocument.customFooter.listeFooter[0].colonne[1].text = data.map(row => row.DocD_THT).reduce((acc, value) => acc + value, 0);
  //   // if(this.generalService.isNotEmpty(this.tva))
  //   // {
  //   //   var selectedTva = this.listeTva.find(tva =>{return tva.DiverSys_Index == this.tva})
  //   //   var tva = parseInt(selectedTva.DiverSys_Titre.replace("%",""))/100
  //   //   this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text = data.map(row => row.DocD_THT).reduce((acc, value) => acc + value*tva, 0);
  //   // }
  //   var THT = parseInt(this.columnsNewDocument.customFooter.listeFooter[0].colonne[1].text.toString())
  //   var TTVA = parseInt(this.columnsNewDocument.customFooter.listeFooter[1].colonne[1].text.toString())
  //   this.columnsNewDocument.customFooter.listeFooter[2].colonne[1].text =  THT + TTVA
  // }
  // addNewRowInDocument()
  // {
  //   var data = this.newDocumentComponen.dataSource.data
  //   data.push(this.getNewRowDevis())
  //   this.newDocumentComponen.setDataSource(data)
  // }
  ajouterDocument(fenetre: string) {
    //mode/:Tiers_code/:indexTabs/:modeFacuration/:modePayement/:tva
    //if(this.formDevis.valid)
    {
      //bon de commande
      if (this.action.Tiers_code) {
        var windows = this.generalService.popupCenter(
          '/w/avt/document/1/1/' +
            fenetre +
            '/modal/' +
            this.action.Tiers_code +
            '/1/' +
            this.param_code
        );
        windows.onbeforeunload = () => {
          this.exist = false;
          this.getListeDocument(true);
        };
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner un client dans Informations action',
          false
        );
    }
  }
  HandlePopupResult(res) {
    alert(res);
  }
  attacherDocument(fenetre) {
    var random = Math.random().toString().substr(2, 5);
    var windows = this.generalService.popupCenter(
      '/w/avt/liste/document/' + fenetre + '/modal/' + random
    );
    windows.onbeforeunload = () => {
      var srtDocument = localStorage.getItem(random);
      if (srtDocument) {
        localStorage.removeItem(random);
        this.exist = false;
        var document = JSON.parse(srtDocument);
        this.exist = false;
        this.enregistrerDocumentAction(
          document.P_Num ? document.P_Num : document.Doc_Num
        );
      }
    };
  }
  clickBtnHeatListeDocument(event, fenetre) {
    switch (event.name) {
      case 'ajouterDocument': {
        this.ajouterDocument(fenetre);
        break;
      }
      case 'attacherDocument': {
        this.attacherDocument(fenetre);
        break;
      }
      case 'devisToFacture': {
        this.devisToFacture();
        break;
      }
      case 'detacherDocument': {
        this.detacherDocument(event.row);
        break;
      }
    }
  }
  detacherDocument(row) {
    // var row = this.listeDevisComponen.row? this.listeDevisComponen.row : this.listeFactureComponen.row;
    if (row) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        message: ' Voulez-vous détacher le document sélectionner ?',
        btnOk: {
          class: 'colorGreen',
          icon: 'keyboard_return',
          text: 'Détacher',
        },
        btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
      };
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.exist = false;
          this.generalService
            .rechercheTable('ds/formdata?code=document&val=' + row.Doc_Num)
            .subscribe((data) => {
              data.Document[0].avtAction_Code = '';
              var ds = {
                Document: data.Document,
                DocumentD: data.DocumentD,
                ApiParam: [{ androidId: 123 }],
              };
              this.generalService.saveDA(ds).subscribe(() => {
                this.generalService.dialogSuccess('Document détacher', true);
                this.getListeDocument(true);
              });
            });
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une ligne',
        false
      );
  }
  devisToFacture() {
    if (this.generalService.isNotEmpty(this.listeDevisComponen.row)) {
      var row = this.listeDevisComponen.row;
      this.exist = false;
      var documentD = [];
      var document = [];
      var ds;
      this.generalService
        .rechercheTable('ds/formdata?code=document&val=' + row.Doc_Num)
        .subscribe(
          (data) => {
            // Doc_Devise_Cours : taux de change
            document.push({
              Doc_Type: 'FACT',
              Devise_Code: data.Document[0].Devise_Code,
              Doc_Devise_Cours: data.Document[0].Doc_Devise_Cours,
              Doc_Obs: data.Document[0].Doc_Obs,
              Doc_THT: data.Document[0].Doc_THT,
              Doc_Num: '',
              Tiers_code: data.Document[0].Tiers_code,
              avtAction_Code: this.param_code,
              Doc_RS: data.Document[0].Doc_RS,
            });
            data.DocumentD.forEach((docD) => {
              documentD.push({
                DocD_Id: '',
                Art_Code: docD.Art_Code,
                Art_Des: docD.Art_Des,
                DocD_Q: docD.DocD_Q,
                DocD_QReliquat: docD.DocD_QReliquat,
                DocD_Unite: docD.DocD_Unite,
                DocD_TVACode: docD.DocD_TVACode,
                DocD_PUHTB: docD.DocD_PUHTB,
                DocD_THT: docD.DocD_THT,
                Doc_Num: '',
              });
            });
            ds = {
              Document: document,
              DocumentD: documentD,
              ApiParam: [{ androidId: 123 }],
            };
            this.generalService.saveDA(ds).subscribe(
              (data) => {
                // re enregistrement pour corriger le bug d'avois Total hor tax = 0
                this.generalService
                  .rechercheTable(
                    'ds/formdata?code=document&val=' + data[0].Num
                  )
                  .subscribe((data) => {
                    ds = {
                      Document: data.Document,
                      DocumentD: data.DocumentD,
                      ApiParam: [{ androidId: 123 }],
                    };
                    this.generalService.saveDA(ds).subscribe((data) => {
                      this.generalService.dialogSuccess('Enregistré', true);
                      this.getListeDocument(true);
                    });
                  });
              },
              () => {
                this.generalService.dialogSuccess('Non enregistré', false);
                this.exist = true;
              }
            );
          },
          () => {
            this.generalService.dialogSuccess('Non enregistré', false);
            this.exist = true;
          }
        );
    }
  }
  retourListeAction() {
    this.generalService.popupCenter('/w/action/prestation/' + this.typeAction);
  }
  closeDialogModifierPlanificationCalmois() {
    this.dialogModifierPlanificationCalmois.close();
  }
  enregistrerModificationPlanificationCalmois(mode: string = '') {
    // Modification
    if (this.actionPlanification == 'Modification') {
      if (this.generalService.isNotEmpty(this.selectedAvtActionTypeD)) {
        var resulta = this.verifierHeurTypePresenceDEnConflie(
          this.initAction.avtActionTypeD,
          this.MatinTypePresenceChecked2,
          this.typePresenceHeureDebAM2,
          this.typePresenceHeureFinAM2,
          this.ApMidiTypePresenceChecked2,
          this.typePresenceHeureDebPM2,
          this.typePresenceHeureFinPM2,
          this.selectedAvtActionTypeD
        );
        //aucin date en confli
        if (resulta == '') {
          this.exist = false;
          this.generalService
            .rechercheTable(
              globalUrls.urlAction + '&val=' + this.action.avtAction_Code
            )
            .subscribe(
              (action) => {
                var avtActionTypeD = action.avtActionTypeD.find(
                  (avtActionTypeD) => {
                    return (
                      avtActionTypeD.avtActionTypeD_Id ==
                      this.selectedAvtActionTypeD
                    );
                  }
                );
                if (avtActionTypeD) {
                  if (
                    this.MatinTypePresenceChecked2 &&
                    this.generalService.isNotEmpty(
                      this.typePresenceHeureDebAM2
                    ) &&
                    this.generalService.isNotEmpty(this.typePresenceHeureFinAM2)
                  ) {
                    avtActionTypeD.avtActionTypeD_heureDebAM =
                      this.dateService.setFormaTime(
                        this.typePresenceHeureDebAM2
                      );
                    avtActionTypeD.avtActionTypeD_heureFinAM =
                      this.dateService.setFormaTime(
                        this.typePresenceHeureFinAM2
                      );
                  }
                  if (
                    this.ApMidiTypePresenceChecked2 &&
                    this.generalService.isNotEmpty(
                      this.typePresenceHeureDebPM2
                    ) &&
                    this.generalService.isNotEmpty(this.typePresenceHeureFinPM2)
                  ) {
                    avtActionTypeD.avtActionTypeD_heureDebPM =
                      this.dateService.setFormaTime(
                        this.typePresenceHeureDebPM2
                      );
                    avtActionTypeD.avtActionTypeD_heureFinPM =
                      this.dateService.setFormaTime(
                        this.typePresenceHeureFinPM2
                      );
                  }
                  this.generalService
                    .enregisterTable(
                      this.generalService.supprimerTableVideAction(
                        action,
                        this.tabProperty,
                        'avtAction_Code'
                      )
                    )
                    .subscribe(
                      () => {
                        this.initAction = action;
                        this.exist = true;
                        this.generalService.dialogSuccess('Enregistré', true);
                        this.typePresenceActionChange(false);
                      },
                      (error) => {
                        this.exist = true;
                        this.generalService.dialogSuccess(
                          'Non enregistré',
                          false
                        );
                      }
                    );
                }
              },
              (error) => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
        } else
          this.generalService.dialogSuccess(
            'Conflit de planning dans: ' + resulta,
            false
          );
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une planification',
          false
        );
    }
    //suppression
    else {
      var listeAvtActionTypeDToDelete;
      if (mode != 'tous')
        listeAvtActionTypeDToDelete = this.listeAvtActionTypeD.filter(
          (actionTypeD) => {
            return actionTypeD.avtActionTypeD_Id == this.selectedAvtActionTypeD;
          }
        );
      else listeAvtActionTypeDToDelete = this.listeAvtActionTypeD;
      if (
        listeAvtActionTypeDToDelete.length > 0 &&
        this.generalService.isNotEmpty(listeAvtActionTypeDToDelete[0])
      ) {
        var api = 'avtActionTypeD';
        if (this.typeAction == '2') api = 'avtactiond2';
        var compte = listeAvtActionTypeDToDelete.length;
        listeAvtActionTypeDToDelete.forEach((elementToDelete) => {
          this.exist = false;
          this.generalService
            .supprimerSanMsgConfirm(elementToDelete.avtActionTypeD_Id, api)
            .subscribe(
              () => {
                compte--;
                if (this.typeAction == '2')
                  this.listeActionD = this.listeActionD.filter((actionD) => {
                    return (
                      actionD.avtActionD_Code !=
                      elementToDelete.avtActionTypeD_Id
                    );
                  });
                else
                  this.initAction.avtActionTypeD =
                    this.initAction.avtActionTypeD.filter((avtActionTypeD) => {
                      return (
                        avtActionTypeD.avtActionTypeD_Id !=
                        elementToDelete.avtActionTypeD_Id
                      );
                    });
                if (compte == 0) {
                  var cooredonner = this.getCooredonnerCalmois(elementToDelete);
                  var day =
                    this.listeCal[cooredonner.mois].val[cooredonner.week][
                      cooredonner.day
                    ];
                  day.bgColor = this.cssBackgroundDefault;
                  day.textColor = this.cssTextdDefault;
                  if (this.typeAction == '2') {
                    this.fillAvtActionTypeDToCalmois(
                      this.convertAvtactiondToAvtActionTypeD(this.listeActionD)
                    );
                    this.setDataSourceListeCollaborateur();
                  } else this.typePresenceActionChange(false);
                  this.dialogModifierPlanificationCalmois.close();
                }
                this.exist = true;
                this.generalService.dialogSuccess('Supprimer', true);
              },
              (error) => {
                compte--;
                this.exist = true;
                this.generalService.dialogSuccess('Non supprimer', false);
              }
            );
        });
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une planification',
          false
        );
    }
  }

  toggleRowListeFinanceurByApprenant(element: any, event: any) {
    const foundElement = this.listeFinanceurByApprenant.data.find(
      (elem) =>
        elem !== undefined && elem.Perso_Matricule === element.Perso_Matricule
    );
    var index = this.listeFinanceurByApprenant.data.indexOf(foundElement);
    this.listeFinanceurByApprenant.data[index].testExpande =
      !this.listeFinanceurByApprenant.data[index].testExpande;
    if (this.listeFinanceurByApprenant.data[index].testExpande)
      event.currentTarget.innerHTML = 'remove';
    else event.currentTarget.innerHTML = 'add';
  }
  selectRowListeFinanceurByApprenant(event, row, id) {
    // var els = document.getElementsByName(name);
    try {
      $('#' + this.oldId).attr('style', '');
    } catch (error) {}

    event.currentTarget.style = 'background-color: #a0bdf3;';
    this.oldId = id;
    this.selectedRowListeFinanceurByApprenant = row;
  }
  onMatinChecked() {
    if (!this.MatinChecked) {
      this.action.avtAction_heureDebAM = null;
      this.action.avtAction_heureFinAM = null;
    } else {
      this.action.avtAction_heureDebAM = this.paramHeure.avtHeureAM_Deb;
      this.action.avtAction_heureFinAM = this.paramHeure.avtHeureAM_Fin;
    }
  }
  onApMidiChecked() {
    if (!this.ApMidiChecked) {
      this.action.avtAction_heureDebPM = null;
      this.action.avtAction_heureFinPM = null;
    } else {
      this.action.avtAction_heureDebPM = this.paramHeure.avtHeurePM_Deb;
      this.action.avtAction_heureFinPM = this.paramHeure.avtHeurePM_Fin;
    }
  }
  onMatinTypePresenceChecked() {
    if (!this.MatinTypePresenceChecked) {
      this.typePresenceHeureDebAM = null;
      this.typePresenceHeureFinAM = null;
    }
  }
  onApMidiTypePresenceChecked() {
    if (!this.ApMidiTypePresenceChecked) {
      this.typePresenceHeureDebPM = null;
      this.typePresenceHeureFinPM = null;
    }
  }
  onMatinTypePresenceChecked2() {
    if (!this.MatinTypePresenceChecked2) {
      this.typePresenceHeureDebAM2 = null;
      this.typePresenceHeureFinAM2 = null;
    }
  }
  onApMidiTypePresenceChecked2() {
    if (!this.ApMidiTypePresenceChecked2) {
      this.typePresenceHeureDebPM2 = null;
      this.typePresenceHeureFinPM2 = null;
    }
  }
  dateDebutDupliquationChange() {}
  dateFinDupliquationChange() {}
  getListeRessourcesHumaines(Matiere_Code) {
    this.generalService
      .rechercheTable(
        this.generalService.url + 'avtpersocomp&param=' + Matiere_Code
      )
      .subscribe((data) => {
        this.listeRessourcesHumaines = this.generalService.sort(
          data,
          'Perso_Nom'
        );
      });
  }
  openMenuContectuelleCalmois(event: MouseEvent) {
    event.preventDefault();
    this.closeAllMenuContectuelle();
    const positionStrategy = this.overlayCalmois
      .position()
      .flexibleConnectedTo({ x: event.x, y: event.y })
      .withPositions([
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
      ]);
    this.overlayRefCalmois = this.overlayCalmois.create({
      positionStrategy,
      scrollStrategy: this.overlayCalmois.scrollStrategies.close(),
    });
    this.overlayRefCalmois.attach(
      new TemplatePortal(
        this.menuContectuelleCalmois,
        this.viewContainerRefCalmoi
      )
    );
  }
  openMenuContectuelleAction(event: MouseEvent) {
    this.canSetSelectedEventForRightClickToNull = false;
    event.preventDefault();
    this.closeAllMenuContectuelle();
    const positionStrategy = this.overlayAction
      .position()
      .flexibleConnectedTo({ x: event.x, y: event.y })
      .withPositions([
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
      ]);
    this.overlayRefAction = this.overlayAction.create({ positionStrategy });
    this.overlayRefAction.attach(
      new TemplatePortal(
        this.menuContectuelleAction,
        this.viewContainerRefAction
      )
    );
  }

  closeMenuContectuelleAction() {
    // this.subAction && this.subAction.unsubscribe();
    if (this.overlayRefAction) {
      this.canSetSelectedEventForRightClickToNull = true;
      this.overlayRefAction.dispose();
      this.overlayRefAction = null;
    }
  }
  closeMenuContectuelleCalmois() {
    this.subCalmois && this.subCalmois.unsubscribe();
    if (this.overlayRefCalmois) {
      this.overlayRefCalmois.dispose();
      this.overlayRefCalmois = null;
    }
  }
  closeAllMenuContectuelle() {
    this.closeMenuContectuelleAction();
    this.closeMenuContectuelleCalmois();
  }
  getTypePresenceFromDiversice() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=ACTION01')
      .subscribe((data) => {
        this.groupeTypePresenceDiversice = data.DiverSys;
        this.generalService
          .rechercheTable(globalUrls.urlParametre + '&val=ACTION02')
          .subscribe((data) => {
            this.typePresenceDiversice = data.DiverSys;
            this.generateTypePresenceAction();
          });
      });
  }
  generateTypePresenceAction() {
    //mode edit
    if (
      this.typePresenceAction.length > 0 &&
      this.generalService.isNotEmpty(
        this.typePresenceAction[0].avtActionType_Id
      )
    ) {
      //this.groupeTypePresenceDiversice = this.groupeTypePresenceDiversice.filter(diver =>{return !this.generalService.isNotEmpty(diver.DiverSys_Group) ||  diver.DiverSys_Group == this.action.avtAction_ModFormation.toString() });
      for (var i = 0; i < this.typePresenceAction.length; i++) {
        var typePre = this.typePresenceDiversice.find(
          (typePresenceDiversice) => {
            return (
              typePresenceDiversice.DiverSys_Index ==
              this.typePresenceAction[i].avtActionType_Presence
            );
          }
        );
        if (typePre != undefined)
          this.typePresenceAction[i]['DiverSys_Titre'] = typePre.DiverSys_Titre;
        else this.typePresenceAction[i]['DiverSys_Titre'] = '';
        // this.typePresenceAction[i].avtActionType_Facturable = (this.typePresenceAction[i].avtActionType_Facturable == 1 ? true : false)
        // this.typePresenceAction[i].avtActionType_Planifiable = (this.typePresenceAction[i].avtActionType_Planifiable == 1 ? true : false)
        // this.typePresenceAction[i].avtActionType_InclusHeureCours = (this.typePresenceAction[i].avtActionType_InclusHeureCours == 1 ? true : false)
      }
    }
    //mode ajout
    else {
      // if(this.typePresenceAction.length == 1)
      //   this.typePresenceAction.pop();
      // this.typePresenceDiversice.forEach(typePresenceDiversice =>
      // {
      //   this.typePresenceAction.push({avtActionType_Id:typePresenceDiversice.DiverSys_Index,avtActionType_NbHeure:0,avtActionType_Presence:typePresenceDiversice.DiverSys_Index,avtAction_Code:this.action.avtAction_Code,DiverSys_Titre:typePresenceDiversice.DiverSys_Titre,avtActionType_Facturable:true})
      // });
    }
    // action de formation
    if (this.typeAction == '0') {
      this.listeTypePresenceComponen.setDataSource(this.typePresenceAction);
      //set default selection to typePresenceAction (select first element)
      if (this.typePresenceAction.length > 0) {
        this.selectedTypePresence = this.typePresenceAction[0].avtActionType_Id;
      }
    }
  }
  radioModalitesChange(event) {
    if (this.typeTrs == '1') {
      this.typePresenceAction = [];
      var liste = this.groupeTypePresenceDiversice.filter((diver) => {
        return (
          !this.generalService.isNotEmpty(diver.DiverSys_Group) ||
          diver.DiverSys_Group == this.action.avtAction_ModFormation.toString()
        );
      });
      liste.forEach((groupeTypePresenceDiversice) => {
        var typePresence = this.typePresenceDiversice.find((type) => {
          return (
            type.DiverSys_Index == groupeTypePresenceDiversice.DiverSys_Group1
          );
        });
        this.typePresenceAction.push({
          avtActionType_Id: typePresence.DiverSys_Index,
          avtActionType_NbHeure: 0,
          avtActionType_Presence: typePresence.DiverSys_Index,
          avtAction_Code: this.action.avtAction_Code,
          DiverSys_Titre: typePresence.DiverSys_Titre,
          avtActionType_Facturable:
            typePresence.DiverSys_Group1 == '0' ? false : true,
          avtActionType_Planifiable:
            typePresence.DiverSys_Group2 == '0' ? false : true,
          avtActionType_InclusHeureCours:
            typePresence.DiverSys_Group3 == '0' ? false : true,
        });
      });
    } else {
      var listeNewTypePresenceAction = this.groupeTypePresenceDiversice.filter(
        (diver) => {
          return (
            !this.generalService.isNotEmpty(diver.DiverSys_Group) ||
            diver.DiverSys_Group ==
              this.action.avtAction_ModFormation.toString()
          );
        }
      );
      var listeNEwDiverSys_Group1 = listeNewTypePresenceAction
        .map((type) => {
          return type.DiverSys_Group1;
        })
        .reduce((a, b) => {
          return a + ';' + b;
        });
      listeNEwDiverSys_Group1 = ';' + listeNEwDiverSys_Group1 + ';';
      var listeGroupeNotFindInTypePresenceAction =
        this.typePresenceAction.filter((type) => {
          return (
            listeNEwDiverSys_Group1.indexOf(
              ';' + type.avtActionType_Presence + ';'
            ) == -1
          );
        });
      var listeAvtActionType_Id = listeGroupeNotFindInTypePresenceAction.map(
        (type) => {
          return type.avtActionType_Id;
        }
      );
      var listeAvtActionType_IdStr = '';
      if (listeAvtActionType_Id.length > 0) {
        listeAvtActionType_IdStr =
          ';' +
          listeAvtActionType_Id.reduce((a, b) => {
            return a + ';' + b;
          }) +
          ';';
        var listePlanification = this.initAction.avtActionTypeD.filter(
          (typeD) => {
            return (
              listeAvtActionType_IdStr.indexOf(
                ';' + typeD.avtActionType_Id + ';'
              ) >= 0
            );
          }
        );
        if (listePlanification.length > 0) {
          this.tryDeleteTypeActionTypeActionD(
            listeGroupeNotFindInTypePresenceAction,
            listePlanification
          );
        }
      }
    }
  }
  tryDeleteTypeActionTypeActionD(
    listeGroupeNotFindInTypePresenceAction,
    listePlanification
  ) {
    var listeAvtActionType_PresenceNotFound =
      listeGroupeNotFindInTypePresenceAction.map((type) => {
        return type.avtActionType_Presence;
      });
    var nonTypePresence = listeAvtActionType_PresenceNotFound.reduce((a, b) => {
      var findTypePresence = this.typePresenceDiversice.find((type) => {
        return type.DiverSys_Index == b;
      });
      if (findTypePresence) findTypePresence = findTypePresence.DiverSys_Titre;
      else findTypePresence = '';
      return a + ', ' + findTypePresence;
    }, '');

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message:
        'Les planifications des types de présences ' +
        nonTypePresence +
        ' vont être supprimé.' +
        ' Voulez-vous les supprimer ?',
      btnOk: {
        class: 'colorGreen',
        icon: 'keyboard_return',
        text: 'Supprimer',
      },
      btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
    };
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        this.deleteActionTypeActionTypeD(
          listeGroupeNotFindInTypePresenceAction,
          listePlanification
        );
      } else {
        this.action.avtAction_ModFormation = this.avtAction_ModFormation;
      }
    });
  }
  deleteActionTypeActionTypeD(
    listeGroupeNotFindInTypePresenceAction,
    listePlanification
  ) {
    var compte =
      listeGroupeNotFindInTypePresenceAction.length + listePlanification.length;
    listeGroupeNotFindInTypePresenceAction.forEach((typePresence) => {
      this.generalService
        .supprimerSanMsgConfirm(typePresence.avtActionType_Id, 'avtActionType')
        .subscribe(() => {
          this.tryRerrechAction(compte);
        });
    });
    listePlanification.forEach((planification) => {
      this.generalService
        .supprimerSanMsgConfirm(
          planification.avtActionTypeD_Id,
          'avtActionTypeD'
        )
        .subscribe(() => {
          this.tryRerrechAction(compte);
        });
    });
  }
  tryRerrechAction(compte) {
    compte--;
    if (compte == 0) {
      this.generalService
        .rechercheTable(
          globalUrls.urlAction + '&val=' + this.action.avtAction_Code
        )
        .subscribe((myAction) => {
          myAction.avtaction[0].avtAction_ModFormation =
            this.action.avtAction_ModFormation;
          this.generalService
            .enregisterTable(
              this.generalService.supprimerTableVideAction(
                myAction,
                this.tabProperty,
                'avtAction_Code'
              )
            )
            .subscribe((action) => {
              this.typePresenceAction = myAction.avtActionType;
              this.generateTypePresenceAction();
              this.getActionD();
              this.typePresenceAction = this.generalService.clone(
                this.initAction.avtActionType
              );
            });
        });
    }
    this.generalService.dialogSuccess('Supprimer', true);
  }
  getListeSalle() {
    this.listeAllSalle = this.generalService.typeSalle;
    this.listeAllSalleIsLoadet = true;
    // this.generalService.rechercheTable(this.generalService.urlParametre+"&val=SALL01").subscribe(data =>
    // {
    //   this.listeAllSalle = data.DiverSys;
    //   this.listeAllSalleIsLoadet = true;

    // });
  }
  setColonneApprenant() {
    this.columnsApprenants.TableRD[0].TableRD_Des = this.ecrant;
    if (this.typeAction == '2')
      this.columnsApprenants.TableRD[0].TableRD_Champs = 'User_Id';
    else this.columnsApprenants.TableRD[0].TableRD_Champs = 'Perso_Nom';
  }
  getListePerso() {
    var url = '';
    // action de formation
    if (this.typeAction == '0') {
      if (this.generalService.isNotEmpty(this.action.Cursus_Code)) {
        url =
          this.generalService.url +
          'avtpersocna&param=' +
          this.action.Cursus_Code;
      }
    }
    // action administrative
    if (this.typeAction == '1') {
      url = this.generalService.url + 'avtperso&param=0';
    }
    // action  de prestation
    if (this.typeAction == '2') {
      url = this.generalService.url + 'avtusers';
    }
    if (url != '')
      this.generalService.rechercheTable(url).subscribe((data) => {
        this.listeApprenant = data;
        this.listeApprenantsComponen.setDataSource(this.listeApprenant);
        //enlever les perso de listeApprenantsComponen qui apparer dans listeApprenantGroupeComponen
        if (this.listeApprenantGroupeComponen.dataSource.data.length > 0)
          this.removePersoFromListeApprenantGroupeComponen();
      });
  }
  // remove Perso From ListeApprenantGroupeComponen qui se trouve dans listeApprenantsComponen
  removePersoFromListeApprenantGroupeComponen() {
    var property = 'Perso_Matricule';
    if (this.typeAction == '2') property = 'User_Id';
    var data = this.listeApprenantsComponen.dataSource.data;
    this.listeApprenantGroupeComponen.dataSource.data.forEach((perso) => {
      data = data.filter((row) => {
        return row[property] != perso[property];
      });
    });
    this.listeApprenantsComponen.setDataSource(data);
  }
  generateDataSourceListeApprenantGroupeComponent() {
    var property = 'Perso_Matricule';
    var property2 = 'Perso_Nom';
    if (this.typeAction == '2') {
      property = 'User_Id';
      property2 = 'UserName';
    }
    this.initAction.avtActionReferent.forEach((apprenant) => {
      var findApprenant = this.listeAllApprenant.find((appre) => {
        return appre[property] == apprenant[property];
      });
      if (findApprenant != undefined)
        apprenant[property2] = findApprenant[property2];
      else apprenant[property2] = '';
    });
    this.listeApprenantGroupeComponen.setDataSource(
      this.initAction.avtActionReferent.filter((referent) => {
        return this.generalService.isNotEmpty(referent[property]);
      })
    );
    //enlever les perso de listeApprenantsComponen qui apparer dans listeApprenantGroupeComponen
    if (this.listeApprenantsComponen.dataSource.data.length > 0)
      this.removePersoFromListeApprenantGroupeComponen();
    //Actiin Administrative
    if (this.typeAction == '1') this.setDataListeCollaborateurComponen();
  }
  getModaliterFormation() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COL12')
      .subscribe((data) => {
        this.listeModaliter = data.DiverSys;
      });
  }
  onCursusActionChange() {
    this.listeApprenantGroupeComponen.setDataSource([]);
    this.onCursusChange();
  }
  onCursusChange() {
    if (this.generalService.isNotEmpty(this.action.Cursus_Code)) {
      this.getListePerso();
      this.generalService
        .rechercheTable(
          globalUrls.urlApplyCursusD + '&val=' + this.action.Cursus_Code
        )
        .subscribe((data) => {
          if (
            data.ApplyCursusD[0].Cursus_Code == null &&
            data.ApplyCursusD[0].Matiere_Code == null &&
            data.ApplyCursusD[0].CursusD_Id == null
          )
            data.ApplyCursusD = [];
          this.listeMatiereCursus = data.ApplyCursusD;
          this.generateListeMatiereCursus();
        });
    }
  }
  verifierExistanceSelectedMatiereCursus() {
    if (!this.selectedMatiereCursus.Matiere_Code && !this.disabled)
      this.generalService.dialogSuccess(
        'Veuillez choisir une matière pour pouvoir selectionner un ressource',
        false
      );
  }
  onRessourcesHumainesChange() {
    this.exist = false;
    this.eventsCalandarRessourceHymaine = [];
    this.deselectionCalendarAction();
    this.selectedRessourceHumaines = this.listeRessourcesHumaines.find(
      (ressource) => {
        return (
          ressource.Perso_Matricule ==
          this.Perso_MatriculeSelectedRessourceHumaines
        );
      }
    );
    var avtAction_dateDeb = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var avtAction_dateFin = this.dateService.setToDate(
      this.action.avtAction_dateFin
    );
    var url =
      globalUrls.urlavtactionDColDate +
      this.selectedRessourceHumaines.Perso_Matricule +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.exist = true;
      this.eventsCalandarRessourceHymaine = this.createEventsCalandar(
        data.filter((actionD) => {
          return actionD.avtAction_Code != this.action.avtAction_Code;
        }),
        false,
        'rgb(250, 239, 89)',
        'white'
      );
      this.refrechCalendarAction(null, null, false, null);
    });
  }
  onMatiereChange(event, matiereCursus) {
    this.deselectionCalendarAction();
    if (this.listeAllSalleIsLoadet) {
      var mat = this.generalService.clone(
        this.listeMatiereCursus.find((matiere) => {
          return matiere.Matiere_Code == event.value;
        })
      );
      eval('this.' + matiereCursus + ' = mat;');
      var s = this.selectedMatiereCursusForUpdate;
      this.getListeRessourcesHumaines(event.value);
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  onSalleChange() {
    if (this.generalService.isNotEmpty(this.Machine_SelectedSalle)) {
      var salle = this.listeSalles.find((s) => {
        return s.Machine_Code == this.Machine_SelectedSalle;
      });
      this.exist = false;
      this.eventsCalandarSalle = [];
      this.deselectionCalendarAction();
      this.selectedSalle = salle;
      this.selectedSalle.Machine_Lib =
        this.selectedSalle.Batiment +
        (this.generalService.isNotEmpty(this.selectedSalle.etage)
          ? ' étage ' + this.selectedSalle.etage
          : '') +
        (this.generalService.isNotEmpty(this.selectedSalle.numPort)
          ? ' porte numéro ' + this.selectedSalle.numPort
          : '');
      var avtAction_dateDeb = this.dateService.setToDate(
        this.action.avtAction_dateDeb
      );
      var avtAction_dateFin = this.dateService.setToDate(
        this.action.avtAction_dateFin
      );
      var url =
        globalUrls.urlavtactionDMachineDate +
        salle.Machine_Code +
        ',' +
        this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
        ',' +
        this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
      this.generalService.rechercheTable(url).subscribe((data) => {
        this.exist = true;
        this.eventsCalandarSalle = this.createEventsCalandar(
          data.filter((actionD) => {
            return actionD.avtAction_Code != this.action.avtAction_Code;
          }),
          false,
          'rgb(90, 92, 197)',
          'white'
        );
        this.refrechCalendarAction(null, null, false, null);
      });
    }
  }
  onSalleChangeFilter(value) {
    this.selectedSalleFilter = this.listeAllSalle.find((salle) => {
      return salle.DiverSys_Index == value;
    });
  }
  generateListeMatiereCursus() {
    this.dataSourceMatiere = [];
    for (var i = 0; i < this.listeMatiereCursus.length; i++) {
      var matiere = this.listeAllMatiere.DiverSys.find((allMatiere) => {
        return (
          allMatiere.DiverSys_Index == this.listeMatiereCursus[i].Matiere_Code
        );
      });
      var nbrHeurMatiere = 0;
      this.listeMatiereCursus[i]['matiereName'] = '';
      if (matiere != undefined) {
        var listeActionDByMatier = this.listeActionD.filter((actionD) => {
          return actionD.Cursus_Code == matiere.DiverSys_Index;
        });
        nbrHeurMatiere = this.actionsService.getNbrHeure(listeActionDByMatier);
        this.listeMatiereCursus[i]['matiereName'] = this.generalService.clone(
          matiere.DiverSys_Titre
        );
      }
      this.listeMatiereCursus[i]['salleName'] = '';
      var salle = this.listeAllSalle.find((allSalle) => {
        return (
          allSalle.DiverSys_Index ==
          this.listeMatiereCursus[i].CursusD_TypeSalle
        );
      });
      if (salle != undefined)
        this.listeMatiereCursus[i]['salleName'] = this.generalService.clone(
          salle.DiverSys_Titre
        );
      this.dataSourceMatiere.push({
        matiereName: this.listeMatiereCursus[i]['matiereName'],
        nbrHeur: nbrHeurMatiere,
        CursusD_Duree: this.listeMatiereCursus[i].CursusD_Duree,
      });
    }
    this.listeMatiereComponen.setDataSource(this.dataSourceMatiere);
    this.listeMatiereCursus = this.generalService.sort(
      this.listeMatiereCursus,
      'matiereName'
    );
  }
  getListeAllMatiere() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MAT01')
      .subscribe((data) => {
        this.listeAllMatiere = data;
        this.listeAllMatiereIsLoadet = true;
        this.getListeCursus();
      });
  }
  fillNewAvtActionTypeD(action) {
    action.avtActionTypeD = this.avtActionTypeD;
    // this.avtActionTypeD.forEach(newAvtActionTypeD =>
    // {
    //   var avtActionTypeD = action.avtActionTypeD.find(actionTypeD =>
    //   {
    //     var avtActionTypeD_date =this.dateService.convertStrToDate(this.dateService.setFormatDate(actionTypeD.avtActionTypeD_date)).getTime()
    //     var selectedDaysDate = newAvtActionTypeD.avtActionTypeD_date.getTime()
    //     return avtActionTypeD_date == selectedDaysDate && actionTypeD.avtActionType_Id == this.selectedTypePresence;
    //   })

    //   if(avtActionTypeD == undefined)
    //   {
    //     action.avtActionTypeD.push(newAvtActionTypeD);
    //   }
    // })
  }
  updateAvtActionTypeD(action) {
    var numberAction: number = 0;

    action.avtActionTypeD.forEach((avt_ActionTypeD) => {
      if (
        this.selectedTypePresence == avt_ActionTypeD.avtActionType_Id &&
        this.generalService.isNotEmpty(avt_ActionTypeD.avtActionTypeD_Id)
      ) {
        var selected_AvtActionTypeD = this.avtActionTypeD.find(
          (actionTypeD) => {
            var avtActionTypeD_date = actionTypeD.avtActionTypeD_date.getTime();
            var selectedDaysDate = this.dateService
              .convertStrToDate(
                this.dateService.setFormatDate(
                  avt_ActionTypeD.avtActionTypeD_date
                )
              )
              .getTime();
            return (
              avtActionTypeD_date == selectedDaysDate &&
              actionTypeD.avtActionType_Id == this.selectedTypePresence
            );
          }
        );
        this.exist = false;
        numberAction++;
        //update avtActionTypeD
        if (selected_AvtActionTypeD != undefined) {
          this.generalService
            .rechercheTable(
              globalUrls.urlAvtActionTypeD +
                '&val=' +
                avt_ActionTypeD.avtActionTypeD_Id
            )
            .subscribe(
              (updateAvtActionTypeD) => {
                updateAvtActionTypeD.avtActionTypeD[0].avtActionTypeD_heureDebAM =
                  this.typePresenceHeureDebAM;
                updateAvtActionTypeD.avtActionTypeD[0].avtActionTypeD_heureFinAM =
                  this.typePresenceHeureFinAM;
                updateAvtActionTypeD.avtActionTypeD[0].avtActionTypeD_heureDebPM =
                  this.typePresenceHeureDebPM;
                updateAvtActionTypeD.avtActionTypeD[0].avtActionTypeD_heureFinAM =
                  this.typePresenceHeureFinPM;
                this.generalService
                  .enregisterTable(updateAvtActionTypeD)
                  .subscribe(
                    () => {
                      numberAction--;
                      if (numberAction <= 0) {
                        this.generalService
                          .rechercheTable(
                            globalUrls.urlAction +
                              '&val=' +
                              this.action.avtAction_Code
                          )
                          .subscribe((action) => {
                            this.initAction = action;
                            this.typePresenceActionChange(false);
                            this.exist = true;
                          });
                      }
                      this.generalService.dialogSuccess('Enregistré', true);
                    },
                    (error) => {
                      this.generalService.dialogSuccess(
                        'Non enregistré',
                        false
                      );
                    }
                  );
              },
              (error) => {
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
        }
        //avtActionTypeD to delete
        else {
          this.generalService
            .supprimerSanMsgConfirm(
              avt_ActionTypeD.avtActionTypeD_Id,
              'avtActionTypeD'
            )
            .subscribe(
              () => {
                numberAction--;
                if (numberAction <= 0) {
                  this.generalService
                    .rechercheTable(
                      globalUrls.urlAction +
                        '&val=' +
                        this.action.avtAction_Code
                    )
                    .subscribe((action) => {
                      this.initAction = action;
                      this.typePresenceActionChange(false);
                      this.exist = true;
                    });
                }
                this.generalService.dialogSuccess('Supprimer', true);
              },
              (error) => {
                this.generalService.dialogSuccess('Non supprimer', false);
              }
            );
        }
      }
    });

    //find avtActionTypeD to delete and delete him
    // action.avtActionTypeD.forEach(AvtActionTypeDToDelete =>
    // {
    //   var findAvtActionTypeDToDelete = this.avtActionTypeD.find(avtActionTypeD =>
    //   {
    //     var date =this.dateService.convertStrToDate(this.dateService.setFormatDate(AvtActionTypeDToDelete.avtActionTypeD_date)).getTime();
    //     return avtActionTypeD.avtActionTypeD_date.getTime() == date && AvtActionTypeDToDelete.avtActionType_Id == avtActionTypeD.avtActionType_Id;
    //   });
    //   if(findAvtActionTypeDToDelete == undefined)
    //   {
    //     this.generalService.supprimerSanMsgConfirm(AvtActionTypeDToDelete.avtActionTypeD_Id,"avtActionTypeD").subscribe(()=>
    //     {
    //       this.generalService.dialogSuccess("Supprimer",true);
    //     },
    //     error =>
    //     {
    //       this.generalService.dialogSuccess("Non supprimer",false);
    //     });
    //   }
    // });
  }
  fillAvtActionTypeD(avtActionType_Id, avtActionTypeD_date) {
    this.avtActionTypeD.push({
      avtAction_Code: this.action.avtAction_Code,
      avtActionType_Id: avtActionType_Id,
      avtActionTypeD_date:
        this.dateService.convertStrToDate(avtActionTypeD_date),
      avtActionTypeD_heureDebAM: this.MatinTypePresenceChecked
        ? this.typePresenceHeureDebAM
        : '',
      avtActionTypeD_heureFinAM: this.MatinTypePresenceChecked
        ? this.typePresenceHeureFinAM
        : '',
      avtActionTypeD_heureDebPM: this.ApMidiTypePresenceChecked
        ? this.typePresenceHeureDebPM
        : '',
      avtActionTypeD_heureFinPM: this.ApMidiTypePresenceChecked
        ? this.typePresenceHeureFinPM
        : '',
      U_timestamp: null,
    });
  }
  setAvtActionTypeD() {
    this.avtActionTypeD = [];
    this.calmoisComponens.selectedDays.forEach((selectedDays) => {
      //action de formation
      if (this.typeAction == '0') {
        this.fillAvtActionTypeD(
          this.selectedTypePresence,
          selectedDays.strDate
        );
      }
      //action administrative
      if (this.typeAction == '1' || this.typeAction == '2') {
        this.typePresenceAction.forEach((type) => {
          this.fillAvtActionTypeD(
            type.avtActionType_Presence,
            selectedDays.strDate
          );
        });
      }
    });
  }
  calculerNbrHeurActionAdministrative(): number {
    var timeAm = 0;
    if (this.MatinChecked)
      timeAm = this.dateService.timeDif(
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM
      );
    var timePm = 0;
    if (this.ApMidiChecked)
      timePm = this.dateService.timeDif(
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      );
    return (timeAm + timePm) * this.initAction.avtActionTypeD.length;
  }
  blurClient(event) {
    this.action.Tiers_code = event;
    this.getClient();
  }
  blurCollaborateur(event) {
    this.action.Perso_Matricule = event;
  }
  //
  appliquerHeurJour(plageHaurere: NgForm) {
    if (plageHaurere.valid) {
      this.heureSemaine.forEach((heur) => {
        if (this.MatinChecked || this.ApMidiChecked) {
          heur.active = true;
          heur['disabled_amActive'] = false;
          heur['disabled_pmActive'] = false;
          if (this.MatinChecked) {
            heur.amActive = true;
          } else {
            heur.amActive = false;
            heur.amDebut = '';
            heur.amFin = '';
          }

          if (this.ApMidiChecked) {
            heur.pmActive = true;
          } else {
            heur.pmActive = false;
            heur.pmDebut = '';
            heur.pmFin = '';
          }
        } else {
          heur.active = false;
          heur.amActive = false;
          heur.pmActive = false;
          heur['disabled_amActive'] = true;
          heur['disabled_pmActive'] = true;
          this.onCheckboxchangeHeurSemaine({
            column: { TableRD_Champs: 'active' },
            row: heur,
          });
        }
        this.onCheckboxchangeHeurSemaine({
          column: { TableRD_Champs: 'amActive' },
          row: heur,
        });
        this.onCheckboxchangeHeurSemaine({
          column: { TableRD_Champs: 'pmActive' },
          row: heur,
        });
      });
      this.appliquerHeurJourByParam(
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM,
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      );
    }
  }
  appliquerHeurJourByParam(amDebut, amFin, pmDebut, pmFin) {
    this.heureSemaine.forEach((heur) => {
      if (heur.active) {
        if (heur.amActive) {
          heur.amDebut = amDebut;
          heur.amFin = amFin;
        }
        if (heur.pmActive) {
          heur.pmDebut = pmDebut;
          heur.pmFin = pmFin;
        }
        var event = { row: heur };
        this.calculerDurerHeurSemaine(event);
        heur = event.row;
      }
    });
  }
  calculerDurerHeurSemaine(event) {
    var amD, amF, pmD, pmF;
    amD = event.row['amDebut'];
    amF = event.row['amFin'];
    pmD = event.row['pmDebut'];
    pmF = event.row['pmFin'];
    event.row['durer'] = 0;
    if (
      this.generalService.isNotEmpty(amD) &&
      this.generalService.isNotEmpty(amF)
    )
      event.row['durer'] =
        this.dateService.timeToNumber(amF) - this.dateService.timeToNumber(amD);
    if (
      this.generalService.isNotEmpty(pmD) &&
      this.generalService.isNotEmpty(pmF)
    )
      event.row['durer'] +=
        this.dateService.timeToNumber(pmF) - this.dateService.timeToNumber(pmD);
    event.row['durer'] = formatNumber(event.row['durer'], 'fr', '1.0-2');
  }
  onInputHeurSemaine(event) {
    if (
      this.generalService.isNotEmpty(event.row[event.column.TableRD_Champs])
    ) {
      event.column.dataToShow = event.column.data.filter((val) => {
        return val.indexOf(event.row[event.column.TableRD_Champs]) >= 0;
      });
      if (event.column.dataToShow.length == 0)
        event.row[event.column.TableRD_Champs] = event.row[
          event.column.TableRD_Champs
        ].substr(0, event.row[event.column.TableRD_Champs].length - 1);
    } else event.column.dataToShow = event.column.data.slice();
    this.calculerDurerHeurSemaine(event);
  }
  onBlurHeurSemaine(event) {
    event.column.dataToShow = event.column.data.slice();
    event.row[event.column.TableRD_Champs] = this.dateService.setFormaTime(
      event.row[event.column.TableRD_Champs]
    );
    if (
      this.generalService.isNotEmpty(event.row[event.column.TableRD_Champs]) &&
      event.column.dataToShow.length > 0 &&
      event.column.dataToShow.find((time) => {
        return time == event.row[event.column.TableRD_Champs];
      }) == undefined
    ) {
      event.row[event.column.TableRD_Champs] = event.column.dataToShow[0];
    }
    var debut: number;
    var fin: number;
    if (
      event.column.TableRD_Champs == 'amDebut' ||
      event.column.TableRD_Champs == 'amFin'
    ) {
      debut = this.dateService.timeToNumber(event.row.amDebut);
      fin = this.dateService.timeToNumber(event.row.amFin);
    } //(event.column.TableRD_Champs == "pmDebut" || event.column.TableRD_Champs == "pmFin")
    else {
      debut = this.dateService.timeToNumber(event.row.pmDebut);
      fin = this.dateService.timeToNumber(event.row.pmFin);
    }
    if (debut > fin) {
      if (event.column.TableRD_Champs.indexOf('Debut') >= 0)
        event.row[event.column.TableRD_Champs] = event.column.dataToShow[0];
      else
        event.row[event.column.TableRD_Champs] =
          event.column.dataToShow[event.column.dataToShow.length - 1];
      this.generalService.dialogSuccess(
        "L'heure de début doit être inférieure à l'heure de fin",
        false
      );
    }
    if (this.generalService.isEmpty(event.row[event.column.TableRD_Champs])) {
      if (event.column.TableRD_Champs.indexOf('Debut') >= 0)
        event.row[event.column.TableRD_Champs] = event.column.dataToShow[0];
      else
        event.row[event.column.TableRD_Champs] =
          event.column.dataToShow[event.column.dataToShow.length - 1];
      this.generalService.dialogSuccess('Ce champ est requis', false);
    }
    this.calculerDurerHeurSemaine(event);
  }
  onCheckboxchangeHeurSemaine(event) {
    if (event.column.TableRD_Champs == 'active') {
      if (!event.row['active']) {
        event.row['disabled_amDebut'] = true;
        event.row['disabled_amFin'] = true;
        event.row['disabled_pmDebut'] = true;
        event.row['disabled_pmFin'] = true;
        event.row['disabled_amActive'] = true;
        event.row['disabled_pmActive'] = true;
        event.row['amActive'] = false;
        event.row['pmActive'] = false;
        event.row['amDebut'] = '';
        event.row['amFin'] = '';
        event.row['pmDebut'] = '';
        event.row['pmFin'] = '';
      } else {
        event.row['amActive'] = true;
        event.row['pmActive'] = true;

        event.row['disabled_amActive'] = false;
        event.row['disabled_pmActive'] = false;

        event.row['disabled_amDebut'] = false;
        event.row['disabled_amFin'] = false;
        event.row['disabled_pmDebut'] = false;
        event.row['disabled_pmFin'] = false;
        event.row['amDebut'] = this.paramHeure.avtHeureAM_Deb;
        event.row['amFin'] = this.paramHeure.avtHeureAM_Fin;
        event.row['pmDebut'] = this.paramHeure.avtHeurePM_Deb;
        event.row['pmFin'] = this.paramHeure.avtHeurePM_Fin;
      }
    }
    if (event.column.TableRD_Champs == 'amActive') {
      if (!event.row['amActive']) {
        event.row['disabled_amDebut'] = true;
        event.row['disabled_amFin'] = true;
        event.row['amDebut'] = '';
        event.row['amFin'] = '';
      } else {
        event.row['disabled_amDebut'] = false;
        event.row['disabled_amFin'] = false;
        event.row['amDebut'] = this.paramHeure.avtHeureAM_Deb;
        event.row['amFin'] = this.paramHeure.avtHeureAM_Fin;
      }
    }
    if (event.column.TableRD_Champs == 'pmActive') {
      if (!event.row['pmActive']) {
        event.row['disabled_pmDebut'] = true;
        event.row['disabled_pmFin'] = true;
        event.row['pmDebut'] = '';
        event.row['pmFin'] = '';
      } else {
        event.row['disabled_pmDebut'] = false;
        event.row['disabled_pmFin'] = false;
        event.row['pmDebut'] = this.paramHeure.avtHeurePM_Deb;
        event.row['pmFin'] = this.paramHeure.avtHeurePM_Fin;
      }
    }
    this.calculerDurerHeurSemaine(event);
  }
  outputActionListeHeurSemaineComponent(event) {
    switch (event.action) {
      case 'onBlur': {
        this.onBlurHeurSemaine(event);
        break;
      }
      case 'onInput': {
        this.onInputHeurSemaine(event);
        break;
      }
      case 'onInputKeyup': {
        this.calculerDurerHeurSemaine(event);
        break;
      }
      case 'onSelectionAutocompleteChanged': {
        this.calculerDurerHeurSemaine(event);
        break;
      }
      case 'onCheckboxChange': {
        this.onCheckboxchangeHeurSemaine(event);
        break;
      }
    }
  }
  calculerNbrHeurTypePresence(): number {
    var timeAm = 0;
    if (this.MatinTypePresenceChecked)
      timeAm = this.dateService.timeDif(
        this.typePresenceHeureDebAM,
        this.typePresenceHeureFinAM
      );
    var timePm = 0;
    if (this.ApMidiTypePresenceChecked)
      timePm = this.dateService.timeDif(
        this.typePresenceHeureDebPM,
        this.typePresenceHeureFinPM
      );
    return (timeAm + timePm) * this.calmoisComponens.selectedDays.length;
  }
  calculerNbrHeurTypePresenceEndSetDataSourceListeTypePresenceComponen() {
    if (this.intervaleHeureTypePresence.form.valid) {
      if (this.calmoisComponens.selectedDays.length > 0) {
        //action de formation
        if (this.typeAction == '0') {
          var findTypePresenceAction = this.typePresenceAction.find((type) => {
            return type.avtActionType_Id == this.selectedTypePresence;
          });
          if (findTypePresenceAction != undefined)
            findTypePresenceAction.avtActionType_NbHeure =
              this.calculerNbrHeurTypePresence();
          this.listeTypePresenceComponen.setDataSource(this.typePresenceAction);
        }
        //action administrative
        if (this.typeAction == '1' || this.typeAction == '2') {
          this.typePresenceAction.forEach((type) => {
            type.avtActionType_NbHeure =
              this.calculerNbrHeurActionAdministrative();
          });
        }
        this.setAvtActionTypeD();
      } else if (this.calmoisComponens.selectedDays.length == 0)
        this.generalService.dialogSuccess(
          'Veuillez sélectionner un ou plusieurs jours ',
          false
        );
    }
  }
  verifierHeureCursusPlanificationCalmois(): boolean {
    var findTypePresenceAction = this.typePresenceAction.find((type) => {
      return type.avtActionType_Id == this.selectedTypePresence;
    });
    if (
      findTypePresenceAction &&
      findTypePresenceAction.avtActionType_InclusHeureCours != 1
    )
      return true;
    var selectedCursus = this.listeCursus.find((cursus) => {
      return cursus.Cursus_Code == this.action.Cursus_Code;
    });
    if (selectedCursus != undefined) {
      var nbrHeur = this.calculerNbrHeurTypePresence();
      var somme = this.typePresenceAction
        .filter((typeP) => {
          return typeP.avtActionType_InclusHeureCours == 1;
        })
        .map((typeP) => typeP.avtActionType_NbHeure)
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      if (selectedCursus.Cursus_Duree >= somme + nbrHeur) {
        return true;
      } else {
        return false;
      }
    } else this.generalService.dialogSuccess('Erreur inattendue!', false);
    return false;
  }
  verifierHeurPlanificationCalmois(listeDay): boolean {
    var heurPlanificationCalmoisValide: boolean = true;
    listeDay.forEach((selectedDay) => {
      var heureS = this.heureSemaine.find((heur) => {
        return heur.id == selectedDay.date.getDay();
      });
      if (heureS) {
        if (this.MatinTypePresenceChecked) {
          if (
            !this.dateService.timeInclueDansInterval(
              this.typePresenceHeureDebAM,
              heureS.amDebut,
              heureS.amFin
            ) ||
            !this.dateService.timeInclueDansInterval(
              this.typePresenceHeureFinAM,
              heureS.amDebut,
              heureS.amFin
            )
          )
            heurPlanificationCalmoisValide = false;
        }
        if (this.ApMidiTypePresenceChecked) {
          if (
            !this.dateService.timeInclueDansInterval(
              this.typePresenceHeureDebPM,
              heureS.pmDebut,
              heureS.pmFin
            ) ||
            !this.dateService.timeInclueDansInterval(
              this.typePresenceHeureFinPM,
              heureS.pmDebut,
              heureS.pmFin
            )
          )
            heurPlanificationCalmoisValide = false;
        }
      } else {
        heurPlanificationCalmoisValide = false;
      }
    });
    return heurPlanificationCalmoisValide;
  }

  //enregitrement planification calmois
  verifierEndEnregistrerPlanificationCalmois() {
    //this.listeActionD
    this.closeAllMenuContectuelle();
    if (
      this.intervaleHeureTypePresence.form.valid &&
      (this.MatinTypePresenceChecked || this.ApMidiTypePresenceChecked)
    ) {
      var liste;
      var heurPlanificationCalmoisValide: boolean = true;
      //action de prestation
      if (this.typeAction == '2') {
        liste = this.convertAvtactiondToAvtActionTypeD(this.avtactionDCol);
        heurPlanificationCalmoisValide = this.verifierHeurPlanificationCalmois(
          this.calmoisComponens.selectedDays
        );
      } else liste = this.initAction.avtActionTypeD;
      //les heurs de planification son valide (inclue dans plage horaire)
      if (heurPlanificationCalmoisValide) {
        var resulta = this.verifierHeurTypePresenceDEnConflie(
          liste,
          this.MatinTypePresenceChecked,
          this.typePresenceHeureDebAM,
          this.typePresenceHeureFinAM,
          this.ApMidiTypePresenceChecked,
          this.typePresenceHeureDebPM,
          this.typePresenceHeureFinPM
        );
        //aucin date en confli
        if (resulta == '') {
          //action de formatin
          if (this.typeAction == '0') {
            if (this.verifierHeureCursusPlanificationCalmois()) {
              this.enregistrerPlanificationCalmois();
            } else {
              this.openAvtDialogDelete();
            }
          }
          //action administrative ou de prestation
          if (this.typeAction == '1' || this.typeAction == '2') {
            if (this.calmoisComponens.selectedDays.length > 0) {
              //action administrative
              if (this.typeAction == '1')
                this.enregistrerPlanificationCalmois();
              //action de prestation
              else {
                var listeActionD = [];
                this.calmoisComponens.selectedDays.forEach((selectedDays) => {
                  listeActionD.push(
                    this.createJsonActionD(
                      null,
                      this.action.avtAction_Code,
                      this.typeActionD,
                      this.dateService.setToFormatDateServerStr2(
                        selectedDays.strDate
                      ),
                      this.typePresenceHeureDebAM,
                      this.typePresenceHeureFinAM,
                      this.typePresenceHeureDebPM,
                      this.typePresenceHeureFinPM,
                      this.actionDIntitule,
                      this.collaborateurCalendrierActionComponent
                        .valueColonneToReturn,
                      null,
                      null,
                      null,
                      null
                    )
                  );
                });
                this.enregistrerActionDForActionPrestation(listeActionD);
              }
            }
          }
        } else
          this.generalService.dialogSuccess(
            'Conflit de planning dans: ' + resulta,
            false
          );
      } else
        this.generalService.dialogSuccess(
          "les heures de planification sont en dehors de la plage horaire de l'action",
          false
        );
    } else {
      $('#btnIntervaleHeureTypePresence').trigger('click');
      this.generalService.dialogSuccess(
        'Veuillez saisir les informations de planification',
        false
      );
    }
  }
  enregistrerActionDForActionPrestation(avtactionD) {
    var actionD = { avtactionD: [] };

    actionD.avtactionD = avtactionD;
    this.exist = false;
    this.generalService.enregisterTable(actionD).subscribe(() => {
      this.generalService.dialogSuccess('Enregistré', true);
      this.generalService
        .rechercheTable(globalUrls.urlActionD + this.param_code)
        .subscribe((data) => {
          this.listeActionD = data.avtactionD;
          this.fillAvtActionTypeDToCalmois(
            this.convertAvtactiondToAvtActionTypeD(this.listeActionD)
          );
          this.setDataSourceListeCollaborateur();
          this.exist = true;
        });
    });
  }
  verifierHeurTypePresenceDEnConflie(
    avtActionTypeD,
    MatinTypePresenceChecked,
    typePresenceHeureDebAM,
    typePresenceHeureFinAM,
    ApMidiTypePresenceChecked,
    typePresenceHeureDebPM,
    typePresenceHeureFinPM,
    selectedAvtActionTypeD = ''
  ): string {
    var nbrTypePresenceEnConflie: string = '';
    this.calmoisComponens.selectedDays.forEach((selectedDays) => {
      var date = this.dateService.convertStrToDate(selectedDays.strDate);
      var listeAvtActionTypeD = avtActionTypeD.filter((ActionTypeD) => {
        return (
          this.dateService.setFormatDate(ActionTypeD.avtActionTypeD_date) ==
            selectedDays.strDate &&
          ActionTypeD.avtActionTypeD_Id != selectedAvtActionTypeD
        );
      });
      listeAvtActionTypeD.forEach((avtActionTypeD) => {
        var dateDeburAmSelectedDays,
          dateFinAmSelectedDays,
          dateDeburPmSelectedDays,
          dateFinPmSelectedDays,
          avtActionTypeD_heureDebAM,
          avtActionTypeD_heureFinAM,
          avtActionTypeD_heureDebPM,
          avtActionTypeD_heureFinPM;
        if (
          MatinTypePresenceChecked &&
          this.dateService.timeToNumber(
            avtActionTypeD.avtActionTypeD_heureDebAM
          ) > 0 &&
          this.dateService.timeToNumber(
            avtActionTypeD.avtActionTypeD_heureFinAM
          ) > 0
        ) {
          dateDeburAmSelectedDays = new Date(
            date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              typePresenceHeureDebAM
          );
          dateFinAmSelectedDays = new Date(
            date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              typePresenceHeureFinAM
          );
          avtActionTypeD_heureDebAM = new Date(
            this.dateService.setToFormatDateServerStr(
              avtActionTypeD.avtActionTypeD_date
            ) +
              ' ' +
              avtActionTypeD.avtActionTypeD_heureDebAM
          );
          avtActionTypeD_heureFinAM = new Date(
            this.dateService.setToFormatDateServerStr(
              avtActionTypeD.avtActionTypeD_date
            ) +
              ' ' +
              avtActionTypeD.avtActionTypeD_heureFinAM
          );
          if (
            this.dateService.intervaleDateInclueDansIntervaleDate(
              dateDeburAmSelectedDays,
              dateFinAmSelectedDays,
              avtActionTypeD_heureDebAM,
              avtActionTypeD_heureFinAM
            )
          ) {
            nbrTypePresenceEnConflie +=
              '  ' + avtActionTypeD.avtActionTypeD_date;
          }
        }
        if (ApMidiTypePresenceChecked) {
          dateDeburPmSelectedDays = new Date(
            date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              typePresenceHeureDebPM
          );
          dateFinPmSelectedDays = new Date(
            date.getFullYear() +
              '-' +
              (date.getMonth() + 1) +
              '-' +
              date.getDate() +
              ' ' +
              typePresenceHeureFinPM
          );
          avtActionTypeD_heureDebPM = new Date(
            avtActionTypeD.avtActionTypeD_date +
              ' ' +
              avtActionTypeD.avtActionTypeD_heureDebPM
          );
          avtActionTypeD_heureFinPM = new Date(
            avtActionTypeD.avtActionTypeD_date +
              ' ' +
              avtActionTypeD.avtActionTypeD_heureFinPM
          );
          if (
            this.dateService.intervaleDateInclueDansIntervaleDate(
              dateDeburPmSelectedDays,
              dateFinPmSelectedDays,
              avtActionTypeD_heureDebPM,
              avtActionTypeD_heureFinPM
            )
          ) {
            nbrTypePresenceEnConflie +=
              '  ' + avtActionTypeD.avtActionTypeD_date;
          }
        }
      });
    });
    return nbrTypePresenceEnConflie;
  }
  //remove From AvtActionTypeD Null Row
  removeFromAvtActionTypeDNullRow(action) {
    action.avtActionTypeD = action.avtActionTypeD.filter((avtActionTypeD) => {
      return this.generalService.isNotEmpty(avtActionTypeD.avtActionType_Id);
    });
  }
  enregistrerPlanificationCalmois() {
    this.calculerNbrHeurTypePresenceEndSetDataSourceListeTypePresenceComponen();
    this.exist = false;
    this.generalService
      .rechercheTable(
        globalUrls.urlAction + '&val=' + this.action.avtAction_Code
      )
      .subscribe(
        (action) => {
          this.removeFromAvtActionTypeDNullRow(action);
          this.fillTypePresenceToAction(action);
          this.fillNewAvtActionTypeD(action);
          this.formaterDateAction(action);
          this.generalService
            .enregisterTable(
              this.generalService.supprimerTableVideAction(
                action,
                this.tabProperty,
                'avtAction_Code'
              )
            )
            .subscribe(
              () => {
                //this.updateAvtActionTypeD(action);
                this.generalService
                  .rechercheTable(
                    globalUrls.urlAction + '&val=' + this.action.avtAction_Code
                  )
                  .subscribe((action) => {
                    this.initAction = action;
                    this.typePresenceActionChange(false);
                    //action administraive
                    if (this.typeAction == '1')
                      this.setDataListeCollaborateurComponen();
                    this.exist = true;

                    //pour le menu de duplication de planification
                    this.setListMonth();
                  });
                this.generalService.dialogSuccess('Enregistré', true);
              },
              (error) => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
        },
        (error) => {
          this.exist = true;
          this.generalService.dialogSuccess('Non enregistré', false);
        }
      );
  }
  convertTypeAvtActionType_FacturableToNumber(listeTypePresence) {
    for (var i = 0; i < listeTypePresence.length; i++) {
      listeTypePresence[i].avtActionType_Facturable = listeTypePresence[i]
        .avtActionType_Facturable
        ? 1
        : 0;
      listeTypePresence[i].avtActionType_Planifiable = listeTypePresence[i]
        .avtActionType_Planifiable
        ? 1
        : 0;
      listeTypePresence[i].avtActionType_InclusHeureCours = listeTypePresence[i]
        .avtActionType_InclusHeureCours
        ? 1
        : 0;
    }
    return listeTypePresence;
  }
  formaterDateAction(action) {
    if (this.generalService.isNotEmpty(action.avtaction[0].avtAction_dateDeb)) {
      action.avtaction[0].avtAction_dateDeb =
        this.dateService.setToFormatDateServerStr(
          action.avtaction[0].avtAction_dateDeb
        );
    }
    if (this.generalService.isNotEmpty(action.avtaction[0].avtAction_dateFin)) {
      action.avtaction[0].avtAction_dateFin =
        this.dateService.setToFormatDateServerStr(
          action.avtaction[0].avtAction_dateFin
        );
    }
    if (
      this.generalService.isNotEmpty(action.avtActionTypeD) &&
      action.avtActionTypeD.length > 0
    ) {
      action.avtActionTypeD.forEach((avtActionTypeD) => {
        if (this.generalService.isNotEmpty(avtActionTypeD.avtActionTypeD_date))
          avtActionTypeD.avtActionTypeD_date =
            this.dateService.setToFormatDateServerStr(
              avtActionTypeD.avtActionTypeD_date
            );
      });
      action.avtaction[0].avtAction_dateFin =
        this.dateService.setToFormatDateServerStr(
          action.avtaction[0].avtAction_dateFin
        );
    }
  }
  genererAvtAPH(action) {
    if (this.typeTrs == '1' || this.generalService.isEmpty(action.avtAPH)) {
      action.avtAPH = [];
      this.listeHeurSemaineComponent.dataSource.data.forEach((heurS) => {
        action.avtAPH.push({
          U_timestamp: null,
          avtAPH_DebAM: heurS.amDebut,
          avtAPH_DebPM: heurS.pmDebut,
          avtAPH_FinAM: heurS.amFin,
          avtAPH_FinPM: heurS.pmFin,
          avtAPH_Jour: heurS.id,
          avtAction_Code: action.avtaction[0].avtAction_Code,
          id: null,
        });
      });
    } else {
      this.listeHeurSemaineComponent.dataSource.data.forEach((heurS) => {
        var plageH = action.avtAPH.find((ph) => {
          return ph.avtAPH_Jour == heurS.id;
        });
        if (plageH) {
          plageH.avtAPH_DebAM = heurS.amDebut ? heurS.amDebut : '';
          plageH.avtAPH_DebPM = heurS.pmDebut ? heurS.pmDebut : '';
          plageH.avtAPH_FinAM = heurS.amFin ? heurS.amFin : '';
          plageH.avtAPH_FinPM = heurS.pmFin ? heurS.pmFin : '';
        }
      });
    }
    return action;
  }
  enregistrerTabsInformationAction() {
    if (this.typeTrs == '1') {
      this.exist = false;
      // action de formation
      if (this.typeAction == '0') {
        var listeTypePresence = this.generalService.clone(
          this.typePresenceAction
        );
        this.initAction.avtActionType =
          this.removeAttributDiverSys_TitreFromJson(listeTypePresence);
        this.initAction.avtActionType =
          this.convertTypeAvtActionType_FacturableToNumber(listeTypePresence);
      }
      this.formaterDateAction(this.initAction);

      this.generalService
        .enregisterTable(
          this.generalService.supprimerTableVideAction(
            this.initAction,
            this.tabProperty,
            'avtAction_Code'
          )
        )
        .subscribe(
          (action) => {
            this.typeTrs = '2';
            this.param_code = action.code;
            this.action.avtAction_Code = action.code;
            this.enregistrerGroupeApprenantAndPlageHaurere(
              this.action.avtAction_Code
            );
            this.refrechTypePresenceAction();
          },
          (error) => {
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
    }
    if (this.typeTrs == '2') {
      if (this.initActionStr != JSON.stringify(this.initAction)) {
        this.exist = false;
        this.generalService
          .rechercheTable(
            globalUrls.urlAction + '&val=' + this.action.avtAction_Code
          )
          .subscribe(
            (myAction) => {
              this.fillInformationAction(myAction);
              this.formaterDateAction(myAction);
              this.generalService
                .enregisterTable(
                  this.generalService.supprimerTableVideAction(
                    myAction,
                    this.tabProperty,
                    'avtAction_Code'
                  )
                )
                .subscribe(
                  (action) => {
                    this.initActionStr = JSON.stringify(myAction);
                    this.exist = true;
                    this.generalService.dialogSuccess('enregistré', true);
                  },
                  (error) => {
                    this.generalService.dialogSuccess('Non enregistré', false);
                  }
                );
            },
            (error) => {
              this.exist = true;
              this.generalService.dialogSuccess('Non enregistré', false);
            }
          );
      }
      this.enregistrerGroupeApprenantAndPlageHaurere(
        this.action.avtAction_Code
      );
    }
  }
  refrechTypePresenceAction() {
    this.generalService
      .rechercheTable(
        globalUrls.urlAction + '&val=' + this.action.avtAction_Code
      )
      .subscribe((action) => {
        this.typePresenceAction = action.avtActionType;
        this.generateTypePresenceAction();
      });
  }

  fillTypePresenceToAction(typePresence) {
    typePresence.avtActionType.forEach((type) => {
      var findType = this.typePresenceAction.find((typeP) => {
        return typeP.avtActionType_Id == type.avtActionType_Id;
      });
      if (findType != undefined) {
        type.avtActionType_NbHeure = findType.avtActionType_NbHeure;
        type.avtActionType_Facturable = findType.avtActionType_Facturable
          ? 1
          : 0;
        type.avtActionType_Planifiable = findType.avtActionType_Planifiable
          ? 1
          : 0;
        type.avtActionType_InclusHeureCours =
          findType.avtActionType_InclusHeureCours ? 1 : 0;
      }
    });
  }
  fillInformationAction(data) {
    data.avtaction[0].avtAction_Type = this.action.avtAction_Type;
    data.avtaction[0].avtAction_Intitule = this.action.avtAction_Intitule;
    data.avtaction[0].Cursus_Code = this.action.Cursus_Code;
    data.avtaction[0].avtAction_dateDeb = this.action.avtAction_dateDeb;
    data.avtaction[0].avtAction_dateFin = this.action.avtAction_dateFin;
    data.avtaction[0].avtAction_heureDebAM = this.action.avtAction_heureDebAM;
    data.avtaction[0].avtAction_heureFinAM = this.action.avtAction_heureFinAM;
    data.avtaction[0].avtAction_heureDebPM = this.action.avtAction_heureDebPM;
    data.avtaction[0].avtAction_heureFinPM = this.action.avtAction_heureFinPM;
    data.avtaction[0].avtAction_ModFormation =
      this.action.avtAction_ModFormation;
    data.avtaction[0].avtAction_Commentaire = this.action.avtAction_Commentaire;
    data.avtaction[0].avtAction_Groupe = this.action.avtAction_Groupe;
    data.avtaction[0].Perso_Matricule = this.action.Perso_Matricule;
    data.avtaction[0].Tiers_code = this.action.Tiers_code;
  }
  // planifierCalmois()
  // {
  //   this.closeAllMenuContectuelle();
  //   if(this.verifierTypePresenceHaveHeure())
  //   {
  //     this.exist = false;
  //     this.generalService.enregisterTable(this.initAction).subscribe(action =>
  //     {
  //     },
  //     error =>
  //     {
  //       this.generalService.dialogSuccess("Non enregistré",false)
  //     })
  //   }
  //   else
  //   this.generalService.dialogSuccess("Veuillez choisir au moins un type de présence et indiquer les horaires matins et après midi et appuie sur le bouton calculer Nbr heure",false)
  // }
  removeAttributDiverSys_TitreFromJson(listeTypePresence) {
    for (var i = 0; i < listeTypePresence.length; i++) {
      delete listeTypePresence[i].DiverSys_Titre;
      listeTypePresence[i]['U_timestamp'] = null;
    }
    return listeTypePresence;
  }
  enregistrerGroupeApprenantAndPlageHaurere(avtAction_Code) {
    this.generalService
      .rechercheTable(globalUrls.urlAction + '&val=' + avtAction_Code)
      .subscribe(
        (action) => {
          var property = 'Perso_Matricule';
          if (this.typeAction == '2') {
            property = 'User_Id';
          }
          var avtActionReferentToDelet = [];
          action.avtActionReferent.forEach((apprenant) => {
            if (
              this.listeApprenantGroupeComponen.dataSource.data.find((ref) => {
                return ref[property] == apprenant[property];
              }) == undefined
            )
              avtActionReferentToDelet.push(apprenant);
          });
          avtActionReferentToDelet.forEach((ref) => {
            if (ref.avtActionReferent_Id)
              this.generalService
                .supprimerSanMsgConfirm(
                  ref.avtActionReferent_Id,
                  'avtActionReferent'
                )
                .subscribe(
                  (data) => {
                    this.generalService.dialogSuccess('Élément supprimé', true);
                  },
                  (error) => {
                    this.generalService.dialogSuccess(
                      'Élément non supprimé',
                      false
                    );
                  }
                );
          });
          var avtActionReferentToAdd = [];
          this.listeApprenantGroupeComponen.dataSource.data.forEach(
            (apprenant) => {
              if (
                action.avtActionReferent.find((ref) => {
                  return ref[property] == apprenant[property];
                }) == undefined
              )
                if (this.typeAction == '2')
                  avtActionReferentToAdd.push({
                    User_Id: apprenant[property],
                    U_timestamp: null,
                    avtAction_Code: avtAction_Code,
                  });
                else
                  avtActionReferentToAdd.push({
                    Perso_Matricule: apprenant[property],
                    U_timestamp: null,
                    avtAction_Code: avtAction_Code,
                  });
            }
          );
          this.formaterDateAction(action);
          action.avtActionReferent = avtActionReferentToAdd;
          //action administrative
          // if(this.typeAction == "1" && this.typeTrs == "2")
          //   this.updateAvtActionReferent(action)
          action = this.generalService.supprimerTableVideAction(
            action,
            this.tabProperty,
            'avtAction_Code'
          );
          var actionStr = JSON.stringify(action);
          //action de prestation

          if (this.typeAction == '2') {
            action = this.genererAvtAPH(action);
          }
          if (
            actionStr != JSON.stringify(action) ||
            avtActionReferentToAdd.length > 0
          ) {
            this.exist = false;
            this.generalService.enregisterTable(action).subscribe(
              (action) => {
                this.exist = true;
                this.generalService.dialogSuccess('enregistré', true);
              },
              (error) => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          }
        },
        (error) => {
          this.exist = true;
          this.generalService.dialogSuccess('Non enregistré', false);
        }
      );
  }
  setEventsCalandarModification(editable) {
    var listeSelectedAvtActionTypeD_date =
      this.calmoisComponens.selectedDays.map((day) => {
        return day.strDate;
      });
    var listeSelectedAvtActionTypeD_dateStr =
      ';' +
      listeSelectedAvtActionTypeD_date.reduce((a, b) => {
        return a + ';' + b;
      }) +
      ';';
    var listeToUpdate = this.initAction.avtActionTypeD.filter((actionTypeD) => {
      return (
        listeSelectedAvtActionTypeD_dateStr.indexOf(
          ';' +
            this.dateService.setFormatDate(actionTypeD.avtActionTypeD_date) +
            ';'
        ) >= 0
      );
    });
    if (this.typeAction == '2') {
      listeToUpdate = this.convertAvtactiondToAvtActionTypeD(
        this.listeActionD.filter((actionD) => {
          return (
            listeSelectedAvtActionTypeD_dateStr.indexOf(
              ';' +
                this.dateService.setFormatDate(actionD.avtActionD_date) +
                ';'
            ) >= 0
          );
        })
      );
    }
    this.listeAvtActionTypeD = listeToUpdate;
    this.listeAvtActionTypeD = this.generalService.sort(
      this.listeAvtActionTypeD,
      'avtActionTypeD_date'
    );
    this.dateDebutModification = new Date(
      this.listeAvtActionTypeD[0].avtActionTypeD_date
    );
    this.dateFinModification = new Date(
      this.listeAvtActionTypeD[
        this.listeAvtActionTypeD.length - 1
      ].avtActionTypeD_date
    );
    this.eventsCalandarModification = this.createEventsCalandar2(
      this.listeAvtActionTypeD,
      editable,
      this.getTypeAction().avtParamAction_ColorAction,
      this.getTypeAction().avtParamAction_ColorText
    );
    this.calendarModificationActionComponent.setEventCalandar(
      this.eventsCalandarModification
    );
  }
  modifierPlanificationCalmois(frm, mode) {
    this.showCalendarActionModification = false;
    this.actionPlanification = mode;
    var editable = true;
    var listeSelectedAvtActionTypeD_date =
      this.calmoisComponens.selectedDays.map((day) => {
        return day.strDate;
      });
    var listeSelectedAvtActionTypeD_dateStr =
      ';' +
      listeSelectedAvtActionTypeD_date.reduce((a, b) => {
        return a + ';' + b;
      }) +
      ';';
    var listeToUpdate = this.initAction.avtActionTypeD.filter((actionTypeD) => {
      return (
        listeSelectedAvtActionTypeD_dateStr.indexOf(
          ';' +
            this.dateService.setFormatDate(actionTypeD.avtActionTypeD_date) +
            ';'
        ) >= 0
      );
    });
    if (this.typeAction == '2') {
      editable = false;
      listeToUpdate = this.avtActionTypeDCalmoi.filter((actionD) => {
        var date =
          ';' +
          this.dateService.setFormatDate(actionD.avtActionTypeD_date) +
          ';';
        var strDate = listeSelectedAvtActionTypeD_dateStr.indexOf(date);
        return strDate >= 0;
      });
    }
    this.closeAllMenuContectuelle();
    this.selectedAvtActionTypeD = '';

    this.listeAvtActionTypeD = listeToUpdate;
    this.listeAvtActionTypeD = this.generalService.sort(
      this.listeAvtActionTypeD,
      'avtActionTypeD_date'
    );
    if (mode == 'Suppression')
      this.genererlisteAvtActionTypeD(this.listeAvtActionTypeD);
    else if (mode == 'Modification') {
      this.dateDebutModification = new Date(
        this.listeAvtActionTypeD[0].avtActionTypeD_date
      );
      var dateFinModification = new Date(
        this.listeAvtActionTypeD[
          this.listeAvtActionTypeD.length - 1
        ].avtActionTypeD_date
      );
      dateFinModification.setDate(dateFinModification.getDate() + 1);
      this.dateFinModification = dateFinModification;
      this.eventsCalandarModification = this.createEventsCalandar2(
        this.listeAvtActionTypeD,
        editable,
        this.getTypeAction().avtParamAction_ColorAction,
        this.getTypeAction().avtParamAction_ColorText
      );
      setTimeout(() => {
        this.showCalendarActionModification = true;
      }, 100);
    }
    this.dialogModifierPlanificationCalmois = this.generalService.dialog.open(
      frm,
      new MatDialogConfig()
    );

    // }
    // else
    // this.generalService.dialogSuccess(message,false)
  }

  onSelectedAvtActionTypeDChange() {
    var avtActionTypeD = this.initAction.avtActionTypeD.find(
      (avtActionTypeD) => {
        return avtActionTypeD.avtActionTypeD_Id == this.selectedAvtActionTypeD;
      }
    );
    if (avtActionTypeD) {
      if (
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureDebAM
        ) &&
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureFinAM
        ) &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureDebAM
        ) > 0 &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureFinAM
        ) > 0
      ) {
        this.typePresenceHeureDebAM2 = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureDebAM
        );
        this.typePresenceHeureFinAM2 = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureFinAM
        );
        this.MatinTypePresenceChecked2 = true;
      } else {
        this.MatinTypePresenceChecked2 = false;
        this.typePresenceHeureDebAM2 = '';
        this.typePresenceHeureFinAM2 = '';
      }

      if (
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureDebPM
        ) &&
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureFinPM
        ) &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureDebPM
        ) > 0 &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureFinPM
        ) > 0
      ) {
        this.typePresenceHeureDebPM2 = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureDebPM
        );
        this.typePresenceHeureFinPM2 = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureFinPM
        );
        this.ApMidiTypePresenceChecked2 = true;
      } else {
        this.ApMidiTypePresenceChecked2 = false;
        this.typePresenceHeureDebPM2 = '';
        this.typePresenceHeureFinPM2 = '';
      }
    }
  }
  genererlisteAvtActionTypeD(listeAvtActionTypeD) {
    listeAvtActionTypeD.forEach((avtActionTypeD) => {
      var str = '';
      // demi journer Am exixte
      if (
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureDebAM
        ) &&
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureFinAM
        ) &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureDebAM
        ) > 0 &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureFinAM
        ) > 0
      ) {
        str +=
          this.dateService.setFormaTime(
            avtActionTypeD.avtActionTypeD_heureDebAM
          ) +
          ' -> ' +
          this.dateService.setFormaTime(
            avtActionTypeD.avtActionTypeD_heureFinAM
          );
        this.MatinTypePresenceChecked = true;
        this.typePresenceHeureDebAM = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureDebAM
        );
        this.typePresenceHeureFinAM = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureFinAM
        );
      }

      // demi journer Pm exixte
      if (
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureDebPM
        ) &&
        this.generalService.isNotEmpty(
          avtActionTypeD.avtActionTypeD_heureFinPM
        ) &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureDebPM
        ) > 0 &&
        this.dateService.setFormaTimeCalendar(
          avtActionTypeD.avtActionTypeD_heureFinPM
        ) > 0
      ) {
        str +=
          ' ' +
          this.dateService.setFormaTime(
            avtActionTypeD.avtActionTypeD_heureDebPM
          ) +
          ' -> ' +
          this.dateService.setFormaTime(
            avtActionTypeD.avtActionTypeD_heureFinPM
          );
        this.ApMidiTypePresenceChecked = true;
        this.typePresenceHeureDebPM = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureDebPM
        );
        this.typePresenceHeureFinPM = this.dateService.setFormaTime(
          avtActionTypeD.avtActionTypeD_heureFinPM
        );
      }
      avtActionTypeD['text'] = str;
    });
    this.generalService.sort(this.listeAvtActionTypeD, 'text');
  }
  suivantPresedent(action: number) {
    if (this.index + action > -1) {
      this.index += action;
      this.tabChanged({ event: this.index });
    }
  }

  verifierTypePresenceHaveHeure() {
    var i = 0;
    for (
      var i = 0;
      i < this.listeTypePresenceComponen.dataSource.data.length;
      i++
    ) {
      if (
        this.listeTypePresenceComponen.dataSource.data[i]
          .avtActionType_NbHeure > 0
      )
        return true;
    }
    return false;
  }
  deselectionnerTable() {
    this.listeFactureComponen.deselectTable();
    this.listeDevisComponen.deselectTable();
  }
  tabChanged(event) {
    //action prestation
    if (this.typeAction == '2') {
      this.collaborateurCalendrierActionComponent.valueColonneToReturn = '';
      this.collaborateurCalendrierActionComponent.parentVal = '';
      this.deselectionnerTable();
    }
    // j'ai fait l'appel de cette fonction ici pour alléger le chargemnt du page au moment du première chargement
    if (this.typeAction != '2') this.getListeSalles();
    if (event.index > this.oldIndex && !this.disabled) {
      //if(event.index < 2)
      {
        // verification information Action
        if (!this.informationAction.form.valid) {
          this.index = this.generalService.clone(this.oldIndex);
          this.generalService.dialogSuccess(
            'SVP remplir tous les champs',
            false
          );
          return;
        }
        //verification Calendrier calmois action
        if (this.typeAction == '0' && !this.verifierTypePresenceHaveHeure()) {
          $('#btnIntervaleHeureTypePresence').trigger('click');
          this.index = this.generalService.clone(this.oldIndex);
          this.generalService.dialogSuccess(
            'Veuillez choisir au moins un type de présence et indiquer les horaires matins et après midi et appuie sur le bouton calculer Nbr heure',
            false
          );
          return;
        }
      }
      //calmois
      if (event.index == 1) {
        // verification information Action
        if (
          !this.informationAction.form.valid ||
          this.listeApprenantGroupeComponen.dataSource.data.length == 0
        ) {
          this.index = this.generalService.clone(this.oldIndex);
          this.generalService.dialogSuccess(
            'Veuillez remplir tous les champs et sélectionner au moins un apprenant',
            false
          );
          return;
        }
      }
      if (this.oldIndex == 0 && this.informationAction.form.valid)
        this.enregistrerTabsInformationAction();
      // if(this.oldIndex == 1 && this.verifierTypePresenceHaveHeure())
      //   this.enregistrerTabsCalendrierAction();
    }
    //bon de commande
    if (event.index == 3) {
      //action de formation
      if (this.typeAction == '0')
        if (
          this.listeModeFacturationIsLoadet &&
          this.listeTvaIsLoadet &&
          this.listeModePaiementIsLoadet &&
          this.listeDelaiReglementIsLoadet
        ) {
          this.generateListeFinanceurByAppreant();
        } else {
          this.index = this.generalService.clone(this.oldIndex);
          this.generalService.dialogSuccess(
            'Veuillez patienter pendant le chargement total des données',
            false
          );
        }
    }
    //pour charger calmois en mode consultation
    // if(event.index > this.oldIndex && this.disabled && event.index == 1)
    //   this.initCalmoi()
  }

  animationDone() {
    if (this.index == 2) {
      this.refrechCalendarAction(
        this.action.avtAction_dateDeb,
        this.action.avtAction_dateFin,
        true,
        this.action.avtAction_dateDeb
      );
      this.showCalendarAction = true;
      if (this.listMonth.length > 0)
        setTimeout(() => {
          this.setListWeek(this.listMonth[0], 0);
        }, 100);
    }
    if (this.index == 5 || (this.typeAction == '1' && this.index == 2)) {
      this.showDoc = true;
    }
    if (this.index == 1) {
      // action non administrative

      setTimeout(() => {
        if (this.typeAction != '2') this.typePresenceActionChange(true);
        else {
          this.fillAvtActionTypeDToCalmois(
            this.convertAvtactiondToAvtActionTypeD(this.listeActionD)
          );
          this.setDataSourceListeCollaborateur();
          this.formaterHeurTypePresence();
        }
      }, 100);
    }
  }
  setDataSourceListeCollaborateur() {
    var listeDistinctCollaborateur = this.generalService.distinct(
      this.listeActionD,
      'Perso_Matricule'
    );
    var dataSourseListeCollaborateurComponen = [];
    listeDistinctCollaborateur.forEach((Perso_Matricule) => {
      var collaborateur = this.listeCollaborateur.find((col) => {
        return col.Perso_Matricule == Perso_Matricule;
      });
      if (collaborateur)
        collaborateur =
          collaborateur.Perso_Nom + ' ' + collaborateur.Perso_Prenom;
      else collaborateur = Perso_Matricule;
      var listeActionDColl = this.listeActionD.filter((actionD) => {
        return actionD.Perso_Matricule == Perso_Matricule;
      });
      dataSourseListeCollaborateurComponen.push({
        Perso_Nom: collaborateur,
        total: this.actionsService.getNbrHeure(listeActionDColl),
      });
    });
    this.listeCollaborateurComponen.setDataSource(
      dataSourseListeCollaborateurComponen
    );
  }
  setOldIndex(event) {
    this.oldIndex = this.index;
    $('#btnInformationActionD').trigger('click');
    $('#btnInformationAction').trigger('click');
  }
  setListeTypeAction() {
    this.generalService
      .rechercheTable(globalUrls.urlListeParamAction)
      .subscribe((paramAction) => {
        this.listeTypeAction = this.generalService.sort(
          paramAction.filter((type) => {
            return type.avtParamAction_Default == this.typeAction;
          }),
          'avtParamAction_Description'
        );
        this.eventsCalandarAction = this.createEventsCalandar(
          this.listeActionD,
          !this.disabled,
          this.getTypeAction().avtParamAction_ColorAction,
          this.getTypeAction().avtParamAction_ColorText
        );
      });
  }
  getListeCursus() {
    this.generalService
      .rechercheTable(globalUrls.urlListeApplyCursus)
      .subscribe(
        (cursus) => {
          this.exist = true;
          this.listeCursus = this.generalService.sort(cursus, 'Cursus_Titre');
          this.onCursusChange();
        },
        (error) => {
          this.exist = true;
        }
      );
  }
  ActionHeurePMBlur(event, champ) {
    this.filterdTimePm = this.timePm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdTimePm.length > 0 &&
      this.filterdTimePm.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdTimePm[0];
    }
    eval(champ + "='" + event.target.value + "'");
    setTimeout(() => {
      var valeur;
      eval('valeur = ' + champ);
      if (this.generalService.isNotEmpty(valeur))
        this.ApMidiTypePresenceChecked = true;
    }, 100);
  }
  timePMchange(event) {
    if (this.generalService.isNotEmpty(event.target.value)) {
      this.filterdTimePm = this.timePm.filter((val) => {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTimePm.length == 0)
        event.target.value = event.target.value.substr(
          0,
          event.target.value.length - 1
        );
    } else this.filterdTimePm = this.timePm.slice();
  }
  ActionHeureAMBlur(event, champ) {
    this.filterdTimeAm = this.timeAm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdTimeAm.length > 0 &&
      this.filterdTimeAm.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdTimeAm[0];
    }
    eval(champ + "='" + event.target.value + "'");
  }
  timeAMchange(event) {
    if (this.generalService.isNotEmpty(event.target.value)) {
      this.filterdTimeAm = this.timeAm.filter((val) => {
        return val.indexOf(event.target.value) >= 0;
      });
      if (this.filterdTimeAm.length == 0)
        event.target.value = event.target.value.substr(
          0,
          event.target.value.length - 1
        );
    } else this.filterdTimeAm = this.timeAm.slice();
  }
  HeureTypePresenceAMBlur(event, champ) {
    this.filterdTimeAm = this.timeAm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdTimeAm.length > 0 &&
      this.filterdTimeAm.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdTimeAm[0];
    }
    eval('this.' + champ + " = '" + event.target.value + "'");
    setTimeout(() => {
      var valeur;
      eval('valeur = this.' + champ);
      if (this.generalService.isNotEmpty(valeur))
        this.MatinTypePresenceChecked = true;
    }, 100);
  }
  HeureTypePresencePMBlur(event, champ) {
    this.filterdTimePm = this.timePm.slice();
    event.target.value = this.dateService.setFormaTime(event.target.value);
    if (
      this.generalService.isNotEmpty(event.target.value) &&
      this.filterdTimePm.length > 0 &&
      this.filterdTimePm.find((time) => {
        return time == event.target.value;
      }) == undefined
    ) {
      event.target.value = this.filterdTimePm[0];
    }
    eval('this.' + champ + " = '" + event.target.value + "'");
    setTimeout(() => {
      var valeur;
      eval('valeur = this.' + champ);
      if (this.generalService.isNotEmpty(valeur))
        this.ApMidiTypePresenceChecked = true;
    }, 100);
  }
  getParamHeur() {
    this.generalService
      .rechercheTable(globalUrls.urlListeParamHeure)
      .subscribe((data) => {
        this.paramHeure = data[0];
        this.formaterHeurAction();
        this.setTimeAmEtTimePm();
      });
  }
  setTimeAmEtTimePm() {
    this.timeAm = this.dateService.generateListeTime(
      this.paramHeure.avtHeureAM_Deb,
      this.paramHeure.avtHeureAM_Fin,
      this.paramHeure.avtHeure_Ecart
    );
    this.timePm = this.dateService.generateListeTime(
      this.paramHeure.avtHeurePM_Deb,
      this.paramHeure.avtHeurePM_Fin,
      this.paramHeure.avtHeure_Ecart
    );
    this.filterdTimeAm = this.dateService.generateListeTime(
      this.paramHeure.avtHeureAM_Deb,
      this.paramHeure.avtHeureAM_Fin,
      this.paramHeure.avtHeure_Ecart
    );
    this.filterdTimePm = this.dateService.generateListeTime(
      this.paramHeure.avtHeurePM_Deb,
      this.paramHeure.avtHeurePM_Fin,
      this.paramHeure.avtHeure_Ecart
    );
    this.columnHeureSemaine.TableRD[3].data = this.timeAm;
    this.columnHeureSemaine.TableRD[3].dataToShow = this.timeAm.slice();
    this.columnHeureSemaine.TableRD[4].data = this.timeAm;
    this.columnHeureSemaine.TableRD[4].dataToShow = this.timeAm.slice();
    this.columnHeureSemaine.TableRD[6].data = this.timePm;
    this.columnHeureSemaine.TableRD[6].dataToShow = this.timePm.slice();
    this.columnHeureSemaine.TableRD[7].data = this.timePm;
    this.columnHeureSemaine.TableRD[7].dataToShow = this.timePm.slice();
    if (this.typeTrs == '1') {
      this.appliquerHeurJourByParam(
        this.paramHeure.avtHeureAM_Deb,
        this.paramHeure.avtHeureAM_Fin,
        this.paramHeure.avtHeurePM_Deb,
        this.paramHeure.avtHeurePM_Fin
      );
      this.listeHeurSemaineComponent.setDataSource(this.heureSemaine);
    }
  }
  dateDebutInferieurDateFin(dateDebut, dateFin) {
    if (this.generalService.isNotEmpty(dateFin)) {
      var debut = new Date('2000/1/1 ' + dateDebut);
      var fin = new Date('2000/1/1 ' + dateFin);
      if (debut.getTime() > fin.getTime()) {
        dateDebut = this.generalService.clone(dateFin);
        this.generalService.dialogSuccess(
          'La date de début doit etre inférieur à la date de fin',
          false
        );
      }
    } else dateFin = this.generalService.clone(dateDebut);
  }

  dateActionChange(peride) {
    if (this.calmoisComponens) this.calmoisComponens.selectedDays = [];
    if (peride == 'DATEDEBUT') {
      if (
        this.action.avtAction_dateFin != undefined &&
        this.action.avtAction_dateFin != null
      ) {
        var debut = new Date(this.action.avtAction_dateDeb);
        var fin = new Date(this.action.avtAction_dateFin);
        if (debut.getTime() > fin.getTime()) {
          this.action.avtAction_dateDeb = this.generalService.clone(
            this.action.avtAction_dateFin
          );
          this.generalService.dialogSuccess(
            'La date de début doit etre inférieur à la date de fin',
            false
          );
        }
      } else
        this.action.avtAction_dateFin = this.generalService.clone(
          this.action.avtAction_dateDeb
        );
    } else if (peride == 'DATEFIN') {
      if (
        this.action.avtAction_dateDeb != undefined &&
        this.action.avtAction_dateDeb != null
      ) {
        var debut = new Date(this.action.avtAction_dateDeb);
        var fin = new Date(this.action.avtAction_dateFin);
        if (debut.getTime() > fin.getTime()) {
          this.action.avtAction_dateFin = this.generalService.clone(
            this.action.avtAction_dateDeb
          );
          this.generalService.dialogSuccess(
            'La date de fin doit etre inférieur à la date de bébut',
            false
          );
        }
      } else
        this.action.avtAction_dateDeb = this.generalService.clone(
          this.action.avtAction_dateFin
        );
    }
    this.setDateDebutFinCalendarAction(
      this.action.avtAction_dateDeb,
      this.action.avtAction_dateFin
    );
    this.setDateDebutFinIntervaleDuplicationActionD();
    setTimeout(() => {
      this.setDateDebutFinCalmois();
      this.setListMonth();
    }, 100);
  }
  convertAvtactiondToAvtActionTypeD(avtactiond) {
    var avtActionTypeD = [];
    avtactiond.forEach((type) => {
      avtActionTypeD.push({
        avtActionTypeD_Id: type.avtActionD_Code,
        avtActionTypeD_date: type.avtActionD_date,
        avtActionTypeD_heureDebAM: type.avtActionD_heureDebAM,
        avtActionTypeD_heureDebPM: type.avtActionD_heureDebPM,
        avtActionTypeD_heureFinAM: type.avtActionD_heureFinAM,
        avtActionTypeD_heureFinPM: type.avtActionD_heureFinPM,
        avtActionType_Id: -1,
        avtAction_Code: type.avtAction_Code,
        Perso_Matricule: type.Perso_Matricule,
        avtActionTypeD_Info: type.avtActionD_Info,
        avtActionTypeD_Type: type.avtActionD_Type,
      });
    });
    return avtActionTypeD;
  }
  convertAvtActionTypeDToAvtactiond(avtActionTypeD) {
    var avtactiond = [];
    avtActionTypeD.forEach((type) => {
      avtactiond.push({
        avtActionD_Code: type.avtActionTypeD_Id,
        avtActionD_date: type.avtActionTypeD_date,
        avtActionD_heureDebAM: type.avtActionTypeD_heureDebAM,
        avtActionD_heureDebPM: type.avtActionTypeD_heureDebPM,
        avtActionD_heureFinAM: type.avtActionTypeD_heureFinAM,
        avtActionD_heureFinPM: type.avtActionTypeD_heureFinPM,
        Perso_Matricule: type.Perso_Matricule,
        avtAction_Code: type.avtAction_Code,
        avtActionD_Info: '',
        avtActionD_Type: type.avtActionD_Type,
      });
    });
    return avtactiond;
  }
  fillAvtActionTypeDToCalmois(avtActionTypeD) {
    this.avtActionTypeDCalmoi = JSON.parse(JSON.stringify(avtActionTypeD));
    var listeBgColor = [];
    //deselection old calmois
    this.oldSelectedClamois.forEach((oldSelectedClamois) => {
      oldSelectedClamois.cal.bgColor = this.cssbackgroundDateAction;
      oldSelectedClamois.cal.textColor = this.cssTextColorDateAction;
    });
    var mois = 0;
    var week = 0;
    var day = 0;
    //selection new calmois
    avtActionTypeD.forEach((actionTypeD) => {
      //en k il y a une ligne vide en doit l'eliminer
      if (this.generalService.isNotEmpty(actionTypeD.avtActionType_Id)) {
        var cooredonner = this.getCooredonnerCalmois(actionTypeD);
        mois = cooredonner.mois;
        week = cooredonner.week;
        day = cooredonner.day;
        try {
          // pour uniquement action de formation
          // pour colorier les case de type presence selectionner
          if (actionTypeD.avtActionType_Id == this.selectedTypePresence) {
            listeBgColor.push({
              strDate: this.listeCal[mois].val[week][day].strDate,
              cal: this.listeCal[mois].val[week][day],
              bgColor: this.getBgColorCalmoi(actionTypeD),
              textColor: this.cssTextColorOcupe,
              forSelectedTypePresence: true,
            });
          } else {
            //action de formation
            if (this.typeAction == '0') {
              listeBgColor.push({
                strDate: this.listeCal[mois].val[week][day].strDate,
                cal: this.listeCal[mois].val[week][day],
                bgColor: this.getBgColorCalmoi(actionTypeD),
                textColor: this.cssTextdDefault,
                forSelectedTypePresence: false,
              });
            }
            //action administrative
            if (this.typeAction == '1' || this.typeAction == '2') {
              listeBgColor.push({
                strDate: this.listeCal[mois].val[week][day].strDate,
                cal: this.listeCal[mois].val[week][day],
                bgColor: this.getBgColorCalmoi(actionTypeD),
                textColor: this.cssTextColorOcupe,
                forSelectedTypePresence: true,
              });
            }
          }
          this.oldSelectedClamois.push({
            cal: this.listeCal[mois].val[week][day],
            mois: this.generalService.clone(mois),
            day: this.generalService.clone(day),
            week: this.generalService.clone(week),
          });
        } catch {}
      }
    });
    this.setBgColorCalmoi(listeBgColor);
  }
  getCooredonnerCalmois(actionTypeD) {
    var mois = 0;
    var week = 0;
    var day = 0;
    mois = this.dateService.monthDiff(
      actionTypeD.avtActionTypeD_date,
      this.action.avtAction_dateDeb
    );
    var date = new Date(actionTypeD.avtActionTypeD_date);
    date.setDate(1);
    var week1, week2;
    week1 = this.dateService.getWeekNumber(
      new Date(actionTypeD.avtActionTypeD_date)
    );
    week2 = this.dateService.getWeekNumber(date);
    //le week de la première semaine peux etre = au week de la derniére semain de l'anné presedente
    // qui provoque une erreur => week avoire une valeur négative
    if (week1 >= week2) week = week1 - week2;
    else week = week1;

    day = new Date(actionTypeD.avtActionTypeD_date).getDay() - 1;
    //le cas de dimanche car la semaine en javascript commance par dimanche
    if (day == -1) day = 6;
    return { mois, week, day };
  }
  setBgColorCalmoi(listeBgColor: Array<any>) {
    var colorAM = '';
    var colorPM = '';

    listeBgColor.forEach((bg) => {
      var listeMemeDateBg = listeBgColor.filter((memeDateBg) => {
        return memeDateBg.strDate == bg.strDate;
      });
      var listeAM = listeMemeDateBg.filter((a) => {
        return a.bgColor.indexOf('AM') > -1;
      });
      var listePM = listeMemeDateBg.filter((a) => {
        return a.bgColor.indexOf('PM') > -1;
      });
      var am =
        listeAM.filter((a) => {
          return a.forSelectedTypePresence == true;
        }).length > 0;
      var pm =
        listePM.filter((a) => {
          return a.forSelectedTypePresence == true;
        }).length > 0;
      if (listeAM.length > 0) {
        if (am) colorAM = this.colorDay.backgroundOcupe;
        else colorAM = this.colorDay.backgroundOcupeForNotSelectedTypePresentD;
      } else colorAM = 'rgba(0, 0, 0, 0)';
      if (listePM.length > 0) {
        if (pm) colorPM = this.colorDay.backgroundOcupe;
        else colorPM = this.colorDay.backgroundOcupeForNotSelectedTypePresentD;
      } else colorPM = 'rgba(0, 0, 0, 0)';
      var bgColor = {
        background:
          'linear-gradient(to top left, ' +
          colorPM +
          ' 0%, ' +
          colorPM +
          ' 50%, ' +
          colorAM +
          ' 50%, ' +
          colorAM +
          ' 100%)',
        height: '90%',
        width: '90%',
      };
      bg.cal.bgColor = bgColor;
    });
  }
  getBgColorCalmoi(actionTypeD) {
    var demiJournerAm: boolean = false;
    var demiJournerPm: boolean = false;
    // demi journer Am exixte
    if (
      this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureDebAM) &&
      this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureFinAM) &&
      this.dateService.setFormaTimeCalendar(
        actionTypeD.avtActionTypeD_heureDebAM
      ) > 0 &&
      this.dateService.setFormaTimeCalendar(
        actionTypeD.avtActionTypeD_heureFinAM
      ) > 0
    )
      demiJournerAm = true;

    // demi journer Pm exixte
    if (
      this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureDebPM) &&
      this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureFinPM) &&
      this.dateService.setFormaTimeCalendar(
        actionTypeD.avtActionTypeD_heureDebPM
      ) > 0 &&
      this.dateService.setFormaTimeCalendar(
        actionTypeD.avtActionTypeD_heureFinPM
      ) > 0
    )
      demiJournerPm = true;
    // journer total : am et pm
    if (demiJournerAm && demiJournerPm) return 'AMPM'; //(forSelectedTypePresence? this.cssBackgroundOcupe : this.cssBackgroundOcupeForNotSelectedTypePresenceD) ;
    // demi journer am
    if (demiJournerAm && !demiJournerPm) return 'AM'; //(forSelectedTypePresence? this.cssBackgroundOcupeAM : this.cssBackgroundOcupeAMForNotSelectedTypePresenceD);
    // demi journer Pm
    if (!demiJournerAm && demiJournerPm) return 'PM'; //(forSelectedTypePresence? this.cssBackgroundOcupePM : this.cssBackgroundOcupePMForNotSelectedTypePresenceD);
    // journer vide
    if (!demiJournerAm && !demiJournerPm) return ''; //(this.cssBackgroundDefault)
    return '';
  }
  setDateDebutFinIntervaleDuplicationActionD() {
    this.dateDebutDupliquation = this.generalService.clone(
      this.action.avtAction_dateDeb
    );
    this.dateFinDupliquation = this.generalService.clone(
      this.action.avtAction_dateFin
    );
  }
  setDateDebutFinCalendarAction(
    avtAction_dateDeb: Date,
    avtAction_dateFin: Date
  ) {
    this.avtActionDateDeb = new Date(avtAction_dateDeb);
    this.avtActionDateFin = new Date(avtAction_dateFin);
    if (this.calendarActionComponent != undefined) {
      this.calendarActionComponent.setOption(
        'defaultDate',
        this.avtActionDateDeb
      );
      this.calendarActionComponent.setOption('validRange', {
        start: this.avtActionDateDeb,
        end: this.avtActionDateFin,
      });
    }
  }

  setListMonth() {
    this.listWeek = [];
    this.listMonth = [];
    if (
      (this.informationAction.form.controls.avtAction_dateDeb.valid &&
        this.informationAction.form.controls.avtAction_dateFin.valid) ||
      this.disabled
    ) {
      this.listMonth = this.dateService.getListMonth(
        new Date(this.action.avtAction_dateDeb),
        new Date(this.action.avtAction_dateFin),
        0
      );
      // pour le form duplication action
      this.listMonth.forEach((month) => {
        month['selected'] = true;

        month['planifiable'] = this.isMonthPlanifiable(month);
        if (month['planifiable'])
          month['listeWeek'] = this.getListWeekPlanifiable(month);
        else month['listeWeek'] = [];
      });
    }
  }
  isMonthPlanifiable(month): boolean {
    if (this.typeAction != '2') {
      var listeDatePlanifiable = this.getListeDatePlanifiable();
      var planifiable = false;
      listeDatePlanifiable.forEach((datePlanifiable) => {
        var date = new Date(datePlanifiable.avtActionTypeD_date);
        if (
          month.monthId == date.getMonth() &&
          month.year == date.getFullYear()
        )
          planifiable = true;
      });
      return planifiable;
    } else return true;
  }
  setListWeek(month, index) {
    //
    for (var i = 0; i < this.listMonth.length; i++) {
      $('#month_' + i).removeClass('rectengle-arrendi-3');
    }
    $('#month_' + index).addClass('rectengle-arrendi-3');
    this.listWeek = this.getListWeekPlanifiable(month); //this.dateService.getListWeek(new Date(month.year,month.monthId,1),new Date(month.year,month.monthId,this.dateService.getLastDayOfMonth(month.monthId)));
    // this.listWeek.forEach(week =>
    // {
    //   var dateFin = this.dateService.convertStrToDate(week.monthName);
    //   dateFin.setDate(dateFin.getDate()+7)
    //   if(this.dateService.intervaleDateInclueDansIntervaleDate(this.action.avtAction_dateDeb,this.action.avtAction_dateFin,this.dateService.convertStrToDate(week.monthName),dateFin) )
    //     week.enable = true;
    //   else
    //     this.listWeek = this.listWeek.filter(wek =>{return wek.colSpan != week.colSpan})
    // });
  }

  getListeDatePlanifiable(): any[] {
    var listePlanifiableTypePresence = this.initAction.avtActionType.filter(
      (type) => {
        return type.avtActionType_Planifiable;
      }
    );
    var listeAvtActionType_Id = ';';
    listePlanifiableTypePresence.forEach((lst) => {
      listeAvtActionType_Id += lst.avtActionType_Id + ';';
    });
    return this.initAction.avtActionTypeD.filter((typeD) => {
      return (
        listeAvtActionType_Id.indexOf(';' + typeD.avtActionType_Id + ';') > -1
      );
    });
  }
  setListMonthDuplication(month) {
    month.selected = !month.selected;
    month.listeWeek.forEach((week) => {
      week.selected = month.selected;
    });
  }
  setWeekDuplication(week) {
    week.selected = !week.selected;
  }
  getListWeekPlanifiable(month) {
    var date1 = new Date();
    date1.setMonth(month.monthId);
    date1.setFullYear(month.year);
    date1.setDate(1);
    var date2 = new Date();
    date2.setFullYear(month.year);
    date2.setMonth(month.monthId);
    date2.setDate(this.dateService.getLastDayOfMonth(month.monthId));
    var listeWeek = this.dateService.getListWeek(date1, date2);
    var listeWeekPlanifiable = this.filterWeekPlanifiable(listeWeek);
    if (this.typeAction == '2') listeWeekPlanifiable = listeWeek;
    listeWeekPlanifiable.forEach((week) => {
      week['selected'] = true;
      week['haveConflie'] = false;
    });
    return listeWeekPlanifiable;
  }
  filterWeekPlanifiable(listeWeek) {
    var listeFiltredWeek = [];
    listeWeek.forEach((element) => {
      var TabDateWeek = element.monthName.split('/');
      if (TabDateWeek.length == 3) {
        var yearWeek;
        var week = element.colSpan;
        yearWeek = TabDateWeek[2];
        if (this.isweekPlanifiable(week, yearWeek)) {
          listeFiltredWeek.push(element);
        }
      }
    });
    return listeFiltredWeek;
  }

  isweekPlanifiable(week, year): boolean {
    var listeDatePlanifiable = this.getListeDatePlanifiable();
    var planifiable = false;
    listeDatePlanifiable.forEach((datePlanifiable) => {
      var date = new Date(datePlanifiable.avtActionTypeD_date);
      var findWeek = this.dateService.getWeekNumber(date);
      if (
        findWeek.toString() == week.toString() &&
        date.getFullYear().toString() == year.toString()
      )
        planifiable = true;
    });
    return planifiable;
  }
  setDateDebutFinCalmois() {
    this.listeCal = [];
    if (
      (this.informationAction.form.controls.avtAction_dateDeb.valid &&
        this.informationAction.form.controls.avtAction_dateFin.valid) ||
      (this.disabled &&
        this.generalService.isNotEmpty(this.action.avtAction_dateDeb) &&
        this.generalService.isNotEmpty(this.action.avtAction_dateFin))
    ) {
      var dateDebut: Date = new Date(this.action.avtAction_dateDeb);
      var dateFin: Date = new Date(this.action.avtAction_dateFin);
      var monthDifference: number =
        this.dateService.monthDiff(dateFin, dateDebut) + 1;
      dateDebut.setDate(1);
      for (var i = 0; i < monthDifference; i++) {
        this.listeCal.push({
          mois: dateDebut.getMonth(),
          annee: dateDebut.getFullYear(),
          val: [],
          listParamsDay: this.getListParamsDay(dateDebut),
        });
        dateDebut.setMonth(dateDebut.getMonth() + 1);
      }
    }
    //pour obliger angular à recharger le omposont calmoi
    this.randomList[0] = Math.random().toString().substr(2, 5);
  }
  dateInclueDansDateDebutEtFinAction(date: Date) {
    var avtAction_dateDeb = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var avtAction_dateFin = this.dateService.setToDate(
      this.action.avtAction_dateFin
    );
    return this.dateService.dateInclueDansInterval(
      avtAction_dateDeb,
      avtAction_dateFin,
      date
    );
  }
  getListParamsDay(myDate: Date) {
    var date = this.generalService.clone(myDate);
    var paramsDay;
    var ListParamsDay = [];
    var lastDayOfMonth = this.dateService.getLastDayOfMonth(
      date.getMonth() + 1
    );

    for (var i = 1; i < lastDayOfMonth + 1; i++) {
      date.setDate(i);
      paramsDay = this.generalService.clone(
        this.initParamsDay(i.toString(), date)
      );
      //pour samedi et dimanche
      if (this.dateService.isSamediOrDimenche(date)) {
        paramsDay.bgColor = this.cssJourFerier;
        paramsDay.actif = false;
      } else {
        if (this.dateInclueDansDateDebutEtFinAction(date)) {
          paramsDay.actif = true;
          paramsDay.bgColor = this.cssbackgroundDateAction;
          paramsDay.textColor = this.cssTextColorDateAction;
        } else {
          paramsDay.bgColor = this.cssbackgroundHorsDateAction;
          paramsDay.actif = false;
        }
      }
      ListParamsDay.push(this.generalService.clone(paramsDay));
    }
    //pour les case vide du composant calmois
    ListParamsDay.push(
      this.generalService.clone(this.initParamsDay('00', date))
    );
    //pour les case de numero de semaine
    var param = this.generalService.clone(this.initParamsDay('week', date));
    param.textColor = this.cssTextColorWeek;
    ListParamsDay.push(param);
    return ListParamsDay;
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.index = 0;
      this.exist = false;
      this.param_code = params['param_code'];
      this.typeTrs = params['typeTrs'];
      this.typeAction = params['typeAction'];
      this.initialiserAction();
    });
  }
  initListeBtn(disabled) {
    this.listBtnBC.forEach((btn) => {
      btn.disabled = disabled;
    });
    this.listBtnListeDevis.forEach((btn) => {
      btn.disabled = disabled;
    });
    this.listBtnListeFacture.forEach((btn) => {
      btn.disabled = disabled;
    });
  }
  initialiserAction() {
    this.setColonneApprenant();
    if (this.typeTrs == '1') {
      this.getAction(globalUrls.urlAction);
    }
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      this.getAction(globalUrls.urlAction + '&val=' + this.param_code);
      this.getListeDocument(false);
      if (this.typeTrs == '3') this.disabled = true;
    }
    this.initListeBtn(this.disabled);
  }
  createEventsCalandar2(
    listeActionD,
    editable: boolean,
    colorAction,
    colorTextActioon
  ) {
    var events = [];
    listeActionD.forEach((actionTypeD) => {
      var type = this.typePresenceAction.find((t) => {
        return t.avtActionType_Id == actionTypeD.avtActionType_Id;
      });
      type = type ? type.DiverSys_Titre : '';
      if (
        this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureDebAM) &&
        actionTypeD.avtActionTypeD_heureDebAM != '00:00:00.0000000' &&
        actionTypeD.avtActionTypeD_heureDebAM != '00:00'
      ) {
        var eventAM = this.actionsService.createEvent(
          actionTypeD,
          type,
          actionTypeD.avtActionTypeD_Id + '_AM',
          new Date(
            this.dateService.setToFormatDateServerStr(
              new Date(actionTypeD.avtActionTypeD_date)
            ) +
              ' ' +
              actionTypeD.avtActionTypeD_heureDebAM
          ),
          new Date(
            this.dateService.setToFormatDateServerStr(
              new Date(actionTypeD.avtActionTypeD_date)
            ) +
              ' ' +
              actionTypeD.avtActionTypeD_heureFinAM
          ),
          colorAction,
          colorTextActioon,
          null,
          editable
        );
        events.push(eventAM);
      }
      if (
        this.generalService.isNotEmpty(actionTypeD.avtActionTypeD_heureDebPM) &&
        actionTypeD.avtActionTypeD_heureDebPM != '00:00:00.0000000' &&
        actionTypeD.avtActionTypeD_heureDebPM != '00:00'
      ) {
        var eventPM = this.actionsService.createEvent(
          actionTypeD,
          type,
          actionTypeD.avtActionTypeD_Id + '_PM',
          new Date(
            this.dateService.setToFormatDateServerStr(
              new Date(actionTypeD.avtActionTypeD_date)
            ) +
              ' ' +
              actionTypeD.avtActionTypeD_heureDebPM
          ),
          new Date(
            this.dateService.setToFormatDateServerStr(
              new Date(actionTypeD.avtActionTypeD_date)
            ) +
              ' ' +
              actionTypeD.avtActionTypeD_heureFinPM
          ),
          colorAction,
          colorTextActioon,
          null,
          editable
        );
        events.push(eventPM);
      }
    });
    return events;
  }
  createEventsCalandar(
    listeActionD,
    editable: boolean,
    colorAction,
    colorTextActioon
  ) {
    var events = [];
    listeActionD.forEach((actionD) => {
      if (
        this.generalService.isNotEmpty(actionD.avtActionD_heureDebAM) &&
        actionD.avtActionD_heureDebAM != '00:00:00.0000000' &&
        actionD.avtActionD_heureDebAM != '00:00'
      ) {
        var eventAM = this.actionsService.createEvent(
          actionD,
          actionD.avtActionD_Info,
          actionD.avtActionD_Code + '_AM',
          new Date(
            actionD.avtActionD_date + ' ' + actionD.avtActionD_heureDebAM
          ),
          new Date(
            actionD.avtActionD_date + ' ' + actionD.avtActionD_heureFinAM
          ),
          colorAction,
          colorTextActioon,
          null,
          editable
        );
        events.push(eventAM);
      }
      if (
        this.generalService.isNotEmpty(actionD.avtActionD_heureDebPM) &&
        actionD.avtActionD_heureDebPM != '00:00:00.0000000' &&
        actionD.avtActionD_heureDebPM != '00:00'
      ) {
        var eventPM = this.actionsService.createEvent(
          actionD,
          actionD.avtActionD_Info,
          actionD.avtActionD_Code + '_PM',
          new Date(
            actionD.avtActionD_date + ' ' + actionD.avtActionD_heureDebPM
          ),
          new Date(
            actionD.avtActionD_date + ' ' + actionD.avtActionD_heureFinPM
          ),
          colorAction,
          colorTextActioon,
          null,
          editable
        );
        events.push(eventPM);
      }
    });
    return events;
  }
  getTypeAction() {
    var typeAction = this.listeTypeAction.find((type) => {
      return type.avtParamAction_Code == this.action.avtAction_Type;
    });
    if (typeAction != undefined) return typeAction;
    else return this.listeTypeAction[0];
  }
  getActionD() {
    var url: string = '';
    if (this.typeTrs == '1') {
      url = globalUrls.urlActionD2;
    }
    if (this.typeTrs == '2' || this.typeTrs == '3') {
      url = globalUrls.urlActionD + this.param_code;
    }

    this.generalService.rechercheTable(url).subscribe((data) => {
      this.listeActionD = data.avtactionD;
      this.setListeTypeAction();
    });
  }
  // get liste de tous les apprant
  // sette liste ser pour liste ApprenantGroupeComponent
  // pour afficher le nom de l'apprenant et pas le code
  getAllPerso() {
    //action de formation
    var url = this.generalService.url + 'avtperso&param=2';
    //Actiin Administrative ou de prestation
    if (this.typeAction == '1')
      url = this.generalService.url + 'avtperso&param=0';
    //Actiin de prestation
    if (this.typeAction == '2') url = this.generalService.url + 'avtusers';
    this.generalService.rechercheTable(url).subscribe((data) => {
      this.listeAllApprenant = data;
      this.generateDataSourceListeApprenantGroupeComponent();
    });
  }
  getListeColaborateur() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtperso&param=0')
      .subscribe((data) => {
        this.listeCollaborateur = data;
      });
  }
  getAction(url) {
    this.generalService.rechercheTable(url).subscribe(
      (data) => {
        this.initAction = data;
        this.initActionStr = JSON.stringify(this.initAction);
        this.action = this.initAction.avtaction[0];
        this.action.avtAction_Nature = this.typeAction;
        this.typePresenceAction = this.generalService.clone(
          this.initAction.avtActionType
        );
        this.getListeColaborateur();
        this.getListePerso();
        this.getAllPerso();
        this.getActionD();
        this.getParamHeur();
        // action de formation
        if (this.typeAction == '0') {
          this.ecrant = 'Apprenants';
          this.titre = 'FORMATION';
          this.avtAction_ModFormation = parseInt(
            this.action.avtAction_ModFormation
          );
          this.getTypePresenceFromDiversice();
          this.initRadioButtonTypePresence();
          this.getListeAllMatiere();
        }
        // action administrative
        if (this.typeAction == '1') {
          this.exist = true;
          this.ecrant = 'Collaborateurs';
          this.titre = 'ADMINISTRATIVE';
        }
        // action prestation
        if (this.typeAction == '2') {
          this.exist = true;
          this.ecrant = 'Utilisateurs';
          this.titre = 'PRESTATION';
          if (this.typeTrs != '1') {
            this.getManager();
            this.getClient();
            this.genererHeureSemaine(this.initAction.avtAPH);
          }
        }
        this.initCalmoi();
        this.setColonneApprenant();
        this.initActionStr = JSON.stringify(this.initAction);
      },
      (error) => {
        console.log(error);
      }
    );
  }
  genererHeureSemaine(avtAPH) {
    this.heureSemaine.forEach((heurS) => {
      var plageH = avtAPH.find((ph) => {
        return ph.avtAPH_Jour == heurS.id;
      });
      if (plageH) {
        if (this.generalService.isNotEmpty(plageH.avtAPH_DebAM)) {
          heurS.amActive = true;
          heurS.amDebut = plageH.avtAPH_DebAM;
          heurS.amFin = plageH.avtAPH_FinAM;
        } else {
          heurS.amActive = false;
          heurS.amDebut = null;
          heurS.amFin = null;
        }
        if (this.generalService.isNotEmpty(plageH.avtAPH_DebPM)) {
          heurS.pmActive = true;
          heurS.pmDebut = plageH.avtAPH_DebPM;
          heurS.pmFin = plageH.avtAPH_FinPM;
        } else {
          heurS.pmActive = false;
          heurS.pmDebut = null;
          heurS.pmFin = null;
        }
        if (
          this.generalService.isNotEmpty(plageH.avtAPH_DebPM) ||
          this.generalService.isNotEmpty(plageH.avtAPH_DebAM)
        )
          heurS.active = true;
        else heurS.active = false;
      } else {
        heurS.active = false;
        heurS.amActive = false;
        heurS.amDebut = null;
        heurS.amFin = null;
        heurS.pmActive = false;
        heurS.pmDebut = null;
        heurS.pmFin = null;
      }
    });
    this.listeHeurSemaineComponent.setDataSource(this.heureSemaine);
  }
  getManager() {
    if (this.generalService.isNotEmpty(this.action.Perso_Matricule))
      this.generalService
        .rechercheTable(
          globalUrls.urlPerso + '&val=' + this.action.Perso_Matricule
        )
        .subscribe((data) => {
          this.collaborateurComponent.parentVal = data.perso[0].Perso_Nom;
        });
  }
  getClient() {
    if (this.generalService.isNotEmpty(this.action.Tiers_code))
      this.generalService
        .rechercheTable(globalUrls.urlClient + '&val=' + this.action.Tiers_code)
        .subscribe((data) => {
          this.clientComponent.parentVal = data.Tiers[0].Tiers_NomPublic;
          if (this.generalService.isNotEmpty(data.Tiers[0].Tiers_codeF))
            this.getEntiterFacturation(data.Tiers[0].Tiers_codeF);
        });
  }
  getEntiterFacturation(Tiers_codeF) {
    this.generalService
      .rechercheTable(globalUrls.urlClient + '&val=' + Tiers_codeF)
      .subscribe((dataF) => {
        this.entiterFacturation = dataF.Tiers[0].Tiers_NomPublic;
      });
  }
  setListeBcAction() {
    this.listeBCComponen.setDataSource(
      this.initAction.avtactionDoc.filter((bc) => {
        return this.generalService.isNotEmpty(bc.Doc_Num);
      })
    );
  }
  openListeSalle() {
    this.generalService.machineChoisie = '';
    this.generalService.fenetreAvtListeMachine = '2';
    this.generalService.dialogOpend = this.generalService.dialog.open(
      AvtListeMachineComponent,
      new MatDialogConfig()
    );

    this.generalService.dialogOpend.afterClosed().subscribe(() => {
      if (this.generalService.isNotEmpty(this.generalService.machineChoisie)) {
        this.exist = false;
        this.choisirSalle(this.generalService.machineChoisie);
      }
    });
  }
  openFrmConfirmDelete() {
    var documentToDelete = this.listeBCComponen.row;
    if (
      this.generalService.isNotEmpty(documentToDelete) &&
      this.generalService.isNotEmpty(documentToDelete.Doc_Num)
    ) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        message: 'Voulez vous supprimer ce bon de commande',
        btnOk: {
          class: 'colorRed',
          icon: 'keyboard_return',
          text: 'Supprimer',
        },
        btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
      };
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.exist = false;
          this.generalService
            .rechercheTable(
              globalUrls.urlAction + '&val=' + this.action.avtAction_Code
            )
            .subscribe(
              (action) => {
                action.avtactionDoc = action.avtactionDoc.filter((bc) => {
                  return bc.Doc_Num != documentToDelete.Doc_Num;
                });
                this.generalService
                  .enregisterTable(
                    this.generalService.supprimerTableVideAction(
                      action,
                      this.tabProperty,
                      'avtAction_Code'
                    )
                  )
                  .subscribe(
                    (action) => {
                      this.generalService
                        .rechercheTable(
                          globalUrls.urlAction +
                            '&val=' +
                            this.action.avtAction_Code
                        )
                        .subscribe(
                          (dataAction) => {
                            this.initAction = dataAction;
                            this.action = this.initAction.avtaction[0];
                            this.exist = true;
                            this.listeBCComponen.setDataSource(
                              this.initAction.avtactionDoc.filter((doc) => {
                                return this.generalService.isNotEmpty(
                                  doc.Doc_Num
                                );
                              })
                            );
                          },
                          () => {
                            this.exist = true;
                            this.generalService.dialogSuccess(
                              'Élément non supprimé',
                              false
                            );
                          }
                        );
                    },
                    () => {
                      this.exist = true;
                      this.generalService.dialogSuccess(
                        'Élément non supprimé',
                        false
                      );
                    }
                  );
              },
              () => {
                this.exist = true;
                this.generalService.dialogSuccess(
                  'Élément non supprimé',
                  false
                );
              }
            );
        }
        if (result == 'annuler') {
        }
      });
    }
  }
  openFormListeBonDeCommande(event) {
    this.generalService.rowChoisie = '';
    this.generalService.fenetreAvtListeDocument = '2';
    this.generalService.dialogOpend = this.generalService.dialog.open(
      AvtListeDocumentComponent,
      new MatDialogConfig()
    );

    this.generalService.dialogOpend.afterClosed().subscribe(() => {
      if (this.generalService.isNotEmpty(this.generalService.rowChoisie)) {
        this.exist = false;
        this.enregistrerBonDeComande();
      }
    });
  }
  enregistrerBonDeComande() {
    var doc = this.generalService.rowChoisie;
    this.generalService
      .rechercheTable(
        globalUrls.urlAction + '&val=' + this.action.avtAction_Code
      )
      .subscribe(
        (action) => {
          var bonDeCommandeToAdd = [
            {
              Doc_Num: doc.Doc_Num,
              U_timestamp: null,
              avtAction_Code: this.action.avtAction_Code,
            },
          ];
          action.avtactionDoc = bonDeCommandeToAdd;
          this.generalService
            .enregisterTable(
              this.generalService.supprimerTableVideAction(
                action,
                this.tabProperty,
                'avtAction_Code'
              )
            )
            .subscribe(
              (action) => {
                this.generalService
                  .rechercheTable(
                    globalUrls.urlAction + '&val=' + this.action.avtAction_Code
                  )
                  .subscribe((dataAction) => {
                    this.initAction = dataAction;
                    this.action = this.initAction.avtaction[0];
                    this.exist = true;
                    this.listeBCComponen.setDataSource(
                      this.initAction.avtactionDoc.filter((doc) => {
                        return this.generalService.isNotEmpty(doc.Doc_Num);
                      })
                    );
                  });
                this.generalService.dialogSuccess('enregistré', true);
              },
              (error) => {
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
        },
        (error) => {
          this.exist = true;
          this.generalService.dialogSuccess('Non enregistré', false);
        }
      );
  }
  clickBtnBonCommande(event) {
    switch (event.name) {
      case 'ajouterBC': {
        this.openDocument();
        break;
      }
      case 'SupprimerBC': {
        this.detacherDocument(event.row);
        break;
      }
    }
  }

  onChangeImagefile(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      this.documentName = fileInput.target.files[0].name;
      this.documentType = src.substring(0, src.indexOf(',') + 1);
      this.documentSrc = src.replace(this.documentType, '');
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }
  openDocument() {
    this.documentName = '';
    this.documentType = '';
    this.documentSrc = '';
    this.generalService.dialogOpend = this.generalService.dialog.open(
      this.frmBonCommande
    );
    this.generalService.dialogOpend.afterClosed().subscribe(() => {});
  }
  enregistrerFileEndBonCommande() {
    this.exist = false;
    if (this.generalService.isNotEmpty(this.documentName)) {
      var doc = this.generalService.initDoc;
      doc.files[0].File_Content = this.documentSrc;
      doc.files[0].File_Text = this.documentName;
      doc.files[0].File_Type = 'action';
      doc.files[0].File_Dll = 'jstree-file';
      doc.files[0].File_Key = this.param_code;
      doc.files[0].File_Autre = this.documentType;
      doc.files[0].File_Groupe = '';
      doc.files[0].File_Lien = '';
      this.generalService.enregisterTable(doc).subscribe((data) => {
        this.generalService
          .rechercheTable(
            'recherche/tbdata?tablere=avtFiles&param=' +
              this.param_code +
              ',action'
          )
          .subscribe((data2) => {
            data2 = this.generalService.sort(data2, 'File_Id');
            if (data2.length > 0)
              this.enregistrerBonCommande(data2[data2.length - 1].File_Id);
          });
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner un fichier',
        false
      );
  }
  enregistrerBonCommande(File_Id) {
    var document = [];
    var ds;
    // Doc_Devise_Cours : taux de change
    document.push({
      Devise_Code: 'TND',
      Doc_Devise_Cours: 1,
      Doc_Obs: this.bonComamnde.Doc_Obs,
      DateDebut: this.bonComamnde.DateDebut,
      DateFin: this.bonComamnde.DateFin,
      Doc_THT: this.bonComamnde.Doc_THT,
      File_Id: File_Id,
      Doc_Num: '',
      Doc_Type: 'CMD',
      Tiers_code: this.action.Tiers_code,
      avtAction_Code: this.param_code,
      Doc_RS: this.clientComponent.parentVal,
    });
    ds = { Document: document, DocumentD: [], ApiParam: [{ androidId: 123 }] };
    this.generalService.saveDA(ds).subscribe(
      (data) => {
        this.generalService.dialogSuccess('Enregistré', true);
        this.getListeDocument(true);
        this.generalService.dialogOpend.close();
      },
      () => {
        this.exist = true;
        this.generalService.dialogSuccess('Non enregistré', false);
      }
    );
  }
  enregistrerDocumentAction(Doc_Num) {
    this.generalService
      .rechercheTable('ds/formdata?code=document&val=' + Doc_Num)
      .subscribe((myAction) => {
        if (this.generalService.isEmpty(myAction.Document[0].avtAction_Code)) {
          myAction.Document[0].avtAction_Code = this.param_code;

          var ds = {
            Document: myAction.Document,
            DocumentD: myAction.DocumentD,
            ApiParam: [{ androidId: 123 }],
          };
          console.log(ds);
          this.generalService.saveDA(ds).subscribe((data) => {
            this.getListeDocument(true);
          });
        } else {
          this.generalService.dialogSuccess(
            'Ce document est déjà joint à une action',
            false
          );
          this.exist = true;
        }
      });
  }
  closeFrmBonCommande() {
    this.generalService.dialog.closeAll();
  }
  initCalmoi() {
    this.dateActionChange('DATEDEBUT');
  }
  initRadioButtonTypePresence() {
    if (this.action.avtAction_ModePaiement != null)
      this.action.avtAction_ModePaiement =
        this.action.avtAction_ModePaiement.toString();
    if (this.action.avtAction_Tva != null)
      this.action.avtAction_Tva = this.action.avtAction_Tva.toString();
    if (this.action.avtAction_ModeFact != null)
      this.action.avtAction_ModeFact =
        this.action.avtAction_ModeFact.toString();
    if (this.action.Delai_Reglement != null)
      this.action.Delai_Reglement = this.action.Delai_Reglement.toString();
  }

  initParamsDay(nb: String, date: Date) {
    return {
      day: nb + '/' + (date.getMonth() + 1) + '/' + date.getFullYear(),
      actif: false,
      AMPM: 1,
      bgColor: this.cssBackgroundDefault,
      textColor: this.cssTextdDefault,
      tooltip: '',
    };
  }
  showDetaille(date, active, index) {
    if (active) {
      for (var i = 0; i < this.listWeek.length; i++) {
        $('#week_' + i).removeClass('rectengle-arrendi-3');
      }
      $('#week_' + index).addClass('rectengle-arrendi-3');

      var dateDebut = this.dateService.convertStrToDate(date.monthName);
      var dateFin = this.dateService.convertStrToDate(date.monthName);
      dateFin.setDate(dateDebut.getDate() + 7);
      //avtAction_dateDeb,avtAction_dateFin de type string => convertion to Date
      this.action.avtAction_dateDeb = this.dateService.setToDate(
        this.action.avtAction_dateDeb
      );
      this.action.avtAction_dateFin = this.dateService.setToDate(
        this.action.avtAction_dateFin
      );

      var avtAction_dateDeb = this.action.avtAction_dateDeb;
      //pour supprimer les heurs et minute
      avtAction_dateDeb = new Date(
        avtAction_dateDeb.getFullYear(),
        avtAction_dateDeb.getMonth(),
        avtAction_dateDeb.getDate()
      );

      var avtAction_dateFin = this.action.avtAction_dateFin;
      //pour supprimer les heurs et minute
      avtAction_dateFin = new Date(
        avtAction_dateFin.getFullYear(),
        avtAction_dateFin.getMonth(),
        avtAction_dateFin.getDate()
      );

      this.refrechCalendarAction(null, null, false, dateDebut);
      this.semaineMois =
        'Semaine: ' +
        date.colSpan +
        ' Du: ' +
        date.monthName +
        ' ---> ' +
        this.dateService.setFormatDate(dateFin);
    }
  }
  concateListeEvent(listeEvent, listeEvent2) {
    listeEvent.forEach((event) => {
      if (
        listeEvent2.find((eventCalandar) => {
          return eventCalandar.id == event.id;
        }) == undefined
      )
        listeEvent2.push(event);
    });
  }
  refrechCalendarAction(
    dateDebut: Date,
    dateFin: Date,
    refrechRangeDate: boolean,
    startDate: Date
  ) {
    this.eventsCalandar = this.generalService.clone(this.eventsCalandarAction);
    if (refrechRangeDate)
      this.setDateDebutFinCalendarAction(dateDebut, dateFin);
    if (this.salleAtelierChecked)
      this.concateListeEvent(this.eventsCalandarSalle, this.eventsCalandar);
    if (this.ressourcesHumainesChecked)
      this.concateListeEvent(
        this.eventsCalandarRessourceHymaine,
        this.eventsCalandar
      );
    setTimeout(() => {
      if (this.calendarActionComponent != undefined) {
        if (startDate != null && startDate != undefined)
          this.calendarActionComponent.setDefaulDate(startDate);
        this.calendarActionComponent.setEventCalandar(this.eventsCalandar);
        this.calendarActionComponent.setOption(
          'minTime',
          this.paramHeureCalendar.avtHeureAM_Deb + ':00'
        );
        this.calendarActionComponent.setOption(
          'maxTime',
          this.paramHeureCalendar.avtHeurePM_Fin + ':00'
        );
      }
    }, 100);
  }
  ressourcesHumainesCheckedChange() {
    this.refrechCalendarAction(null, null, false, null);
  }
  salleAtelierCheckedChange() {
    this.refrechCalendarAction(null, null, false, null);
  }

  blurChamp(event, modelDir) {
    if (this.action.Tiers_code != undefined && this.action.Tiers_code != '') {
      this.exist = false;
      this.generalService
        .rechercheTable(globalUrls.urlClient + '&val=' + this.action.Tiers_code)
        .subscribe((client) => {
          this.exist = true;
          this.clientFacture = client.Tiers[0];
        });
    }
  }
  addApprenat() {
    if (this.listeApprenantsComponen.row) {
      var property = 'Perso_Matricule';
      if (this.typeAction == '2') property = 'User_Id';
      this.listeFinanceurAction = undefined;
      this.listeApprenantGroupeComponen.setDataSource(
        this.listeApprenantGroupeComponen.dataSource.data.concat([
          this.listeApprenantsComponen.row,
        ])
      );
      var data = this.listeApprenantsComponen.dataSource.data;
      [this.listeApprenantsComponen.row].forEach((selectedRow) => {
        data = data.filter((row) => {
          return row[property] != selectedRow[property];
        });
      });
      this.listeApprenantsComponen.setDataSource(data);
      this.listeApprenantsComponen.row = null;
    }
    //Actiin Administrative
    if (this.typeAction == '1') {
      this.setDataListeCollaborateurComponen();
      this.fillAvtActionTypeByListeCollaborateurComponen();
    }
  }
  // pour action Administrative
  fillAvtActionTypeByListeCollaborateurComponen() {}
  setDataListeCollaborateurComponen() {
    var listeCollaborateur = this.listeApprenantGroupeComponen.dataSource.data;
    listeCollaborateur.forEach((collaborateur) => {
      if (this.typeTrs == '1') collaborateur['total'] = 0;
      if (this.typeTrs == '2') {
        if (this.initAction.avtActionType.length > 0)
          collaborateur['total'] =
            this.initAction.avtActionType[0].avtActionType_NbHeure;
        else collaborateur['total'] = 0;
      }
    });
    this.listeCollaborateurComponen.setDataSource(listeCollaborateur);
  }
  async generateListeFinanceurByAppreant() {
    var listeApprenant = this.listeApprenantGroupeComponen.dataSource.data;
    var listeFinanceurByApprenant = [];
    if (this.listeFinanceurAction == undefined)
      this.listeFinanceurAction = await this.getFinanceurApprenant();
    this.listeFinanceurAction = this.generalService.generateListeFinanceur(
      this.listeFinanceurAction,
      this.listeModePaiement,
      this.listeTva,
      this.listeModeFacturation,
      this.listeDelaiReglement
    );
    for (let i = 0; i < listeApprenant.length; i++) {
      var detail = this.listeFinanceurAction.filter((financeur) => {
        return financeur.Perso_Matricule == listeApprenant[i].Perso_Matricule;
      });
      listeFinanceurByApprenant.push({
        Perso_Matricule: listeApprenant[i].Perso_Matricule,
        Perso_Nom: listeApprenant[i].Perso_Nom,
        Perso_Prenom: listeApprenant[i].Perso_Prenom,
        Tiers_NomPublic: this.getSocieterApprenent(
          listeApprenant[i].Perso_Matricule
        ),
        testExpande: false,
        detail: detail,
      });
    }
    this.listeFinanceurByApprenant = new MatTableDataSource(
      listeFinanceurByApprenant
    );
  }
  getSocieterApprenent(Perso_Matricule): string {
    return '';
  }
  async getFinanceurApprenant() {
    var listeFinanceur = await this.generalService
      .rechercheTable(
        this.generalService.url + 'avtactionfinanceur&param=' + this.param_code
      )
      .toPromise();
    return listeFinanceur; //= this.generalService.generateListeFinanceur(listeFinanceur,this.listeModePaiement,this.listeTva,this.listeModeFacturation,this.listeDelaiReglement)
  }

  removeApprenat() {
    var property = 'Perso_Matricule';
    if (this.typeAction == '2') property = 'User_Id';
    this.listeApprenantsComponen.setDataSource(
      this.listeApprenantsComponen.dataSource.data.concat([
        this.listeApprenantGroupeComponen.row,
      ])
    );
    var data = this.listeApprenantGroupeComponen.dataSource.data;
    [this.listeApprenantGroupeComponen.row].forEach((selectedRow) => {
      data = data.filter((row) => {
        return row[property] != selectedRow[property];
      });
    });
    this.listeApprenantGroupeComponen.setDataSource(data);
    this.listeApprenantGroupeComponen.row = null;
    //Actiin Administrative
    if (this.typeAction == '1') this.setDataListeCollaborateurComponen();
  }
  typePresenceActionChange(formaterHeurTypePresence: boolean) {
    if (formaterHeurTypePresence) this.formaterHeurTypePresence();
    this.fillAvtActionTypeDToCalmois(this.initAction.avtActionTypeD);
  }
  // fillHeurAvtActionTypeD()
  // {
  //   var avtActionTypeD = this.initAction.avtActionTypeD.filter(actionTypeD => {return actionTypeD.avtActionType_Id == this.selectedTypePresence})
  //   if(avtActionTypeD.length > 0)
  //   {
  //     this.typePresenceHeureDebAM = this.dateService.setValideFormaTime(avtActionTypeD[0].avtActionTypeD_heureDebAM) ;
  //     this.typePresenceHeureFinAM = this.dateService.setValideFormaTime(avtActionTypeD[0].avtActionTypeD_heureFinAM) ;
  //     this.typePresenceHeureDebPM = this.dateService.setValideFormaTime(avtActionTypeD[0].avtActionTypeD_heureDebPM) ;
  //     this.typePresenceHeureFinPM = this.dateService.setValideFormaTime(avtActionTypeD[0].avtActionTypeD_heureFinPM) ;
  //   }

  // }
  formaterHeurTypePresence() {
    this.typePresenceHeureDebAM = this.generalService.clone(
      this.action.avtAction_heureDebAM
    );
    this.typePresenceHeureFinAM = this.generalService.clone(
      this.action.avtAction_heureFinAM
    );
    this.typePresenceHeureDebPM = this.generalService.clone(
      this.action.avtAction_heureDebPM
    );
    this.typePresenceHeureFinPM = this.generalService.clone(
      this.action.avtAction_heureFinPM
    );
  }
  formaterHeurAction() {
    this.action.avtAction_heureDebAM = this.dateService.setFormaTime(
      this.action.avtAction_heureDebAM
    );
    this.action.avtAction_heureDebPM = this.dateService.setFormaTime(
      this.action.avtAction_heureDebPM
    );
    this.action.avtAction_heureFinAM = this.dateService.setFormaTime(
      this.action.avtAction_heureFinAM
    );
    this.action.avtAction_heureFinPM = this.dateService.setFormaTime(
      this.action.avtAction_heureFinPM
    );
    if (this.action.avtAction_heureDebAM == '') {
      if (this.generalService.isNotEmpty(this.paramHeure.avtHeureAM_Deb))
        this.action.avtAction_heureDebAM = this.paramHeure.avtHeureAM_Deb;
      else this.action.avtAction_heureDebAM = '00:00';
    }
    if (this.action.avtAction_heureFinAM == '') {
      if (this.generalService.isNotEmpty(this.paramHeure.avtHeureAM_Fin))
        this.action.avtAction_heureFinAM = this.paramHeure.avtHeureAM_Fin;
      else this.action.avtAction_heureFinAM = '00:00';
    }
    if (this.action.avtAction_heureDebPM == '') {
      if (this.generalService.isNotEmpty(this.paramHeure.avtHeurePM_Deb))
        this.action.avtAction_heureDebPM = this.paramHeure.avtHeurePM_Deb;
      else this.action.avtAction_heureDebPM = '00:00';
    }
    if (this.action.avtAction_heureFinPM == '') {
      if (this.generalService.isNotEmpty(this.paramHeure.avtHeurePM_Fin))
        this.action.avtAction_heureFinPM = this.paramHeure.avtHeurePM_Fin;
      else this.action.avtAction_heureFinPM = '00:00';
    }
    this.initActionStr = JSON.stringify(this.initAction);
    this.setParamHeureCalendar();
  }
  setParamHeureCalendar() {
    this.paramHeureCalendar = this.generalService.clone(this.paramHeure);
    if (
      this.generalService.isNotEmpty(this.paramHeureCalendar.avtHeure_Ecart)
    ) {
      if (this.paramHeureCalendar.avtHeure_Ecart.toString().length == 1)
        this.paramHeureCalendar.avtHeure_Ecart =
          '0' + this.paramHeureCalendar.avtHeure_Ecart;
      if (this.typeTrs != '1') {
        this.paramHeureCalendar.avtHeurePM_Deb =
          this.action.avtAction_heureDebPM;
        this.paramHeureCalendar.avtHeurePM_Fin =
          this.action.avtAction_heureFinPM;
        this.paramHeureCalendar.avtHeureAM_Deb =
          this.action.avtAction_heureDebAM;
        this.paramHeureCalendar.avtHeureAM_Fin =
          this.action.avtAction_heureFinAM;
      }
    }
  }

  createJsonActionD(
    avtActionD_Code,
    avtAction_Code,
    avtActionD_Type,
    avtActionD_date,
    avtActionD_heureDebAM,
    avtActionD_heureFinAM,
    avtActionD_heureDebPM,
    avtActionD_heureFinPM,
    avtActionD_Info,
    Perso_Matricule,
    avtActionD_suivi,
    avtActionD_remarque,
    Machine_Code,
    Cursus_Code
  ) {
    return {
      avtActionD_Code: avtActionD_Code,
      avtAction_Code: avtAction_Code,
      avtActionD_Type: avtActionD_Type,
      avtActionD_date: avtActionD_date,
      avtActionD_heureDebAM: avtActionD_heureDebAM,
      avtActionD_heureFinAM: avtActionD_heureFinAM,
      avtActionD_heureDebPM: avtActionD_heureDebPM,
      avtActionD_heureFinPM: avtActionD_heureFinPM,
      avtActionD_Info: avtActionD_Info,
      Perso_Matricule: Perso_Matricule,
      U_timestamp: null,
      avtActionD_suivi: avtActionD_suivi,
      avtActionD_remarque: avtActionD_remarque,
      avtActionD_Staut: null,
      Doc_Num: null,
      Machine_Code: Machine_Code,
      Cursus_Code: Cursus_Code,
    };
  }

  getActionDAfterSaveEvent() {
    this.param_code = this.action.avtAction_Code;
    this.generalService
      .rechercheTable(globalUrls.urlActionD + this.param_code)
      .subscribe(
        (data) => {
          this.exist = true;
          this.listeActionD = data.avtactionD;
          this.eventsCalandarAction = this.createEventsCalandar(
            this.listeActionD,
            !this.disabled,
            this.getTypeAction().avtParamAction_ColorAction,
            this.getTypeAction().avtParamAction_ColorText
          );
          //action de prestation
          if (this.typeAction == '2') {
            this.setDataSourceListeCollaborateur();
            this.fillAvtActionTypeDToCalmois(
              this.convertAvtactiondToAvtActionTypeD(this.listeActionD)
            );
            if (this.calendarModificationActionComponent)
              this.setEventsCalandarModification(false);
          } else {
            this.refrechCalendarAction(null, null, false, null);
            this.generateListeMatiereCursus();
          }
        },
        (error) => {
          this.exist = true;
          this.generalService.dialogSuccess(
            'Erreur de rafrésissement du calendaire',
            false
          );
        }
      );
  }
  enregistrerActionD(actionD) {
    this.deselectionCalendarAction();
    this.generalService.enregisterTable(actionD).subscribe(
      (data) => {
        this.generalService.dialogSuccess('Enregistré', true);
        this.getActionDAfterSaveEvent();
      },
      (error) => {
        this.exist = true;
        this.generalService.dialogSuccess('Non enregistré', false);
      }
    );
  }
  verifierNbrHeurMatiereEtenregistrerActionD(actionD, selectedMatiereCursus) {
    if (this.verifierNbrHeurMatiere(actionD, selectedMatiereCursus)) {
      this.enregistrerActionD(actionD);
    } else {
      this.openAvtDialogDeleteDepassmentNbrHeur(actionD);
    }
  }
  openAvtDialogDeleteDepassmentNbrHeur(actionD) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message:
        'Vous avez dépassé le nombre d’heures du matière sélectionnée. Voulez-vous continuer ?',
      btnOk: {
        class: 'colorGreen',
        icon: 'keyboard_return',
        text: 'Continuer',
      },
      btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
    };
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        this.enregistrerActionD(actionD);
      }
      if (result == 'annuler') {
      }
    });
  }
  verifierNbrHeurMatiere(actionD, selectedMatiereCursus): boolean {
    var listeActionD = this.listeActionD.concat(actionD.avtactionD);
    var nbrHeurMatiere = 0;
    var listeActionDByMatier = listeActionD.filter((actionD) => {
      return (
        actionD.Cursus_Code == selectedMatiereCursus.Matiere_Code.toString()
      );
    });
    nbrHeurMatiere = this.actionsService.getNbrHeure(listeActionDByMatier);
    if (nbrHeurMatiere > selectedMatiereCursus.CursusD_Duree) return false;
    else return true;
  }
  genererEtEnregistrerActionD() {
    this.exist = false;
    //les selection des date peux avoir 2 date dans le meme jour => listeDistinctSelectedDate contient les jour selectionner unique
    var selectedDate = this.calendarActionComponent.selectedDate;
    var actionD = { avtactionD: [] };
    selectedDate.forEach((selected_Date) => {
      var timeStart = this.dateService.extractTimeFromDate(selected_Date.start);
      var timeEnd = this.dateService.extractTimeFromDate(selected_Date.end);
      var avtActionD_heureDebAM = null;
      var avtActionD_heureFinAM = null;
      var avtActionD_heureDebPM = null;
      var avtActionD_heureFinPM = null;
      if (
        this.dateService.setFormaTime2(timeStart) != '' &&
        this.dateService.timeInclueDansInterval(
          timeStart,
          this.action.avtAction_heureDebAM,
          this.action.avtAction_heureFinAM
        )
      ) {
        avtActionD_heureDebAM = timeStart;
        avtActionD_heureFinAM = timeEnd;
      }
      if (
        this.dateService.setFormaTime2(timeStart) != '' &&
        this.dateService.timeInclueDansInterval(
          timeStart,
          this.action.avtAction_heureDebPM,
          this.action.avtAction_heureFinPM
        )
      ) {
        avtActionD_heureDebPM = timeStart;
        avtActionD_heureFinPM = timeEnd;
      }
      actionD.avtactionD.push(
        this.createJsonActionD(
          null,
          this.action.avtAction_Code,
          null,
          this.dateService.setFormatDate(selected_Date.start),
          avtActionD_heureDebAM,
          avtActionD_heureFinAM,
          avtActionD_heureDebPM,
          avtActionD_heureFinPM,
          this.selectedMatiereCursus.matiereName +
            ' ' +
            this.selectedRessourceHumaines.Perso_Nom +
            ' ' +
            this.selectedSalle.Machine_Lib,
          this.generalService.clone(
            this.selectedRessourceHumaines.Perso_Matricule
          ),
          null,
          null,
          this.generalService.clone(this.selectedSalle.Machine_Code),
          this.generalService.clone(this.selectedMatiereCursus.Matiere_Code)
        )
      );
    });
    this.verifierNbrHeurMatiereEtenregistrerActionD(
      actionD,
      this.selectedMatiereCursus
    );
  }

  openFrmModifierPlanificationFullCall(
    frmModifierPlanificationFullCall,
    mode: string
  ) {
    if (this.selectedEventForRightClickEvent) {
      if (mode == 'modifier') {
        this.titrefrmModifierPlanificationFullCall =
          'Modification planification';
        this.disabledFrmModifierPlanificationFullCall = false;
      } else {
        this.titrefrmModifierPlanificationFullCall =
          'Diplication planification';
        this.disabledFrmModifierPlanificationFullCall = true;
      }
      this.closeAllMenuContectuelle();
      const dialogConfig = new MatDialogConfig();
      this.removeWeekDuplicationEnConflieAndNotPlanifiable();
      this.fillActionDForRightClickEventToFrmModifierPlanificationFullCall();
      this.dialog.open(frmModifierPlanificationFullCall, dialogConfig);
      this.dialog.afterAllClosed.subscribe(() => {
        this.selectedEventForRightClickEvent = null;
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez placer la sourie dans la planification à ' + mode,
        false
      );
  }
  supprmierActionD() {
    if (this.selectedEventForRightClickEvent) {
      this.closeAllMenuContectuelle();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        message: 'Voulez vous supprimer cette planification',
        btnOk: {
          class: 'colorRed',
          icon: 'keyboard_return',
          text: 'Supprimer',
        },
        btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
      };
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          this.exist = false;
          this.generalService
            .supprimerSanMsgConfirm(
              this.selectedEventForRightClickEvent.extendedProps.actionD
                .avtActionD_Code,
              'avtactiond2'
            )
            .subscribe((data) => {
              this.generalService.dialogSuccess('Élément supprimé', true);
              this.getActionDAfterSaveEvent();
            });
        }
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez placer la sourie dans la planification à supprimer',
        false
      );
  }
  fillActionDForRightClickEventToFrmModifierPlanificationFullCall() {
    this.onMatiereChange(
      {
        value:
          this.selectedEventForRightClickEvent.extendedProps.actionD
            .Cursus_Code,
      },
      'selectedMatiereCursusForUpdate'
    );
    this.Perso_MatriculeSelectedRessourceHumainesForUpdate =
      this.selectedEventForRightClickEvent.extendedProps.actionD.Perso_Matricule;
    this.Machine_SelectedSalleForUpdate = Number.parseInt(
      this.selectedEventForRightClickEvent.extendedProps.actionD.Machine_Code
    );
    if (
      this.generalService.isNotEmpty(
        this.dateService.setFormaTime(
          this.selectedEventForRightClickEvent.extendedProps.actionD
            .avtActionD_heureDebAM
        )
      )
    )
      this.heureDebForUpdate = this.dateService.setFormaTime(
        this.selectedEventForRightClickEvent.extendedProps.actionD
          .avtActionD_heureDebAM
      );
    else
      this.heureDebForUpdate = this.dateService.setFormaTime(
        this.selectedEventForRightClickEvent.extendedProps.actionD
          .avtActionD_heureDebPM
      );

    if (
      this.generalService.isNotEmpty(
        this.dateService.setFormaTime(
          this.selectedEventForRightClickEvent.extendedProps.actionD
            .avtActionD_heureFinAM
        )
      )
    )
      this.heureFinForUpdate = this.dateService.setFormaTime(
        this.selectedEventForRightClickEvent.extendedProps.actionD
          .avtActionD_heureFinAM
      );
    else
      this.heureFinForUpdate = this.dateService.setFormaTime(
        this.selectedEventForRightClickEvent.extendedProps.actionD
          .avtActionD_heureFinPM
      );
  }
  planifierAction() {
    this.closeAllMenuContectuelle();
    if (this.informationActionD.form.valid) {
      if (this.calendarActionComponent.selectedDate.length > 0) {
        this.genererEtEnregistrerActionD();
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une ou plusieurs séances',
          false
        );
    } else $('#btnInformationActionD').trigger('click');
  }
  openAvtDialogDelete() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message:
        'Vous avez dépassé le nombre d’heures du cursus. Voulez-vous continuer ?',
      btnOk: {
        class: 'colorGreen',
        icon: 'keyboard_return',
        text: 'Continuer',
      },
      btnAnnuler: { class: 'colorRed', icon: 'close', text: 'Annuler' },
    };
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        this.enregistrerPlanificationCalmois();
      }
      if (result == 'annuler') {
      }
    });
  }
  setIntervalDuplicationActionD(intervalDuplicationAction) {
    if (this.informationActionD.form.valid) {
      if (this.calendarActionComponent.selectedDate.length > 0) {
        this.closeAllMenuContectuelle();
        const dialogConfig = new MatDialogConfig();
        this.removeWeekDuplicationEnConflieAndNotPlanifiable();
        this.dialog.open(intervalDuplicationAction, dialogConfig);
      } else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une ou plusieurs séances',
          false
        );
    } else $('#btnInformationActionD').trigger('click');
  }
  getListeEventDuplication(): any[] {
    var listeEvent = [];
    var dateFintDuplication = new Date(this.action.avtAction_dateFin);
    var dateFintDuplicationNumber: number;
    //pour elimer les heur et minute et la convertir en nembre
    dateFintDuplicationNumber = new Date(
      dateFintDuplication.getFullYear(),
      dateFintDuplication.getMonth(),
      dateFintDuplication.getDate()
    ).getTime();
    this.calendarActionComponent.selectedDate.forEach((selectedEvent) => {
      listeEvent.push(selectedEvent);
      var evetDuplicated = this.generalService.clone(selectedEvent);
      do {
        evetDuplicated.start.setDate(evetDuplicated.start.getDate() + 7);
        evetDuplicated.end.setDate(evetDuplicated.end.getDate() + 7);
        var dateDuplicationNumber = new Date(
          evetDuplicated.end.getFullYear(),
          evetDuplicated.end.getMonth(),
          evetDuplicated.end.getDate()
        ).getTime();
        if (dateDuplicationNumber <= dateFintDuplicationNumber)
          listeEvent.push(this.generalService.clone(evetDuplicated));
      } while (dateDuplicationNumber <= dateFintDuplicationNumber);
    });
    return listeEvent;
  }
  eventEnConflie(listeEventWeek: any[]): boolean {
    var conflie = false;
    var listeEvent = [];
    listeEvent = this.generalService.clone(this.eventsCalandarAction);
    this.concateListeEvent(this.eventsCalandarSalle, listeEvent);
    this.concateListeEvent(this.eventsCalandarRessourceHymaine, listeEvent);
    listeEventWeek.forEach((event) => {
      if (this.actionsService.eventInclueInListeEvent(listeEvent, event))
        conflie = true;
    });
    return conflie;
  }
  removeWeekDuplicationEnConflieAndNotPlanifiable() {
    var liseEventDuplication = this.getListeEventDuplication();

    this.listMonth.forEach((month) => {
      if (month.listeWeek) {
        month.listeWeek.forEach((week) => {
          var listeEventWeek = this.getLiseEventWeek(
            week,
            liseEventDuplication
          );
          if (this.eventEnConflie(listeEventWeek)) week['haveConflie'] = true;

          if (this.listeEventWeekHaveDateNotPlanifiable(listeEventWeek))
            week['notPlanifiable'] = true;
        });
        if (
          month.listeWeek.filter((week) => {
            return !week.haveConflie && !week.notPlanifiable;
          }).length == 0
        ) {
          month.planifiable = false;
        }
      } else month.planifiable = false;
    });
  }
  listeEventWeekHaveDateNotPlanifiable(listeEventWeek): boolean {
    var notPlanifiable = false;
    listeEventWeek.forEach((eventWeek) => {
      if (!this.datePlanifiable(eventWeek.start)) notPlanifiable = true;
    });
    return notPlanifiable;
  }
  getLiseEventWeek(week, listeEvent) {
    var liseEventWeek = [];
    listeEvent.forEach((event) => {
      var weekEvent = this.dateService.getWeekNumber(event.start);
      if (weekEvent == week.colSpan) liseEventWeek.push(event);
    });
    return liseEventWeek;
  }
  dupliquerAction2() {
    this.exist = false;
    this.closeWindowsDiplication();
    this.actionD = { avtactionD: [] };
    var caneSave: boolean = true;
    var listeEvent = [];
    listeEvent = this.generalService.clone(this.eventsCalandarAction);
    this.concateListeEvent(this.eventsCalandarSalle, listeEvent);
    this.concateListeEvent(this.eventsCalandarRessourceHymaine, listeEvent);

    this.msgErrorDateConflie = '';
    var selected_Date = {
      id: this.selectedEventForRightClickEvent.id,
      start: this.selectedEventForRightClickEvent.start,
      end: this.selectedEventForRightClickEvent.end,
    };

    var timeStart = this.dateService.extractTimeFromDate(selected_Date.start);
    var timeEnd = this.dateService.extractTimeFromDate(selected_Date.end);
    var avtActionD_heureDebAM = null;
    var avtActionD_heureFinAM = null;
    var avtActionD_heureDebPM = null;
    var avtActionD_heureFinPM = null;
    if (
      this.dateService.setFormaTime2(timeStart) != '' &&
      this.dateService.timeInclueDansInterval(
        timeStart,
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM
      )
    ) {
      avtActionD_heureDebAM = timeStart;
      avtActionD_heureFinAM = timeEnd;
    }
    if (
      this.dateService.setFormaTime2(timeStart) != '' &&
      this.dateService.timeInclueDansInterval(
        timeStart,
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      )
    ) {
      avtActionD_heureDebPM = timeStart;
      avtActionD_heureFinPM = timeEnd;
    }
    var ressource = this.listeRessourcesHumaines.find((re) => {
      return (
        re.Perso_Matricule ==
        this.Perso_MatriculeSelectedRessourceHumainesForUpdate
      );
    });
    var salle = this.listeSalles.find((sal) => {
      return sal.Machine_Code == this.Machine_SelectedSalleForUpdate;
    });
    //this.actionD.avtactionD.push(this.createJsonActionD(null,this.action.avtAction_Code,null,this.dateService.setFormatDate(selected_Date.start),avtActionD_heureDebAM,avtActionD_heureFinAM,avtActionD_heureDebPM,avtActionD_heureFinPM,this.selectedMatiereCursusForUpdate.matiereName + " " + ressource.Perso_Nom + " " + salle.Machine_Lib,ressource.Perso_Matricule,null,null,salle.Machine_Code,this.generalService.clone(this.selectedMatiereCursusForUpdate.Matiere_Code)));
    //pour enlever l'heur et minute du dateDupliquated
    var dateDupliquatedSansTime = new Date(
      this.dateService.setToFormatDateServerStr(selected_Date.start)
    );
    var dateStartDupliquated = this.generalService.clone(selected_Date.start);
    var dateEndDupliquated = this.generalService.clone(selected_Date.end);

    do {
      dateDupliquatedSansTime.setDate(dateDupliquatedSansTime.getDate() + 7);
      dateStartDupliquated.setDate(dateStartDupliquated.getDate() + 7);
      dateEndDupliquated.setDate(dateEndDupliquated.getDate() + 7);
      if (
        dateDupliquatedSansTime.getTime() <=
          new Date(
            this.dateService.setToFormatDateServerStr(
              new Date(this.action.avtAction_dateFin)
            )
          ).getTime() &&
        this.dateInclueDanssIntervalDuplication(dateDupliquatedSansTime)
      ) {
        var dateDupliquatedCopie = this.generalService.clone(
          dateDupliquatedSansTime
        );
        var evetForTestValideDate = this.generalService.clone(selected_Date);
        evetForTestValideDate.start =
          this.generalService.clone(dateStartDupliquated);
        evetForTestValideDate.end =
          this.generalService.clone(dateEndDupliquated);
        if (
          this.actionsService.eventInclueInListeEvent(
            listeEvent,
            evetForTestValideDate
          )
        ) {
          this.msgErrorDateConflie +=
            ' ' + this.dateService.setFormatDate(dateStartDupliquated);
          caneSave = false;
        }
        this.actionD.avtactionD.push(
          this.createJsonActionD(
            null,
            this.action.avtAction_Code,
            null,
            this.dateService.setFormatDate(dateDupliquatedCopie),
            avtActionD_heureDebAM,
            avtActionD_heureFinAM,
            avtActionD_heureDebPM,
            avtActionD_heureFinPM,
            this.selectedMatiereCursusForUpdate.matiereName +
              ' ' +
              ressource.Perso_Nom +
              ' ' +
              salle.Machine_Lib,
            ressource.Perso_Matricule,
            null,
            null,
            salle.Machine_Code,
            this.selectedMatiereCursusForUpdate.Matiere_Code
          )
        );
      }
    } while (
      dateDupliquatedSansTime.getTime() <=
      new Date(
        this.dateService.setToFormatDateServerStr(
          new Date(this.action.avtAction_dateFin)
        )
      ).getTime()
    );
    if (caneSave) {
      this.verifierNbrHeurMatiereEtenregistrerActionD(
        this.actionD,
        this.selectedMatiereCursusForUpdate
      );
    } else {
      this.exist = true;
      const dialogConfig = new MatDialogConfig();
      this.dialog.open(this.fconfirmDuplicationEnConflie, dialogConfig);
    }
  }
  dupliquerAction() {
    this.exist = false;
    this.closeWindowsDiplication();
    this.actionD = { avtactionD: [] };
    var caneSave: boolean = true;
    var listeEvent = [];
    listeEvent = this.generalService.clone(this.eventsCalandarAction);
    this.concateListeEvent(this.eventsCalandarSalle, listeEvent);
    this.concateListeEvent(this.eventsCalandarRessourceHymaine, listeEvent);

    this.msgErrorDateConflie = '';
    this.calendarActionComponent.selectedDate.forEach((selected_Date) => {
      var timeStart = this.dateService.extractTimeFromDate(selected_Date.start);
      var timeEnd = this.dateService.extractTimeFromDate(selected_Date.end);
      var avtActionD_heureDebAM = null;
      var avtActionD_heureFinAM = null;
      var avtActionD_heureDebPM = null;
      var avtActionD_heureFinPM = null;
      if (
        this.dateService.setFormaTime2(timeStart) != '' &&
        this.dateService.timeInclueDansInterval(
          timeStart,
          this.action.avtAction_heureDebAM,
          this.action.avtAction_heureFinAM
        )
      ) {
        avtActionD_heureDebAM = timeStart;
        avtActionD_heureFinAM = timeEnd;
      }
      if (
        this.dateService.setFormaTime2(timeStart) != '' &&
        this.dateService.timeInclueDansInterval(
          timeStart,
          this.action.avtAction_heureDebPM,
          this.action.avtAction_heureFinPM
        )
      ) {
        avtActionD_heureDebPM = timeStart;
        avtActionD_heureFinPM = timeEnd;
      }
      this.actionD.avtactionD.push(
        this.createJsonActionD(
          null,
          this.action.avtAction_Code,
          null,
          this.dateService.setFormatDate(selected_Date.start),
          avtActionD_heureDebAM,
          avtActionD_heureFinAM,
          avtActionD_heureDebPM,
          avtActionD_heureFinPM,
          this.selectedMatiereCursus.matiereName +
            ' ' +
            this.selectedRessourceHumaines.Perso_Nom +
            ' ' +
            this.selectedSalle.Machine_Lib,
          this.selectedRessourceHumaines.Perso_Matricule,
          null,
          null,
          this.selectedSalle.Machine_Code,
          this.generalService.clone(this.selectedMatiereCursus.Matiere_Code)
        )
      );
      //pour enlever l'heur et minute du dateDupliquated
      var dateDupliquatedSansTime = new Date(
        this.dateService.setToFormatDateServerStr(selected_Date.start)
      );
      var dateStartDupliquated = this.generalService.clone(selected_Date.start);
      var dateEndDupliquated = this.generalService.clone(selected_Date.end);

      do {
        dateDupliquatedSansTime.setDate(dateDupliquatedSansTime.getDate() + 7);
        dateStartDupliquated.setDate(dateStartDupliquated.getDate() + 7);
        dateEndDupliquated.setDate(dateEndDupliquated.getDate() + 7);
        if (
          dateDupliquatedSansTime.getTime() <=
            new Date(
              this.dateService.setToFormatDateServerStr(
                new Date(this.action.avtAction_dateFin)
              )
            ).getTime() &&
          this.dateInclueDanssIntervalDuplication(dateDupliquatedSansTime)
        ) {
          var dateDupliquatedCopie = this.generalService.clone(
            dateDupliquatedSansTime
          );
          var evetForTestValideDate = this.generalService.clone(selected_Date);
          evetForTestValideDate.start =
            this.generalService.clone(dateStartDupliquated);
          evetForTestValideDate.end =
            this.generalService.clone(dateEndDupliquated);
          if (
            this.actionsService.eventInclueInListeEvent(
              listeEvent,
              evetForTestValideDate
            )
          ) {
            this.msgErrorDateConflie +=
              ' ' + this.dateService.setFormatDate(dateStartDupliquated);
            caneSave = false;
          }
          this.actionD.avtactionD.push(
            this.createJsonActionD(
              null,
              this.action.avtAction_Code,
              null,
              dateDupliquatedCopie,
              avtActionD_heureDebAM,
              avtActionD_heureFinAM,
              avtActionD_heureDebPM,
              avtActionD_heureFinPM,
              this.selectedMatiereCursus.matiereName +
                ' ' +
                this.selectedRessourceHumaines.Perso_Nom +
                ' ' +
                this.selectedSalle.Machine_Lib,
              this.selectedRessourceHumaines.Perso_Matricule,
              null,
              null,
              this.selectedSalle.Machine_Code,
              this.selectedMatiereCursus.Matiere_Code
            )
          );
        }
      } while (
        dateDupliquatedSansTime.getTime() <=
        new Date(
          this.dateService.setToFormatDateServerStr(
            new Date(this.action.avtAction_dateFin)
          )
        ).getTime()
      );
    });
    if (caneSave) {
      this.verifierNbrHeurMatiereEtenregistrerActionD(
        this.actionD,
        this.selectedMatiereCursus
      );
    } else {
      this.exist = true;
      const dialogConfig = new MatDialogConfig();
      this.dialog.open(this.fconfirmDuplicationEnConflie, dialogConfig);
    }
  }
  dateInclueDanssIntervalDuplication(dateDupliquatedSansTime: Date): boolean {
    var monthDateDupliquatedSansTime = dateDupliquatedSansTime.getMonth();
    var actuelleWeek = this.dateService.getWeekNumber(dateDupliquatedSansTime);
    var listeDuplicatedWeek = [];
    this.listMonth.forEach((months) => {
      months.listeWeek.forEach((week) => {
        if (!week.haveConflie && week.selected && !week.notPlanifiable)
          listeDuplicatedWeek.push(week);
      });
    });
    var findWeek = listeDuplicatedWeek.find((week) => {
      var month = this.dateService.convertStrToDate(week.monthName).getMonth();
      return (
        week.colSpan == actuelleWeek && month == monthDateDupliquatedSansTime
      );
    });
    if (findWeek) return true;
    else return false;
  }
  closeWindowsDiplication() {
    this.dialog.closeAll();
  }
  getListeTva() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM01')
      .subscribe((data) => {
        this.listeTva = data.DiverSys;
        // this.columnsNewDocument.TableRD[3].dataSelect = this.listeTva;
        this.listeTvaIsLoadet = true;
      });
  }
  getListeModePaiement() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM04')
      .subscribe((data) => {
        this.listeModePaiement = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeModePaiementIsLoadet = true;
      });
  }
  getListeModeFacturation() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM02')
      .subscribe((data) => {
        this.listeModeFacturation = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeModeFacturationIsLoadet = true;
      });
  }
  getListeDelaiReglement() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=COM03')
      .subscribe((data) => {
        this.listeDelaiReglement = this.generalService.sort(
          data.DiverSys,
          'DiverSys_Titre'
        );
        this.listeDelaiReglementIsLoadet = true;
      });
  }
  generateHeurAction(actionD, dateDebut, dateFin) {
    var timeStart = this.dateService.extractTimeFromDate(dateDebut);
    var timeEnd = this.dateService.extractTimeFromDate(dateFin);
    var avtActionD_heureDebAM = null;
    var avtActionD_heureFinAM = null;
    var avtActionD_heureDebPM = null;
    var avtActionD_heureFinPM = null;
    if (
      this.dateService.setFormaTime2(timeStart) != '' &&
      this.dateService.timeInclueDansInterval(
        timeStart,
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM
      )
    ) {
      avtActionD_heureDebAM = timeStart;
      avtActionD_heureFinAM = timeEnd;
    }
    if (
      this.dateService.setFormaTime2(timeStart) != '' &&
      this.dateService.timeInclueDansInterval(
        timeStart,
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      )
    ) {
      avtActionD_heureDebPM = timeStart;
      avtActionD_heureFinPM = timeEnd;
    }
    actionD.avtActionD_heureDebAM = avtActionD_heureDebAM;
    actionD.avtActionD_heureFinAM = avtActionD_heureFinAM;
    actionD.avtActionD_heureDebPM = avtActionD_heureDebPM;
    actionD.avtActionD_heureFinPM = avtActionD_heureFinPM;
    return actionD;
  }
  choisirSalle(salle) {
    if (this.generalService.isNotEmpty(salle)) {
      this.exist = false;
      this.eventsCalandarSalle = [];
      this.deselectionCalendarAction();
      this.selectedSalle = salle;
      this.selectedSalle.Machine_Lib =
        this.selectedSalle.Batiment +
        (this.generalService.isNotEmpty(this.selectedSalle.etage)
          ? ' étage ' + this.selectedSalle.etage
          : '') +
        (this.generalService.isNotEmpty(this.selectedSalle.numPort)
          ? ' porte numéro ' + this.selectedSalle.numPort
          : '');
      var avtAction_dateDeb = this.dateService.setToDate(
        this.action.avtAction_dateDeb
      );
      var avtAction_dateFin = this.dateService.setToDate(
        this.action.avtAction_dateFin
      );
      var url =
        globalUrls.urlavtactionDMachineDate +
        salle.Machine_Code +
        ',' +
        this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
        ',' +
        this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
      this.generalService.rechercheTable(url).subscribe((data) => {
        this.exist = true;
        this.eventsCalandarSalle = this.createEventsCalandar(
          data.filter((actionD) => {
            return actionD.avtAction_Code != this.action.avtAction_Code;
          }),
          !this.disabled,
          'rgb(90, 92, 197)',
          'white'
        );
        this.refrechCalendarAction(null, null, false, null);
      });
    }
  }
  deselectionCalendarAction() {
    this.calendarActionComponent.selectedDate.forEach((selectedDate) => {
      this.calendarActionComponent.calendarComponent
        .getEventById(selectedDate.id)
        .remove();
    });
    this.calendarActionComponent.selectedDate = [];
  }
  selectionTimeDansParamHeure(timeStar, timeEnd) {
    //si selection pour AM
    if (
      this.dateService.timeInclueDansInterval(
        timeStar,
        this.calendarActionComponent.paramHeure.avtHeureAM_Deb,
        this.calendarActionComponent.paramHeure.avtHeureAM_Fin
      ) &&
      this.dateService.timeInclueDansInterval(
        timeEnd,
        this.calendarActionComponent.paramHeure.avtHeureAM_Deb,
        this.calendarActionComponent.paramHeure.avtHeureAM_Fin
      )
    ) {
      return true;
    }
    //si selection pour PM
    if (
      this.dateService.timeInclueDansInterval(
        timeStar,
        this.calendarActionComponent.paramHeure.avtHeurePM_Deb,
        this.calendarActionComponent.paramHeure.avtHeurePM_Fin
      ) &&
      this.dateService.timeInclueDansInterval(
        timeEnd,
        this.calendarActionComponent.paramHeure.avtHeurePM_Deb,
        this.calendarActionComponent.paramHeure.avtHeurePM_Fin
      )
    ) {
      return true;
    }
    return false;
  }

  createEventSelection(start: Date, end: Date, event) {
    var myevent = {
      id: '#' + this.compteur,
      title: '',
      start: start,
      end: end,
      backgroundColor: 'rgba(150,150,150, 0.3)',
      editable: false,
    };
    this.compteur++;
    var calendar = event.calendarComponent;
    calendar.addEvent(myevent);
    this.calendarActionComponent.selectedDate.push(myevent);
  }
  listeEventInValideIntervaleDate(listeEvent): boolean {
    var find = false;
    listeEvent.forEach((event) => {
      if (this.eventInValideIntervaleDate(event)) find = true;
    });
    return find;
  }
  eventInValideIntervaleDate(event): boolean {
    //si selection pour AM
    if (
      this.dateService.timeInclueDansInterval(
        event.start.getHours() + ':' + event.start.getMinutes(),
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM
      ) &&
      this.dateService.timeInclueDansInterval(
        event.end.getHours() + ':' + event.end.getMinutes(),
        this.action.avtAction_heureDebAM,
        this.action.avtAction_heureFinAM
      )
    ) {
      return true;
    }
    //si selection pour PM
    if (
      this.dateService.timeInclueDansInterval(
        event.start.getHours() + ':' + event.start.getMinutes(),
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      ) &&
      this.dateService.timeInclueDansInterval(
        event.end.getHours() + ':' + event.end.getMinutes(),
        this.action.avtAction_heureDebPM,
        this.action.avtAction_heureFinPM
      )
    ) {
      return true;
    }
    return false;
  }
  saveActionD(
    listeEvent,
    Cursus_Code?,
    Machine_Code?,
    Perso_Matricule?,
    avtActionD_Info?
  ) {
    var compte = listeEvent.length;
    for (let i = 0; i < listeEvent.length; i++) {
      var code = listeEvent[i].extendedProps.actionD.avtActionD_Code;
      if (this.typeAction == '2')
        code = listeEvent[i].extendedProps.actionD.avtActionTypeD_Id;
      this.generalService
        .rechercheTable(globalUrls.urlActionD2 + '&val=' + code)
        .subscribe(
          (actionD) => {
            actionD.avtactionD[0].avtActionD_date =
              this.dateService.setToFormatDateServerStr(listeEvent[i].start);
            var timeStart = this.dateService.extractTimeFromDate(
              listeEvent[i].start
            );
            var timeEnd = this.dateService.extractTimeFromDate(
              listeEvent[i].end
            );
            if (
              this.dateService.setFormaTime2(timeStart) != '' &&
              this.dateService.timeInclueDansInterval(
                timeStart,
                this.action.avtAction_heureDebAM,
                this.action.avtAction_heureFinAM
              )
            ) {
              actionD.avtactionD[0].avtActionD_heureDebAM = timeStart;
              actionD.avtactionD[0].avtActionD_heureFinAM = timeEnd;
            }
            if (
              this.dateService.setFormaTime2(timeStart) != '' &&
              this.dateService.timeInclueDansInterval(
                timeStart,
                this.action.avtAction_heureDebPM,
                this.action.avtAction_heureFinPM
              )
            ) {
              actionD.avtactionD[0].avtActionD_heureDebPM = timeStart;
              actionD.avtactionD[0].avtActionD_heureFinPM = timeEnd;
            }
            if (Cursus_Code) actionD.avtactionD[0].Cursus_Code = Cursus_Code;
            if (Machine_Code) actionD.avtactionD[0].Machine_Code = Machine_Code;
            if (Perso_Matricule)
              actionD.avtactionD[0].Perso_Matricule = Perso_Matricule;
            if (avtActionD_Info)
              actionD.avtactionD[0].avtActionD_Info = avtActionD_Info;
            this.generalService.enregisterTable(actionD).subscribe(
              (data) => {
                this.generalService.dialogSuccess('Enregistré', true);
                compte--;
                if (compte == 0) this.getActionDAfterSaveEvent();
              },
              (error) => {
                compte--;
                if (compte == 0) this.getActionDAfterSaveEvent();
                this.exist = true;
                this.generalService.dialogSuccess('Non enregistré', false);
              }
            );
          },
          (error) => {
            compte--;
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
    }
  }
  saveActionDForUpdate(
    avtActionD_Code,
    Perso_Matricule,
    avtActionD_Info,
    avtActionD_Type,
    avtActionD_date,
    avtActionD_heureDebAM,
    avtActionD_heureDebPM,
    avtActionD_heureFinAM,
    avtActionD_heureFinPM
  ) {
    this.generalService
      .rechercheTable(globalUrls.urlActionD2 + '&val=' + avtActionD_Code)
      .subscribe(
        (actionD) => {
          actionD.avtactionD[0].avtActionD_date = avtActionD_date;
          actionD.avtactionD[0].avtActionD_Type = avtActionD_Type;
          if (this.MatinTypePresenceChecked) {
            actionD.avtactionD[0].avtActionD_heureDebAM = avtActionD_heureDebAM;
            actionD.avtactionD[0].avtActionD_heureFinAM = avtActionD_heureFinAM;
          }
          if (this.ApMidiTypePresenceChecked) {
            actionD.avtactionD[0].avtActionD_heureDebPM = avtActionD_heureDebPM;
            actionD.avtactionD[0].avtActionD_heureFinPM = avtActionD_heureFinPM;
          }
          actionD.avtactionD[0].Perso_Matricule = Perso_Matricule;
          actionD.avtactionD[0].avtActionD_Info = avtActionD_Info;
          this.generalService.enregisterTable(actionD).subscribe(
            (data) => {
              this.exist = true;
              this.generalService.dialogSuccess('Enregistré', true);
              this.getActionDAfterSaveEvent();
            },
            (error) => {
              this.generalService.dialogSuccess('Non enregistré', false);
              this.getActionDAfterSaveEvent();
            }
          );
        },
        (error) => {
          this.generalService.dialogSuccess('Non enregistré', false);
          this.getActionDAfterSaveEvent();
        }
      );
  }
  verificationAndSaveEventAfterChange(oldEvent, newEvent, listeEvent) {
    var avtAction_dateDeb = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var avtAction_dateFin = this.dateService.setToDate(
      this.action.avtAction_dateFin
    );
    var url =
      globalUrls.urlavtactionDColDate +
      oldEvent.event.event.extendedProps.actionD.Perso_Matricule +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
    var listeEventRessource;
    var listeEventSalle;
    //verification du disponibiliter de ressource tous les autre action
    this.generalService.rechercheTable(url).subscribe(
      (actionDRessource) => {
        listeEventRessource = this.createEventsCalandar(
          actionDRessource.filter((actionD) => {
            return (
              actionD.avtActionD_Code !=
              oldEvent.event.event.extendedProps.actionD.avtActionD_Code
            );
          }),
          false,
          'rgb(250, 239, 89)',
          'white'
        );
        if (
          this.actionsService.eventInclueInListeEvent(
            listeEventRessource,
            newEvent
          )
        ) {
          this.exist = true;
          this.annulerModificationEventCalendar(oldEvent);
        } else {
          //verification du disponibiliter de salle dans tous les autre action
          url =
            globalUrls.urlavtactionDMachineDate +
            oldEvent.event.event.extendedProps.actionD.Machine_Code +
            ',' +
            this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
            ',' +
            this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
          this.generalService.rechercheTable(url).subscribe(
            (actionDSalle) => {
              listeEventSalle = this.createEventsCalandar(
                actionDSalle.filter((actionD) => {
                  return (
                    actionD.avtActionD_Code !=
                    oldEvent.event.event.extendedProps.actionD.avtActionD_Code
                  );
                }),
                false,
                'rgb(90, 92, 197)',
                'white'
              );
              if (
                this.actionsService.eventInclueInListeEvent(
                  listeEventSalle,
                  newEvent
                )
              ) {
                this.exist = true;
                this.annulerModificationEventCalendar(oldEvent);
              } else {
                //verification du disponibiliter du l'action  dans l'action actuelle
                if (
                  this.actionsService.eventInclueInListeEvent(
                    listeEvent,
                    newEvent
                  ) ||
                  !this.eventInValideIntervaleDate(newEvent)
                ) {
                  this.exist = true;
                  this.annulerModificationEventCalendar(oldEvent);
                } else {
                  this.saveActionD([newEvent]);
                }
              }
            },
            (err) => {
              this.exist = true;
              this.annulerModificationEventCalendar(oldEvent);
            }
          );
        }
      },
      (err) => {
        this.exist = true;
        this.annulerModificationEventCalendar(oldEvent);
      }
    );
  }
  verificationAndSaveEventAfterChange2(oldEvent, newEvent) {
    if (this.verifierHeurPlanificationCalmois([{ date: newEvent.start }])) {
      var url = globalUrls.urlAction + '&val=' + this.param_code;
      var listeEventRessource;
      //Action de prestation
      if (this.typeAction == '2') {
        //url = this.generalService.urlActionD +this.param_code;
        var avtAction_dateDeb = this.dateService.setFormatDateRechercheServer(
          this.dateService.setToDate(this.action.avtAction_dateDeb)
        );
        var avtAction_dateFin = this.dateService.setFormatDateRechercheServer(
          this.dateService.setToDate(this.action.avtAction_dateFin)
        );
        url =
          'recherche/tbdata?tablere=avtActionDP&param=' +
          avtAction_dateDeb +
          ',' +
          avtAction_dateFin +
          ',' +
          this.collaborateurCalendrierActionForUpdateComponent
            .valueColonneToReturn;
      }
      this.exist = false;
      //verification du disponibiliter de ressource tous les autre action
      this.generalService.rechercheTable(url).subscribe(
        (action) => {
          var liste = action.avtActionTypeD;
          if (this.typeAction == '2')
            liste = this.convertAvtactiondToAvtActionTypeD(action);

          liste = liste.filter((actionD) => {
            return (
              actionD.avtActionTypeD_Id !=
              newEvent.extendedProps.actionD.avtActionTypeD_Id
            );
          });
          listeEventRessource = this.createEventsCalandar2(
            liste,
            false,
            'rgb(250, 239, 89)',
            'white'
          );
          if (
            this.actionsService.eventInclueInListeEvent(
              listeEventRessource,
              newEvent
            )
          ) {
            this.annulerModificationEventCalendar2(oldEvent);
            this.generalService.dialogSuccess('Action en conflit', false);
            this.exist = true;
          } else {
            //action de prestation
            if (this.typeAction == '2') {
              this.saveActionDForUpdate(
                newEvent.extendedProps.actionD.avtActionTypeD_Id,
                this.collaborateurCalendrierActionForUpdateComponent
                  .valueColonneToReturn,
                this.actionDIntitule,
                this.typeActionD,
                this.dateService.setToFormatDateServerStr(newEvent.start),
                this.typePresenceHeureDebAM,
                this.typePresenceHeureDebPM,
                this.typePresenceHeureFinAM,
                this.typePresenceHeureFinPM
              );
            } else this.saveAvtActionTypeD(action, newEvent);
          }
        },
        (err) => {
          this.exist = true;
          this.annulerModificationEventCalendar2(oldEvent);
        }
      );
    } else
      this.generalService.dialogSuccess(
        "les heures de planification sont en dehors de la plage horaire de l'action",
        false
      );
  }
  saveAvtActionTypeD(action, newEvent) {
    var actionD = newEvent.extendedProps.actionD;
    var avtActionTypeD = action.avtActionTypeD.find((avtActionTypeD) => {
      return avtActionTypeD.avtActionTypeD_Id == actionD.avtActionTypeD_Id;
    });
    if (avtActionTypeD) {
      avtActionTypeD.avtActionType_Id =
        newEvent.extendedProps.actionD.avtActionType_Id;
      if (newEvent.id.indexOf('AM') >= 0) {
        avtActionTypeD.avtActionTypeD_heureDebAM =
          this.dateService.extractTimeFromDate(newEvent.start);
        avtActionTypeD.avtActionTypeD_heureFinAM =
          this.dateService.extractTimeFromDate(newEvent.end);
      }
      if (newEvent.id.indexOf('PM') >= 0) {
        avtActionTypeD.avtActionTypeD_heureDebPM =
          this.dateService.extractTimeFromDate(newEvent.start);
        avtActionTypeD.avtActionTypeD_heureFinPM =
          this.dateService.extractTimeFromDate(newEvent.end);
      }
      this.generalService
        .enregisterTable(
          this.generalService.supprimerTableVideAction(
            action,
            this.tabProperty,
            'avtAction_Code'
          )
        )
        .subscribe(
          () => {
            this.initAction = action;
            this.exist = true;
            this.generalService.dialogSuccess('Enregistré', true);
            this.typePresenceActionChange(false);
            this.setDataSourceListeCollaborateur();
          },
          (error) => {
            this.exist = true;
            this.generalService.dialogSuccess('Non enregistré', false);
          }
        );
    }
  }
  genererSalle() {
    var distinctType = this.generalService.distinct(this.listeSalles, 'type');
    this.listeSallesForMatSelect = [];
    distinctType.forEach((type) => {
      this.listeSallesForMatSelect.push({
        type: type,
        detail: this.generalService.sort(
          this.listeSalles.filter((salle) => {
            return salle.type == type;
          }),
          'Batiment'
        ),
      });
    });
  }
  getListeSalles() {
    if (this.listeSalles.length == 0)
      this.generalService
        .rechercheTable(this.generalService.url + 'avtMachineT&param=2')
        .subscribe((data) => {
          // this.generalService.rechercheTable(this.generalService.urlParametre+"&val=SALL01").subscribe(typeSalle =>
          //   {
          this.generalService
            .rechercheTable(globalUrls.urlParametre + '&val=SALL02')
            .subscribe((batiment) => {
              this.listeSalles = [];
              data.forEach((d) => {
                // var type = typeSalle.DiverSys.find(t => {return t.DiverSys_Index == d.Machine_Type})
                var type = this.generalService.typeSalle.find((t) => {
                  return t.DiverSys_Index == d.Machine_Type;
                });
                var titreType = '';
                if (type != undefined) titreType = type.DiverSys_Titre;
                var bati = batiment.DiverSys.find((t) => {
                  return t.DiverSys_Index == d.Machine_CapTemps;
                });
                if (bati != undefined) bati = bati.DiverSys_Titre;
                this.listeSalles.push({
                  Machine_Code: d.Machine_Code,
                  type: titreType,
                  numPort: d.Machine_Emp2,
                  Batiment: bati,
                  etage: d.Machine_Fournisseur,
                  nbrPlace: d.Machine_TR,
                });
              });
              this.genererSalle();
            });

          // });
          //
        });
  }
  getListeEventForUpdate(newEvent): any[] {
    var oldActionD = this.selectedEventForRightClickEvent.extendedProps.actionD;
    var listeActionD = this.listeActionD.filter((actionD) => {
      return (
        actionD.Cursus_Code == oldActionD.Cursus_Code &&
        actionD.Machine_Code == oldActionD.Machine_Code &&
        actionD.avtActionD_heureDebAM == oldActionD.avtActionD_heureDebAM &&
        actionD.avtActionD_heureFinAM == oldActionD.avtActionD_heureFinAM &&
        actionD.avtActionD_heureDebPM == oldActionD.avtActionD_heureDebPM &&
        actionD.avtActionD_heureFinPM == oldActionD.avtActionD_heureFinPM
      );
    });
    listeActionD.forEach((actionD) => {
      if (newEvent.id.indexOf('AM') > 0) {
        actionD.avtActionD_heureDebAM = this.heureDebForUpdate;
        actionD.avtActionD_heureFinAM = this.heureFinForUpdate;
      } else {
        actionD.avtActionD_heureDebPM = this.heureDebForUpdate;
        actionD.avtActionD_heureFinPM = this.heureFinForUpdate;
      }
    });
    var listeEvent = this.createEventsCalandar(listeActionD, false, '', '');
    listeEvent.forEach((event) => {
      event['extendedProps'] = { actionD: event.actionD };
    });
    return listeEvent;
  }
  modifierActionD() {
    var avtAction_dateDeb = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var avtAction_dateFin = this.dateService.setToDate(
      this.action.avtAction_dateFin
    );
    var url =
      globalUrls.urlavtactionDColDate +
      this.Perso_MatriculeSelectedRessourceHumainesForUpdate +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
    var listeEventRessource;
    var listeEventSalle;
    var newEvent = this.calendarActionComponent.calendarComponent.getEventById(
      this.selectedEventForRightClickEvent.id
    );
    var tabDebTime = this.heureDebForUpdate.split(':');
    var tabFinTime = this.heureFinForUpdate.split(':');
    var newEvent2 = {
      id: newEvent.id,
      start: newEvent.start,
      end: newEvent.end,
      extendedProps: { actionD: newEvent.extendedProps.actionD },
    };
    newEvent2.start.setHours(parseInt(tabDebTime[0]), parseInt(tabDebTime[1]));
    newEvent2.end.setHours(parseInt(tabFinTime[0]), parseInt(tabFinTime[1]));
    var listeNewEvent = [newEvent2];

    if (this.aplyChangeToAllPlanification)
      listeNewEvent = listeNewEvent.concat(
        this.getListeEventForUpdate(newEvent2)
      );
    //verification du disponibiliter de ressource tous les autre action
    this.exist = false;
    this.generalService.rechercheTable(url).subscribe((actionDRessource) => {
      listeEventRessource = this.createEventsCalandar(
        actionDRessource.filter((actionD) => {
          return (
            actionD.avtActionD_Code !=
            this.selectedEventForRightClickEvent.extendedProps.actionD
              .avtActionD_Code
          );
        }),
        false,
        'rgb(250, 239, 89)',
        'white'
      );
      if (
        this.actionsService.listeEventInclueInListeEvent(
          listeEventRessource,
          listeNewEvent
        )
      ) {
        this.generalService.dialogSuccess(
          'Il y a des planifications en conflits',
          false
        );
        this.exist = true;
      } else {
        //verification du disponibiliter de salle dans tous les autre action
        url =
          globalUrls.urlavtactionDMachineDate +
          this.selectedEventForRightClickEvent.extendedProps.actionD
            .Machine_Code +
          ',' +
          this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
          ',' +
          this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
        this.generalService.rechercheTable(url).subscribe((actionDSalle) => {
          listeEventSalle = this.createEventsCalandar(
            actionDSalle.filter((actionD) => {
              return (
                actionD.avtActionD_Code !=
                this.selectedEventForRightClickEvent.extendedProps.actionD
                  .avtActionD_Code
              );
            }),
            false,
            'rgb(90, 92, 197)',
            'white'
          );
          if (
            this.actionsService.listeEventInclueInListeEvent(
              listeEventSalle,
              listeNewEvent
            )
          ) {
            this.generalService.dialogSuccess(
              'Il y a des planifications en conflits',
              false
            );
            this.exist = true;
          } else {
            //verification du disponibiliter du l'action  dans l'action actuelle
            if (
              this.actionsService.listeEventInclueInListeEvent(
                this.calendarActionComponent.calendarComponent.getEvents(),
                listeNewEvent
              ) ||
              !this.listeEventInValideIntervaleDate(listeNewEvent)
            ) {
              this.generalService.dialogSuccess(
                'Il y a des planifications en conflits',
                false
              );
              this.exist = true;
            } else {
              this.saveActionD(
                listeNewEvent,
                this.selectedMatiereCursusForUpdate.Matiere_Code,
                this.Machine_SelectedSalleForUpdate,
                this.Perso_MatriculeSelectedRessourceHumainesForUpdate,
                this.genererAvtActionD_Info()
              );
            }
          }
        });
      }
    });
  }
  genererAvtActionD_Info() {
    var ressourceHumaines = this.listeRessourcesHumaines.find((ressource) => {
      return (
        ressource.Perso_Matricule ==
        this.Perso_MatriculeSelectedRessourceHumainesForUpdate
      );
    });
    if (ressourceHumaines) ressourceHumaines = ressourceHumaines.Perso_Nom;
    var salle = this.listeSalles.find((sale) => {
      return sale.Machine_Code == this.Machine_SelectedSalleForUpdate;
    });
    if (salle)
      salle =
        salle.Batiment +
        (salle.etage ? ' étage ' + salle.etage : '') +
        (salle.numPort ? ' porte numéro ' + salle.numPort : '');
    var avtActionD_Info =
      this.selectedMatiereCursusForUpdate.matiereName +
      ' ' +
      ressourceHumaines +
      ' ' +
      salle;
    return avtActionD_Info;
  }
  async getAvtactionDCol(Perso_Matricule) {
    var avtAction_dateDeb = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var avtAction_dateFin = this.dateService.setToDate(
      this.action.avtAction_dateFin
    );
    var url =
      globalUrls.urlavtactionDColDate +
      Perso_Matricule +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateDeb) +
      ',' +
      this.dateService.setFormatDateRechercheServer(avtAction_dateFin);
    return await this.generalService.rechercheTable(url).toPromise();
  }
  async blurCollaborateurCalendrierAction(Perso_Matricule) {
    this.avtactionDCol = await this.getAvtactionDCol(Perso_Matricule);
    this.fillAvtActionTypeDToCalmois(
      this.convertAvtactiondToAvtActionTypeD(this.avtactionDCol)
    );
  }
  getPremierDateDuplication(date: Date): Date {
    var day = date.getDay();
    var dateDebutAcction = this.dateService.setToDate(
      this.action.avtAction_dateDeb
    );
    var dayDateDebutAcction = dateDebutAcction.getDay();
    if (day > dayDateDebutAcction) {
      dateDebutAcction.setDate(
        dateDebutAcction.getDate() + day - dayDateDebutAcction
      );
      return dateDebutAcction;
    } else {
      dateDebutAcction.setDate(
        dateDebutAcction.getDate() + (7 - dayDateDebutAcction + day)
      );
      return dateDebutAcction;
    }
  }
  async dupliquerActionPrestation() {
    var listeSelectedAvtActionD_date = this.calmoisComponens.selectedDays.map(
      (day) => {
        return day.strDate;
      }
    );
    var listeSelectedAvtActionD_dateStr =
      ';' +
      listeSelectedAvtActionD_date.reduce((a, b) => {
        return a + ';' + b;
      }) +
      ';';
    var listeactionDToDuplicate = this.listeActionD.filter((actionD) => {
      return (
        listeSelectedAvtActionD_dateStr.indexOf(
          ';' + this.dateService.setFormatDate(actionD.avtActionD_date) + ';'
        ) >= 0
      );
    });
    var listeWewActionD = [];
    var avtAction_dateDeb = this.dateService.setFormatDateRechercheServer(
      this.dateService.setToDate(this.action.avtAction_dateDeb)
    );
    var avtAction_dateFin = this.dateService.setFormatDateRechercheServer(
      this.dateService.setToDate(this.action.avtAction_dateFin)
    );
    var listePerso_Marticule = listeactionDToDuplicate
      .map((day) => {
        return day.Perso_Matricule;
      })
      .reduce((a, b) => {
        return a + ';' + b;
      });
    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=avtActionDP&param=' +
          avtAction_dateDeb +
          ',' +
          avtAction_dateFin +
          ',' +
          listePerso_Marticule
      )
      .subscribe((actionDColl) => {
        actionDColl.forEach((actiond) => {
          actiond.avtActionD_date = this.dateService.setToFormatDateServerStr(
            this.dateService.setToDate(actiond.avtActionD_date)
          );
        });
        listeactionDToDuplicate.forEach(async (actionDToDuplicate) => {
          var newActionD = JSON.parse(JSON.stringify(actionDToDuplicate));
          var date = this.getPremierDateDuplication(
            new Date(newActionD.avtActionD_date)
          );
          do {
            newActionD.U_timestamp = null;
            newActionD.avtActionD_date =
              this.dateService.setToFormatDateServerStr(date);
            if (this.dateInclueDanssIntervalDuplication(date)) {
              var listeActionDColl = actionDColl.filter((a) => {
                return a.Perso_Matricule == newActionD.Perso_Matricule;
              });

              var listeEventColl = this.createEventsCalandar(
                listeActionDColl,
                false,
                'rgb(250, 239, 89)',
                'white'
              );
              var newEvent = this.createEventsCalandar(
                [newActionD],
                false,
                '#000000',
                '#000000'
              );
              // verification existance planification en conflie
              if (
                !this.actionsService.listeEventInclueInListeEvent(
                  listeEventColl,
                  newEvent,
                  false
                )
              ) {
                listeWewActionD.push(JSON.parse(JSON.stringify(newActionD)));
              }
            }
            date.setDate(date.getDate() + 7);
          } while (
            date.getTime() <
            this.dateService.setToDate(this.action.avtAction_dateFin).getTime()
          );
        });
        if (listeWewActionD.length > 0) {
          this.closeWindowsDiplication();
          this.enregistrerActionDForActionPrestation(listeWewActionD);
        }
      });
  }
  showFrmDuplicationActionPrestatonCalmois(
    frmDuplicationActionPrestatonCalmois
  ) {
    var listeSelectedAvtActionD_date = this.calmoisComponens.selectedDays.map(
      (day) => {
        return day.strDate;
      }
    );
    var listeSelectedAvtActionD_dateStr =
      ';' +
      listeSelectedAvtActionD_date.reduce((a, b) => {
        return a + ';' + b;
      }) +
      ';';
    var listeactionDToDuplicate = this.listeActionD.filter((actionD) => {
      return (
        listeSelectedAvtActionD_dateStr.indexOf(
          ';' + this.dateService.setFormatDate(actionD.avtActionD_date) + ';'
        ) >= 0
      );
    });

    if (listeactionDToDuplicate.length > 0) {
      var selectionValide = true;
      var weekFirstDay = this.dateService.getWeekNumber(
        new Date(listeactionDToDuplicate[0].avtActionD_date)
      );
      listeactionDToDuplicate.forEach((actionD) => {
        if (
          this.dateService.getWeekNumber(new Date(actionD.avtActionD_date)) !=
          weekFirstDay
        )
          selectionValide = false;
      });
      if (selectionValide)
        this.generalService.dialog.open(frmDuplicationActionPrestatonCalmois);
      else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner actions de la même semaine',
          false
        );
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une action à dupliquer',
        false
      );
  }
  //-----------------action calendar-----------------
  actionCalendar(event) {
    if (!this.disabled)
      switch (event.acton) {
        case 'dateClick':
          break;
        case 'select':
          this.selectDate(event);
          break;
        case 'dayRender':
          this.dayRender(event);
          break;
        case 'eventRender':
          this.eventRender(event);
          break;
        case 'eventClick':
          this.eventClick(event);
          break;
        case 'eventDragStart':
          break;
        case 'eventDragStop':
          this.eventDragStop(event);
          break;
        case 'eventResize':
          this.eventResize(event);
          break;
        case 'eventResizeStart':
          this.eventResizeStart(event);
          break;
        case 'eventMouseEnter':
          this.eventMouseEnter(event);
          break;
        case 'eventMouseLeave':
          this.eventMouseLeave(event);
          break;
      }
  }
  actionCalendar2(event) {
    switch (event.acton) {
      case 'eventDragStop':
        this.eventDragStop2(event);
        break;
      case 'eventResize':
        this.eventResize2(event);
        break;
      case 'eventResizeStart':
        this.eventResizeStart(event);
        break;
      case 'eventClick':
        this.eventClickForUpdate(event);
        break;
    }
  }
  typePresenceActionChangeForUpdate() {
    if (this.selctedEventForUpdate) {
      this.selctedEventForUpdate.event.event.extendedProps.actionD.avtActionType_Id =
        this.selectedTypePresenceForUpdate;
    }
  }
  enregistrerPlanificationForUpdate() {
    if (this.generalService.isNotEmpty(this.selctedEventForUpdate))
      this.verificationAndSaveEventAfterChange2(
        this.selctedEventForUpdate,
        this.selctedEventForUpdate.event.event
      );
    else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner une action à modifier',
        false
      );
  }
  eventClickForUpdate(event) {
    if (this.selctedEventForUpdate) {
      $(this.selctedEventForUpdate.event.el).css('border-color', '');
    }
    $(event.event.el).css('border-color', 'red');
    $(event.event.el).css('border-style', 'solid');
    this.selctedEventForUpdate = event;
    this.selectedTypePresenceForUpdate =
      event.event.event.extendedProps.actionD.avtActionType_Id;
    //action de prestation
    if (this.typeAction == '2') {
      this.actionDIntitule =
        event.event.event.extendedProps.actionD.avtActionTypeD_Info;
      this.typeActionD =
        event.event.event.extendedProps.actionD.avtActionTypeD_Type;
      if (event.event.event.id.indexOf('PM') >= 0) {
        this.ApMidiTypePresenceChecked = true;
        this.MatinTypePresenceChecked = false;
        this.typePresenceHeureDebPM = this.dateService.setFormaTime(
          event.event.event.extendedProps.actionD.avtActionTypeD_heureDebPM
        );
        this.typePresenceHeureFinPM = this.dateService.setFormaTime(
          event.event.event.extendedProps.actionD.avtActionTypeD_heureFinPM
        );
      } else {
        this.ApMidiTypePresenceChecked = false;
        this.MatinTypePresenceChecked = true;
        this.typePresenceHeureDebAM = this.dateService.setFormaTime(
          event.event.event.extendedProps.actionD.avtActionTypeD_heureDebAM
        );
        this.typePresenceHeureFinAM = this.dateService.setFormaTime(
          event.event.event.extendedProps.actionD.avtActionTypeD_heureFinAM
        );
      }
      this.onMatinTypePresenceChecked();
      this.onApMidiTypePresenceChecked();
      var collaborateur = this.listeCollaborateur.find((coll) => {
        return (
          coll.Perso_Matricule ==
          event.event.event.extendedProps.actionD.Perso_Matricule
        );
      });
      if (collaborateur) {
        this.collaborateurCalendrierActionForUpdateComponent.valueColonneToReturn =
          collaborateur.Perso_Matricule;
        this.collaborateurCalendrierActionForUpdateComponent.parentVal =
          collaborateur.Perso_Nom;
      }
    }
  }
  datePlanifiable(selectDate: Date): boolean {
    var listeDatePlanifiable = this.getListeDatePlanifiable();
    var date = this.dateService.setToFormatDateServerStr(selectDate);
    var findDate = listeDatePlanifiable.find((datePlanifiable) => {
      return datePlanifiable.avtActionTypeD_date == date;
    });
    if (findDate == undefined) return false;
    return true;
  }
  dayRender(event) {
    if (!this.datePlanifiable(event.event.date))
      event.event.el.bgColor = '#e1e1ea';
  }
  eventRender(event) {
    if (
      event.event.event.extendedProps &&
      event.event.event.extendedProps.actionD
    )
      event.event.el.querySelector('.fc-title').innerHTML =
        "<span  id='ev_" +
        event.event.event.extendedProps.actionD.avtActionD_Code +
        "'>" +
        event.event.event.title +
        '</span>';
  }
  selectDate(event) {
    var start = new Date(event.event.start);
    var end = new Date(event.event.end);
    var timeStar = start.getHours() + ':' + start.getMinutes();
    var timeEnd = end.getHours() + ':' + end.getMinutes();
    // si la periode selectionner et planifiable
    if (this.datePlanifiable(start)) {
      //pour que la selection ne deppasse pas la journer actuelle
      if (event.event.start.getDay() != event.event.end.getDay()) {
        event.event.end = new Date(event.event.start);
        event.event.end.setHours(24);
        event.event.end.setMinutes(0);
      }
      //selection dans time debut et time fin AM et PM de ParamHeure
      if (this.selectionTimeDansParamHeure(timeStar, timeEnd)) {
        if (
          !this.actionsService.eventInclueInListeEvent(
            event.calendarComponent.getEvents(),
            event.event
          )
        )
          this.createEventSelection(event.event.start, event.event.end, event);
      }
    } else
      this.generalService.dialogSuccess(
        'Vous ne pouvez pas sélectionner une période non panifiable',
        false
      );
  }
  eventClick(event) {
    if (event.event.event.id.indexOf('#') == 0) {
      var calendar = event.calendarComponent;
      calendar.getEventById(event.event.event.id).remove();
      this.calendarActionComponent.selectedDate =
        this.calendarActionComponent.selectedDate.filter((date) => {
          return date.id != event.event.event.id;
        });
    } else {
      if (
        event.event.event.extendedProps.router != null &&
        event.event.event.extendedProps.router != undefined
      )
        this.router.navigate(event.event.event.url);
      else {
        var fff = $(
          '#ev_' + event.event.event.extendedProps.actionD.avtActionD_Code
        );
        $(
          '#ev_' + event.event.event.extendedProps.actionD.avtActionD_Code
        ).addClass('rectengle-arrendi-2');
        //event.event.event.borderColor = "red"
      }
    }
  }
  annulerModificationEventCalendar(event) {
    this.calendarActionComponent.calendarComponent
      .getEventById(event.event.event.id)
      .setStart(event.event.event.start);
    this.calendarActionComponent.calendarComponent
      .getEventById(event.event.event.id)
      .setEnd(event.event.event.end);
  }
  annulerModificationEventCalendar2(event) {
    this.calendarModificationActionComponent.calendarComponent
      .getEventById(event.event.event.id)
      .setStart(event.event.event.start);
    this.calendarModificationActionComponent.calendarComponent
      .getEventById(event.event.event.id)
      .setEnd(event.event.event.end);
  }
  eventDragStop(event) {
    setTimeout(() => {
      this.exist = false;
      var calendar = event.calendarComponent;
      var newEvent = calendar.getEventById(event.event.event.id);
      var listeEvent = event.calendarComponent.getEvents();
      this.verificationAndSaveEventAfterChange(event, newEvent, listeEvent);
    }, 100);
  }
  eventDragStop2(event) {
    setTimeout(() => {
      this.exist = false;
      var calendar = event.calendarComponent;
      var newEvent = calendar.getEventById(event.event.event.id);
      this.verificationAndSaveEventAfterChange2(event, newEvent);
    }, 100);
  }

  eventResize(event) {
    this.exist = false;
    setTimeout(() => {
      var calendar = event.calendarComponent;
      var newEvent = calendar.getEventById(event.event.event.id);
      var listeEvent = event.calendarComponent.getEvents();
      this.verificationAndSaveEventAfterChange(
        this.eventAfterResize,
        newEvent,
        listeEvent
      );
    }, 100);
  }
  eventResize2(event) {
    this.exist = false;
    setTimeout(() => {
      var calendar = event.calendarComponent;
      var newEvent = calendar.getEventById(event.event.event.id);
      this.verificationAndSaveEventAfterChange2(
        this.eventAfterResize,
        newEvent
      );
    }, 100);
  }
  eventResizeStart(event) {
    var e = event.event.event;
    this.eventAfterResize = this.generalService.clone({
      event: {
        event: {
          id: e.id,
          start: e.start,
          end: e.end,
          extendedProps: e.extendedProps,
          title: e.title,
          url: e.url,
          backgroundColor: e.backgroundColor,
          borderColor: e.borderColor,
        },
      },
    });
  }

  eventMouseEnter(event) {
    this.selectedEventForRightClickEvent = event.event.event;
  }
  eventMouseLeave(event) {
    if (this.canSetSelectedEventForRightClickToNull) {
      this.selectedEventForRightClickEvent = null;
    }
  }
  //-----------------fin action calendar-----------------
}
